{
  "updatedAt": "2026-10-15T16:36:16.758Z",
  "personIds": ["422", "489", "485", "458", "74734"],
  "publications": [
    {
      "id": 23001,
      "title": "LLM-Assisted Ontology Evolution for Hazards and Physical Threats — Continuous Identification and Integration of Emerging Threat Concepts",
      "authors": "Servando V. Pizarro Martinez, Timon T. Aldenhoff, Arnold F. Arz von Straussenburg, Dennis M. Riehle",
      "authorNames": [
        "Martinez, Servando V. Pizarro",
        "Aldenhoff, Timon T.",
        "Arz von Straussenburg, Arnold F.",
        "Riehle, Dennis M."
      ],
      "year": "2027",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Conceptual Modeling : 45th International Conference, ER 2026, St. John's, NL, Canada, October 5–8, 2026 : Proceedings",
      "publisher": "Springer Nature Switzerland",
      "pages": "325-341",
      "peerReviewed": "ja",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-032-40795-5_19",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-032-40795-5_19",
      "fullTextUrl": null,
      "detailPath": "/publications/23001-llm-assisted-ontology-evolution-for-hazards-and-physical-threats-continuous-identification-and-integration-of-emerging-threat-concepts",
      "apa7": "Martinez, S. V. P., Aldenhoff, T. T., Arz von Straussenburg, A. F., & Riehle, D. M. (2027). LLM-Assisted Ontology Evolution for Hazards and Physical Threats — Continuous Identification and Integration of Emerging Threat Concepts. In A. Bernasconi, M. Indulska, S. Ram, J. Evermann, & J. Parsons (Eds.), Conceptual Modeling : 45th International Conference, ER 2026, St. John’s, NL, Canada, October 5–8, 2026 : Proceedings (pp. 325–341). Springer Nature Switzerland. https://doi.org/10.1007/978-3-032-40795-5_19",
      "bibtex": "@inproceedings{Martinez2027LLM,\n\taddress = {Cham},\n\tauthor = {Martinez, Servando V. Pizarro and Aldenhoff, Timon T. and Arz von Straussenburg, Arnold F. and Riehle, Dennis M.},\n\tbooktitle = {Conceptual {Modeling} : 45th {International} {Conference}, {ER} 2026, {St}. {John}'s, {NL}, {Canada}, {October} 5--8, 2026 : Proceedings},\n\tdoi = {10.1007/978-3-032-40795-5_19},\n\teditor = {Bernasconi, Anna and Indulska, Marta and Ram, Sudha and Evermann, Joerg and Parsons, Jeffrey},\n\tyear = {2027},\n\tpages = {325--341},\n\torganization = {Springer Nature Switzerland},\n\ttitle = {LLM-{Assisted} {Ontology} {Evolution} for {Hazards} and {Physical} {Threats} --- {Continuous} {Identification} and {Integration} of {Emerging} {Threat} {Concepts}},\n\turl = {https://doi.org/10.1007/978-3-032-40795-5_19},\n}"
    },
    {
      "id": 21703,
      "title": "Data Trusts for Smart Cities: A Business Model",
      "authors": "David Acev, Timon T. Aldenhoff, Sankalp Biyani, Dennis M. Riehle, Maria A. Wimmer",
      "authorNames": [
        "Acev, David",
        "Aldenhoff, Timon T.",
        "Biyani, Sankalp",
        "Riehle, Dennis M.",
        "Wimmer, Maria A."
      ],
      "year": "2026",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "CENTERIS 2025 - International Conference on ENTERprise Information Systems / ProjMAN - International Conference on Project MANagement / HCist - International Conference on Health and Social Care Information Systems and Technologies",
      "publisher": "Elsevier",
      "pages": "227-236",
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1016/j.procs.2026.02.458",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1016/j.procs.2026.02.458",
      "fullTextUrl": null,
      "detailPath": "/publications/21703-data-trusts-for-smart-cities-a-business-model",
      "apa7": "Acev, D., Aldenhoff, T. T., Biyani, S., Riehle, D. M., & Wimmer, M. A. (2026). Data Trusts for Smart Cities: A Business Model. In R. P. C. L. Rijo, R. Martinho, & M. Cruz-Cunha (Eds.), CENTERIS 2025 - International Conference on ENTERprise Information Systems / ProjMAN - International Conference on Project MANagement / HCist - International Conference on Health and Social Care Information Systems and Technologies (pp. 227–236). Elsevier. https://doi.org/10.1016/j.procs.2026.02.458",
      "bibtex": "@inproceedings{Acev2026Data,\n\taddress = {Amsterdam},\n\tauthor = {Acev, David and Aldenhoff, Timon T. and Biyani, Sankalp and Riehle, Dennis M. and Wimmer, Maria A.},\n\tbooktitle = {CENTERIS 2025 - {International} {Conference} on {ENTERprise} {Information} {Systems} / {ProjMAN} - {International} {Conference} on {Project} {MANagement} / {HCist} - {International} {Conference} on {Health} and {Social} {Care} {Information} {Systems} and {Technologies}},\n\tdoi = {10.1016/j.procs.2026.02.458},\n\teditor = {Rijo, Rui Pedro Charters Lopes and Martinho, Ricardo and Cruz-Cunha, Manuela},\n\tyear = {2026},\n\tpages = {227--236},\n\torganization = {Elsevier},\n\ttitle = {Data {Trusts} for {Smart} {Cities}: A {Business} {Model}},\n\turl = {https://doi.org/10.1016/j.procs.2026.02.458},\n}"
    },
    {
      "id": 21882,
      "title": "Integrating an Intelligent Tutoring Chatbot into\nHigher Education: The Case of Teaching Declarative Process Modeling through Generative AI",
      "authors": "Sabine Nagel, Anna Wolters, Dennis Riehle, Patrick Delfmann",
      "authorNames": [
        "Nagel, Sabine",
        "Wolters, Anna",
        "Riehle, Dennis",
        "Delfmann, Patrick"
      ],
      "year": "2026",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceedings of the 59th Hawaii International Conference on System Sciences",
      "publisher": "ScholarSpace",
      "pages": "4976-4985",
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://hdl.handle.net/10125/111994",
          "kind": "full-text"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://hdl.handle.net/10125/111994",
      "detailPath": "/publications/21882-integrating-an-intelligent-tutoring-chatbot-into-higher-education-the-case-of-teaching-declarative-process-modeling-through-generative-ai",
      "apa7": "Nagel, S., Wolters, A., Riehle, D., & Delfmann, P. (2026). Integrating an Intelligent Tutoring Chatbot into\nHigher Education: The Case of Teaching Declarative Process Modeling through Generative AI. In T. X. Bui (Ed.), Proceedings of the 59th Hawaii International Conference on System Sciences (pp. 4976–4985). ScholarSpace. https://hdl.handle.net/10125/111994",
      "bibtex": "@inproceedings{Nagel2026Integrating,\n\taddress = {University of Hawaii at M{\\= a}noa, Hawaii},\n\tauthor = {Nagel, Sabine and Wolters, Anna and Riehle, Dennis and Delfmann, Patrick},\n\tbooktitle = {Proceedings of the 59th {Hawaii} {International} {Conference} on {System} {Sciences}},\n\teditor = {Bui, Tung X.},\n\tyear = {2026},\n\tpages = {4976--4985},\n\torganization = {ScholarSpace},\n\ttitle = {Integrating an {Intelligent} {Tutoring} {Chatbot} into\n{Higher} {Education}: The {Case} of {Teaching} {Declarative} {Process} {Modeling} through {Generative} {AI}},\n\turl = {https://hdl.handle.net/10125/111994},\n}"
    },
    {
      "id": 22165,
      "title": "Edge AI in the social internet of things : a systematic review of trends and research needs",
      "authors": "Dennis M. Riehle, Arnold F. Arz von Straussenburg, Mevludin Blazevic",
      "authorNames": [
        "Riehle, Dennis M.",
        "Arz von Straussenburg, Arnold F.",
        "Blazevic, Mevludin"
      ],
      "year": "2026",
      "type": "Journalartikel",
      "language": "en",
      "venue": "Management Review Quarterly",
      "publisher": null,
      "pages": null,
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": "Edge-AI refers to the execution of AI tasks, such as inference and\nlimited model training on edge devices located near data sources,\nreducing latency and network congestion. The SIoT applies social\nnetworking principles to IoT systems, enabling smart devices to\nautonomously form relationships for service discovery and collaboration.\nIntegrating Edge-AI into SIoT enables decentralized, intelligent\ndecision-making and real-time data processing. This paper explores the\nbroad field SIoT to derive relevant studies that constitute the research\nfield of Edge-AI in SIoT. SIoT-related papers from multiple academic\ndatabases over the past decade are systematically collected, classified\nand synthesized into a concept matrix, according to research\ntrajectories in SIoT. Despite the enormous research already conducted in\nSIoT, research needs remain for Edge-AI enabled SIoT, particularly in\ndeveloping novel use cases and real-world applications, but also\ncreating new approaches for training AI models on edge devices. These\ngaps indicate opportunities for advancing SIoT through specialized\nEdge-AI concepts. This study concludes by proposing research needs for\nfuture investigation and can be seen as a roadmap for researchers to\npursue advancements in Edge-AI enabled SIoT applications. Furthermore,\nwe complemented the Preferred Reporting Items for Systematic Reviews and\nMeta-analyses (PRISMA)-based search with an inductive coding protocol:\ntitles, abstracts, and, where required, full texts were open coded using\nsalient keywords (e.g., federated learning, vehicular edge, trust,\nhuman-in-the-loop), refined via comparison to derive the twelve streams\nand populate the concept matrix; two researchers coded a sample, and\nreconciled disagreements.",
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/s11301-026-00588-y",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/s11301-026-00588-y",
      "fullTextUrl": null,
      "detailPath": "/publications/22165-edge-ai-in-the-social-internet-of-things-a-systematic-review-of-trends-and-research-needs",
      "apa7": "Riehle, D. M., Arz von Straussenburg, A. F., & Blazevic, M. (2026). Edge AI in the social internet of things : a systematic review of trends and research needs. Management Review Quarterly. https://doi.org/10.1007/s11301-026-00588-y",
      "bibtex": "@article{Riehle2026Edge,\n\tauthor = {Riehle, Dennis M. and Arz von Straussenburg, Arnold F. and Blazevic, Mevludin},\n\tjournal = {Management Review Quarterly},\n\tdoi = {10.1007/s11301-026-00588-y},\n\tyear = {2026},\n\ttitle = {Edge {AI} in the social internet of things : a systematic review of trends and research needs},\n\turl = {https://doi.org/10.1007/s11301-026-00588-y},\n\thowpublished = {https://doi.org/10.1007/s11301-026-00588-y},\n}"
    },
    {
      "id": 22294,
      "title": "Designing IoT Data Platforms: A Structured Problem Analysis and Requirements Derivation",
      "authors": "Timon T. Aldenhoff, Dennis M. Riehle",
      "authorNames": ["Aldenhoff, Timon T.", "Riehle, Dennis M."],
      "year": "2026",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "PACIS 2026 Proceedings",
      "publisher": "Association for Information Systems (AIS)",
      "pages": null,
      "peerReviewed": "ja",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://aisel.aisnet.org/pacis2026/iot_smartcity/iot_smartcity/5/",
          "kind": "full-text"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://aisel.aisnet.org/pacis2026/iot_smartcity/iot_smartcity/5/",
      "detailPath": "/publications/22294-designing-iot-data-platforms-a-structured-problem-analysis-and-requirements-derivation",
      "apa7": "Aldenhoff, T. T., & Riehle, D. M. (2026). Designing IoT Data Platforms: A Structured Problem Analysis and Requirements Derivation. PACIS 2026 Proceedings. https://aisel.aisnet.org/pacis2026/iot_smartcity/iot_smartcity/5/",
      "bibtex": "@inproceedings{Aldenhoff2026Designing,\n\taddress = {Atlanta, Georgia},\n\tauthor = {Aldenhoff, Timon T. and Riehle, Dennis M.},\n\tbooktitle = {PACIS 2026 {Proceedings}},\n\tyear = {2026},\n\torganization = {Association for Information Systems (AIS)},\n\ttitle = {Designing {IoT} {Data} {Platforms}: A {Structured} {Problem} {Analysis} and {Requirements} {Derivation}},\n\turl = {https://aisel.aisnet.org/pacis2026/iot_smartcity/iot_smartcity/5/},\n}"
    },
    {
      "id": 22296,
      "title": "A Unified Definition of Data Trusts: Roles, Comparative Positioning, and Typology",
      "authors": "Timon T. Aldenhoff, Florian Rieder, David Acev, Sankalp Biyani, Maria A. Wimmer, Dennis M. Riehle",
      "authorNames": [
        "Aldenhoff, Timon T.",
        "Rieder, Florian",
        "Acev, David",
        "Biyani, Sankalp",
        "Wimmer, Maria A.",
        "Riehle, Dennis M."
      ],
      "year": "2026",
      "type": "Journalartikel",
      "language": "en",
      "venue": "Information Systems and e-Business Management",
      "publisher": null,
      "pages": null,
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": "In the evolving digital economy, the challenge of sharing data while ensuring data sovereignty has become increasingly critical. Data trusts have been proposed as a governance model built around independent, fiduciary stewardship of data exchange between providers and consumers. Despite the concept's potential, research in this domain remains nascent and fragmented across disciplines. Through a structured, topic-centered literature review, we address three research questions on the conceptualization of data trusts, the roles within the ecosystem, and outstanding research gaps. Our key contributions are threefold. First, we conceptualize data trusts through a consolidated definition, position them among adjacent data intermediaries, and derive a typology of four archetypes along primary objective and locus of governance authority. Second, we consolidate the fragmented role vocabulary into a minimal five-role model. Third, we propose a theory-informed research agenda that identifies nine gap categories and outlines directions for future work.",
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/s10257-026-00732-x",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/s10257-026-00732-x",
      "fullTextUrl": null,
      "detailPath": "/publications/22296-a-unified-definition-of-data-trusts-roles-comparative-positioning-and-typology",
      "apa7": "Aldenhoff, T. T., Rieder, F., Acev, D., Biyani, S., Wimmer, M. A., & Riehle, D. M. (2026). A Unified Definition of Data Trusts: Roles, Comparative Positioning, and Typology. Information Systems and E-Business Management. https://doi.org/10.1007/s10257-026-00732-x",
      "bibtex": "@article{Aldenhoff2026Unified,\n\tauthor = {Aldenhoff, Timon T. and Rieder, Florian and Acev, David and Biyani, Sankalp and Wimmer, Maria A. and Riehle, Dennis M.},\n\tjournal = {Information Systems and e-Business Management},\n\tdoi = {10.1007/s10257-026-00732-x},\n\tyear = {2026},\n\ttitle = {A {Unified} {Definition} of {Data} {Trusts}: Roles, {Comparative} {Positioning}, and {Typology}},\n\turl = {https://doi.org/10.1007/s10257-026-00732-x},\n\thowpublished = {https://doi.org/10.1007/s10257-026-00732-x},\n}"
    },
    {
      "id": 22316,
      "title": "Authentic Learning by Design: Meta-Requirements for AI Support for Students and Educators",
      "authors": "Anna Wolters, Gregor Kipping, Sofie Wass, Michael Gau, Dennis Riehle, Leona Chandra Kruse",
      "authorNames": [
        "Wolters, Anna",
        "Kipping, Gregor",
        "Wass, Sofie",
        "Gau, Michael",
        "Riehle, Dennis",
        "Kruse, Leona Chandra"
      ],
      "year": "2026",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Design for Better Futures: Beyond the Science of the Artificial : Completed Research : 21st International Conference on Design Science Research in Information Systems and Technology, DESRIST 2026 Münster, Germany, June 8–10, 2026 : Proceedings, Part II",
      "publisher": "Springer",
      "pages": "227-245",
      "peerReviewed": "ja",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-032-28313-9_13",
          "kind": "doi"
        },
        {
          "label": "OpenAlex ID",
          "url": "https://openalex.org/W7162873659",
          "kind": "external"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-032-28313-9_13",
      "fullTextUrl": null,
      "detailPath": "/publications/22316-authentic-learning-by-design-meta-requirements-for-ai-support-for-students-and-educators",
      "apa7": "Wolters, A., Kipping, G., Wass, S., Gau, M., Riehle, D., & Kruse, L. C. (2026). Authentic Learning by Design: Meta-Requirements for AI Support for Students and Educators. In J. vom Brocke, L. Chandra Kruse, A. Hevner, M. Rosemann, M. Chiarini Tremblay, & R. Winter (Eds.), Design for Better Futures: Beyond the Science of the Artificial : Completed Research : 21st International Conference on Design Science Research in Information Systems and Technology, DESRIST 2026 Münster, Germany, June 8–10, 2026 : Proceedings, Part II (pp. 227–245). Springer. https://doi.org/10.1007/978-3-032-28313-9_13",
      "bibtex": "@inproceedings{Wolters2026Authentic,\n\taddress = {Cham},\n\tauthor = {Wolters, Anna and Kipping, Gregor and Wass, Sofie and Gau, Michael and Riehle, Dennis and Kruse, Leona Chandra},\n\tbooktitle = {Design for {Better} {Futures}: Beyond the {Science} of the {Artificial} : Completed {Research} : 21st {International} {Conference} on {Design} {Science} {Research} in {Information} {Systems} and {Technology}, {DESRIST} 2026 {M}{\\\" u}nster, {Germany}, {June} 8--10, 2026 : Proceedings, {Part} {II}},\n\tdoi = {10.1007/978-3-032-28313-9_13},\n\teditor = {vom Brocke, Jan and Chandra Kruse, Leona and Hevner, Alan and Rosemann, Michael and Chiarini Tremblay, Monica and Winter, Robert},\n\tyear = {2026},\n\tpages = {227--245},\n\torganization = {Springer},\n\ttitle = {Authentic {Learning} by {Design}: Meta-{Requirements} for {AI} {Support} for {Students} and {Educators}},\n\turl = {https://doi.org/10.1007/978-3-032-28313-9_13},\n}"
    },
    {
      "id": 22573,
      "title": "When Models Meet Sensors – A Structured Review and IS Research Agenda for Generative AI-Enabled IoT Artifacts",
      "authors": "Arnold F. Arz von Straussenburg, Dennis Riehle",
      "authorNames": ["Arz von Straussenburg, Arnold F.", "Riehle, Dennis"],
      "year": "2026",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "PACIS 2026 Proceedings",
      "publisher": "Association for Information Systems (AIS)",
      "pages": null,
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https:// https://aisel.aisnet.org/pacis2026/iot_smartcity/iot_smartcity/11",
          "kind": "full-text"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https:// https://aisel.aisnet.org/pacis2026/iot_smartcity/iot_smartcity/11",
      "detailPath": "/publications/22573-when-models-meet-sensors-a-structured-review-and-is-research-agenda-for-generative-ai-enabled-iot-artifacts",
      "apa7": "Arz von Straussenburg, A. F., & Riehle, D. (2026). When Models Meet Sensors – A Structured Review and IS Research Agenda for Generative AI-Enabled IoT Artifacts. PACIS 2026 Proceedings. https:// https://aisel.aisnet.org/pacis2026/iot_smartcity/iot_smartcity/11",
      "bibtex": "@inproceedings{Arz2026When,\n\taddress = {Atlanta, Georgia},\n\tauthor = {Arz von Straussenburg, Arnold F. and Riehle, Dennis},\n\tbooktitle = {PACIS 2026 {Proceedings}},\n\tyear = {2026},\n\torganization = {Association for Information Systems (AIS)},\n\ttitle = {When {Models} {Meet} {Sensors} -- {A} {Structured} {Review} and {IS} {Research} {Agenda} for {Generative} {AI}-{Enabled} {IoT} {Artifacts}},\n\turl = {https:// https://aisel.aisnet.org/pacis2026/iot_smartcity/iot_smartcity/11},\n}"
    },
    {
      "id": 22578,
      "title": "Schlussbericht zum Forschungsprojekt KOOP-DAS : Aufbau einer Kooperation zwischen dem DTM EG-DAS und der Datenrauminitiative Südwestcluster im Bereich Smart Campus und Smart City Data, sowie dem DIN zur Erarbeitung einer DIN SPEC für Datentreuhandschaften (KOOP-DAS)",
      "authors": "Maria A. Wimmer, Dennis M. Riehle, Marius Henkel, Florian Rieder, Timon T. Aldenhoff, Jan Klei",
      "authorNames": [
        "Wimmer, Maria A.",
        "Riehle, Dennis M.",
        "Henkel, Marius",
        "Rieder, Florian",
        "Aldenhoff, Timon T.",
        "Klei, Jan"
      ],
      "year": "2026",
      "type": "Arbeitspapier/Forschungsbericht",
      "language": "en",
      "venue": null,
      "publisher": "Technische Informationsbibliothek",
      "pages": null,
      "peerReviewed": null,
      "access": "Open Access",
      "abstract": "Daten\nsind das Öl unserer digitalen Gesellschaft. An unterschiedlichsten\nStellen werden Daten gesammelt, ausgewertet und zu Mehrwertdiensten\ngenutzt. Insbesondere in digitalen Ökosystemen wie etwa in Smart City\nProjekten, in denen verschiedene Anwendungen der Künstlichen Intelligenz\n(KI) zum Einsatz kommen, sind qualitätsgesicherte und standardisierte\nDaten zentral. In den letzten Jahren haben sich daher innovative\nDatenökosysteme als ein zentrales Element moderner digitaler\nWertschöpfung entwickelt. Insbesondere im kommunalen Kontext gewinnen\ndigitale Datenplattformen und Datenintermediäre zunehmend an Bedeutung,\num Daten zwischen verschiedenen Akteuren im Smart City Kontext\nauszutauschen, etwa für Umweltmonitoring, Verkehrssteuerung, Monitoring\nöffentlicher Infrastruktur oder datengetriebener Zivilschutz. Das\nPotenzial dieser Daten für datenbasierte Entscheidungen, innovative\nAnwendungen und gemeinwohlorientierte Mehrwertdienste kann jedoch nur\nausgeschöpft werden, wenn Daten sicher, nachvollziehbar und\ninteroperabel zwischen unterschiedlichen Plattformen und Organisationen\nausgetauscht werden können. In der Praxis bestehen hierfür Hürden durch\nuneinheitliche Schnittstellen, unterschiedliche Datenformate und\nDatenmodelle, heterogene Metadatenstrukturen sowie nicht durchgängig\nstandardisierte Anforderungen an Datenqualität, Zugriffsrechte,\nNutzungsbedingungen udgl.\n\nDas Forschungsprojekt KOOP-DAS adressierte diese Herausforderungen\nund hatte das Ziel, die Interoperabilität zwischen der\nDatentreuhandplattform EG-DAS der Universität Koblenz und der Urban Data\nSpace Platform (UDSP) der HYPERTEGRITY AG (HTAG) im Kontext des\n\"Südwest-Clusters\" zu erproben. Dabei wurden die Datenaustauschprozesse\nzwischen den Datenplattformen analysiert, speziﬁziert, und mithilfe der\nPrototypen evaluiert. Daraus resultierten folgende zentrale Ergebnisse\nfür den interoperablen Datenaustausch zwischen Datentreuhandplattformen\nund Smart-City-Datenplattformen:\n\n- Schnittstellenspeziﬁkation für den Datenaustausch zwischen EG-DAS\nund der UDSP, bestehend aus Basisspeziﬁkation und domänenspeziﬁschen\nProﬁlen\n\n- Aufbau und Erprobung der Schnittstellenspeziﬁkation zwischen der\nUDSP und dem EG-DAS DTM in einer Testumgebung (\"Sandbox\") entlang der\nDatendomänen Sensorik- bzw. Wetterdaten, 3D-Daten, Bilddaten, und\n5G-Messdaten, sowie Evaluation des interoperablen Datenaustauschs\nentlang von technischer und semantischer Interoperabilität, Metadaten,\nDatensouveränität, Datenqualität sowie Sicherheits- und\nVertrauensaspekten mithilfe einer Evaluationsmatrix\n\n- Identiﬁkation von Weiterentwicklungsbedarfen für einheitliche\nMetadatenproﬁle, maschinenlesbare Policy- Beschreibungen, Datenherkunft,\nDatenqualität, Datengovernance und domänenspeziﬁschen Datenmodellen\n\n- Initialisierung der DIN SPEC für DTM und Überführung von Projekterkenntnissen in die Ausarbeitung der DIN SPEC 91677\n\n- Kommunikation der Projektergebnisse in 6 wissenschaftlichen Publikationen und auf der Webseite",
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.34657/39737",
          "kind": "doi"
        },
        {
          "label": "Handle",
          "url": "http://hdl.handle.net/oa.tib.eu/renate/handle/123456789/40669",
          "kind": "external"
        },
        {
          "label": "OpenAlex ID",
          "url": "https://openalex.org/W7170069775",
          "kind": "external"
        }
      ],
      "doiUrl": "https://doi.org/10.34657/39737",
      "fullTextUrl": null,
      "detailPath": "/publications/22578-schlussbericht-zum-forschungsprojekt-koop-das-aufbau-einer-kooperation-zwischen-dem-dtm-eg-das-und-der-datenrauminitiative-s-dwestcluster-im-bereich-smart-campus-und-smart-city-data-sowie-dem-din-zur-erarbeitung-einer-din-spec-f-r-datentreuhandschaften-koop-das",
      "apa7": "Wimmer, M. A., Riehle, D. M., Henkel, M., Rieder, F., Aldenhoff, T. T., & Klei, J. (2026). Schlussbericht zum Forschungsprojekt KOOP-DAS : Aufbau einer Kooperation zwischen dem DTM EG-DAS und der Datenrauminitiative Südwestcluster im Bereich Smart Campus und Smart City Data, sowie dem DIN zur Erarbeitung einer DIN SPEC für Datentreuhandschaften (KOOP-DAS). Technische Informationsbibliothek. https://doi.org/10.34657/39737",
      "bibtex": "@misc{Wimmer2026Schlussbericht,\n\taddress = {Hannover},\n\tauthor = {Wimmer, Maria A. and Riehle, Dennis M. and Henkel, Marius and Rieder, Florian and Aldenhoff, Timon T. and Klei, Jan},\n\tdoi = {10.34657/39737},\n\tyear = {2026},\n\tpublisher = {Technische Informationsbibliothek},\n\ttitle = {Schlussbericht zum {Forschungsprojekt} {KOOP}-{DAS} : Aufbau einer {Kooperation} zwischen dem {DTM} {EG}-{DAS} und der {Datenrauminitiative} {S}{\\\" u}dwestcluster im {Bereich} {Smart} {Campus} und {Smart} {City} {Data}, sowie dem {DIN} zur {Erarbeitung} einer {DIN} {SPEC} f{\\\" u}r {Datentreuhandschaften} ({KOOP}-{DAS})},\n\turl = {https://doi.org/10.34657/39737},\n}"
    },
    {
      "id": 22683,
      "title": "The State Of Generative AI Adoption In Higher Education – Administrative Efficiency Over Pedagogical Transformation?",
      "authors": "Anna Wolters, Gregor Kipping, Sofie Wass, Michael Gau, Dennis M. Riehle, Leona Chandra Kruse",
      "authorNames": [
        "Wolters, Anna",
        "Kipping, Gregor",
        "Wass, Sofie",
        "Gau, Michael",
        "Riehle, Dennis M.",
        "Chandra Kruse, Leona"
      ],
      "year": "2026",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "ECIS 2026 Proceedings",
      "publisher": "AIS",
      "pages": null,
      "peerReviewed": "ja",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://aisel.aisnet.org/treos_ecis2026/119",
          "kind": "full-text"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://aisel.aisnet.org/treos_ecis2026/119",
      "detailPath": "/publications/22683-the-state-of-generative-ai-adoption-in-higher-education-administrative-efficiency-over-pedagogical-transformation",
      "apa7": "Wolters, A., Kipping, G., Wass, S., Gau, M., Riehle, D. M., & Chandra Kruse, L. (2026). The State Of Generative AI Adoption In Higher Education – Administrative Efficiency Over Pedagogical Transformation? ECIS 2026 Proceedings. https://aisel.aisnet.org/treos_ecis2026/119",
      "bibtex": "@inproceedings{Wolters2026State,\n\taddress = {Atlanta, GA},\n\tauthor = {Wolters, Anna and Kipping, Gregor and Wass, Sofie and Gau, Michael and Riehle, Dennis M. and Chandra Kruse, Leona},\n\tbooktitle = {ECIS 2026 {Proceedings}},\n\tyear = {2026},\n\torganization = {AIS},\n\ttitle = {The {State} {Of} {Generative} {AI} {Adoption} {In} {Higher} {Education} -- {Administrative} {Efficiency} {Over} {Pedagogical} {Transformation}?},\n\turl = {https://aisel.aisnet.org/treos_ecis2026/119},\n}"
    },
    {
      "id": 22684,
      "title": "Leveraging AI Agents In Design-Based Teaching: Insights From Utilizing Synthetic Users To Design Tool Support For Immigrants",
      "authors": "Gregor Kipping, Sofie Wass, Thorsten Schoormann, Anna Wolters, Michael Gau, Dennis M. Riehle, Leona Chandra Kruse",
      "authorNames": [
        "Kipping, Gregor",
        "Wass, Sofie",
        "Schoormann, Thorsten",
        "Wolters, Anna",
        "Gau, Michael",
        "Riehle, Dennis M.",
        "Chandra Kruse, Leona"
      ],
      "year": "2026",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "ECIS 2026 Proceedings",
      "publisher": "AIS",
      "pages": null,
      "peerReviewed": "ja",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://aisel.aisnet.org/treos_ecis2026/104/",
          "kind": "full-text"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://aisel.aisnet.org/treos_ecis2026/104/",
      "detailPath": "/publications/22684-leveraging-ai-agents-in-design-based-teaching-insights-from-utilizing-synthetic-users-to-design-tool-support-for-immigrants",
      "apa7": "Kipping, G., Wass, S., Schoormann, T., Wolters, A., Gau, M., Riehle, D. M., & Chandra Kruse, L. (2026). Leveraging AI Agents In Design-Based Teaching: Insights From Utilizing Synthetic Users To Design Tool Support For Immigrants. ECIS 2026 Proceedings. https://aisel.aisnet.org/treos_ecis2026/104/",
      "bibtex": "@inproceedings{Kipping2026Leveraging,\n\taddress = {Atlanta, GA},\n\tauthor = {Kipping, Gregor and Wass, Sofie and Schoormann, Thorsten and Wolters, Anna and Gau, Michael and Riehle, Dennis M. and Chandra Kruse, Leona},\n\tbooktitle = {ECIS 2026 {Proceedings}},\n\tyear = {2026},\n\torganization = {AIS},\n\ttitle = {Leveraging {AI} {Agents} {In} {Design}-{Based} {Teaching}: Insights {From} {Utilizing} {Synthetic} {Users} {To} {Design} {Tool} {Support} {For} {Immigrants}},\n\turl = {https://aisel.aisnet.org/treos_ecis2026/104/},\n}"
    },
    {
      "id": 22736,
      "title": "Entwicklung von Geschäftsmodellen für nachhaltige Datentreuhandplattformen mit offenen Architekturen und Schnittstellen, unter Beibehaltung der Datenhoheit für kleine und mittelständische Unternehmen (EG-DAS) : Sachbericht zum Abschlussnachweis Forschungsprojekt EG-DAS",
      "authors": "Dennis M. Riehle, Maria A. Wimmer, Timon T. Aldenhoff, Florian Rieder, Marc Nilges",
      "authorNames": [
        "Riehle, Dennis M.",
        "Wimmer, Maria A.",
        "Aldenhoff, Timon T.",
        "Rieder, Florian",
        "Nilges, Marc"
      ],
      "year": "2026",
      "type": "Arbeitspapier/Forschungsbericht",
      "language": "de",
      "venue": null,
      "publisher": "Technische Informationsbibliothek (TIB)",
      "pages": null,
      "peerReviewed": null,
      "access": "Open Access",
      "abstract": "Die\nzunehmende Digitalisierung und insbesondere der sinnstiftende Umgang\nmit Daten stellt vor allem kleinere und mittelständische Unternehmen\n(KMU) sowie sonstige wirtschaftliche und nicht-wirtschaftliche\nInstitutionen auf regionaler und kommunaler Ebene vor große\nHerausforderungen, die aus ihren Aktivitäten entstehenden Daten im\neigenen wirtschaftlichen Interesse a) effektiv zu verwalten, b) daraus\nPotentiale und Synergien durch Zugang auch für weitere\n(Wirtschafts-)Akteure zu schaffen, und c) dennoch die Hoheit über diese\nDaten nicht zu verlieren. Die besonderen Herausforderungen für KMUs und\nkleinere Institutionen sind dabei, i) technische, ii) organisatorische,\niii) rechtlich konforme, iv) strategische und v) prozessbezogene\nGrund(infra)strukturen sowie v) weiche Anforderungen - wie die\nerforderlichen Fähigkeiten und Kompetenzen - vorzuhalten, um ein\nvertrauensvolles Datenhandling der vorhandenen Daten zu gewährleisten.\n\nWährend große Tech-Unternehmen wie Google, Facebook oder Amazon\npassende Dateninfrastrukturen als eigene Lösung entwickeln und in-house\nbetreiben, bleiben kleinere Organisationen häufig zurück. Heutige\nDateninfrastrukturen integrieren eine Vielzahl unterschiedlicher\nTechnologien, sowohl Architektur, wie auch Hard- und Software\nbetreffend, sodass der Betrieb einer eigenen Dateninfrastruktur\nausgesprochen komplex ist. Die hierfür notwendigen technologischen\nKompetenzen bringen insbesondere Organisation außerhalb der Tech-Branche\nselten mit. Entsprechend müssen solche Organisationen Dienstleister\nengagieren, welche die notwendige Dateninfrastruktur bereitstellen.\nDerartige Dienstleister verfolgen das Modell der Datentreuhandschaft,\nverwalten die Daten also in Treuhand für das beauftragende Unternehmen.\nDie Datentreuhandschaft ist somit eine Maßnahme, um Datensouveränität zu\nermöglichen und zu fördern.\n\nDas Projektvorhaben EG-DAS zielt daher darauf ab, Geschäftsmodelle\nfür nachhaltige Datentreuhandplattformen mit offenen Architekturen und\nSchnittstellen zu entwickeln. Dabei wird die Erforschung und Entwicklung\nvon sechs praxisrelevanten Bausteinen für Datentreuhandplattformen\nangestrebt:\n\n- ein Geschäftsmodell für Betreiber:innen von\nDatentreuhandplattformen. Das Geschäftsmodell beschreibt die\nwesentlichen wirtschaftlichen Interessen eines Betreibers eines\nDatentreuhandmodells, die Preismodelle und enthaltene Leistungen,\nRahmenbedingungen und Vereinbarungen für die Datentreuhandverwaltung,\ninklusive der DSGVO-konformen Datenhaltung und der Datensouveränität für\ndie Dateneigentümer.\n\n- eine Referenzarchitektur für eine Datentreuhandplattform. Hierbei\nwerden nach dem Konzept einer Enterprise Architecture nach The Open\nGroup Architecture Framework (TOGAF) verschiedene Sichten und\nArchitekuren (Dienstleistung aus Stakeholdersicht, Geschäftsarchitektur,\nDatenarchitektur, Technologiearchitektur) als Referenzarchitektur\nbeschrieben, um die Datentreuhandverwaltung transparent und offen zu\ngestalten. Gleichzeitig werden Schnittstellenspezifikationen für die\nAnbindung der Datentreuhandplattform an Dienste der interessierten\nAkteure (z. B. KMU) bereitgestellt.\n\n- ein feingranulares Rollen- und Rechtekonzept, um den Zugriff auf\ngespeichert Daten zu steuern und zu überwachen, sodass die\nDateneigentümer einen Überblick über Zugriff und Nutzung der eigenen\nDaten haben und somit Maßnahmen zur Vertrauensbildung in\nDatentreuhandplattformen unterstützen.\n\n- Data Governance-Mechanismen fassen schließlich eine Reihe an\nMechanismen zusammen, um Rechtskonformität, Vertrauenswürdigkeit,\nPrivacy und Datensouveränität zu gewährleisten. Der Datenzugriff wird in\nVerbindung mit dem Rollen- und Rechtekonzept (Baustein 3) umgesetzt.\nWeitere Maßnahmen umfassen etwa den Consent (Zustimmung zur\nDatenweitergabe), die Qualitätssicherung der Daten, die Prüfung auf\nRechtskonformität bei der Datenverarbeitung und -weitergabe, sowie\nSchutzmechanismen gegen Missbrauch und Manipulation.\n\n- ein Best-Practice-Guide zum Vertrauensmanagement, welcher die\nFunktionen der Referenzarchitektur, der Schnittstellen, des Rollen- und\nRechtekonzepts sowie der Mechanismen der Data Governance für\nNicht-Expert:innen transparent anhand von Schaubildern, konzeptuellen\nModellen und Checklisten erklärt.\n\n- ein Katalog an Best Practices zur Prozessintegration. Eine Sammlung\nvon Best Practice Beispielen zur Integration von Daten in\nunterschiedlichen Anwendungen und Prozessen soll für nutzende\nOrganisationen beispielhaft erklären, wie die Datentreuhandplattform\nfunktioniert. Der Best Practices Katalog wird entlang der Pilotierung\naufgebaut und zeigt mögliche Umsetzungen auf.",
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.34657/40185",
          "kind": "doi"
        },
        {
          "label": "OpenAlex ID",
          "url": "https://openalex.org/W7204091441",
          "kind": "external"
        }
      ],
      "doiUrl": "https://doi.org/10.34657/40185",
      "fullTextUrl": null,
      "detailPath": "/publications/22736-entwicklung-von-gesch-ftsmodellen-f-r-nachhaltige-datentreuhandplattformen-mit-offenen-architekturen-und-schnittstellen-unter-beibehaltung-der-datenhoheit-f-r-kleine-und-mittelst-ndische-unternehmen-eg-das-sachbericht-zum-abschlussnachweis-forschungsprojekt-eg-das",
      "apa7": "Riehle, D. M., Wimmer, M. A., Aldenhoff, T. T., Rieder, F., & Nilges, M. (2026). Entwicklung von Geschäftsmodellen für nachhaltige Datentreuhandplattformen mit offenen Architekturen und Schnittstellen, unter Beibehaltung der Datenhoheit für kleine und mittelständische Unternehmen (EG-DAS) : Sachbericht zum Abschlussnachweis Forschungsprojekt EG-DAS. Technische Informationsbibliothek (TIB). https://doi.org/10.34657/40185",
      "bibtex": "@misc{Riehle2026Entwicklung,\n\tauthor = {Riehle, Dennis M. and Wimmer, Maria A. and Aldenhoff, Timon T. and Rieder, Florian and Nilges, Marc},\n\tdoi = {10.34657/40185},\n\tyear = {2026},\n\tpublisher = {Technische Informationsbibliothek (TIB)},\n\ttitle = {Entwicklung von {Gesch}{\\\" a}ftsmodellen f{\\\" u}r nachhaltige {Datentreuhandplattformen} mit offenen {Architekturen} und {Schnittstellen}, unter {Beibehaltung} der {Datenhoheit} f{\\\" u}r kleine und mittelst{\\\" a}ndische {Unternehmen} ({EG}-{DAS}) : Sachbericht zum {Abschlussnachweis} {Forschungsprojekt} {EG}-{DAS}},\n\turl = {https://doi.org/10.34657/40185},\n}"
    },
    {
      "id": 23002,
      "title": "Supplementary Dataset: LLM-Assisted Ontology Evolution for Hazards and Physical Threats – Continuous Identification and Integration of Emerging Threat Concepts",
      "authors": "Servando V. Pizarro Martinez, Timon T. Aldenhoff, Arnold F. Arz von Straussenburg, Dennis M. Riehle",
      "authorNames": [
        "Martinez, Servando V. Pizarro",
        "Aldenhoff, Timon T.",
        "Arz von Straussenburg, Arnold F.",
        "Riehle, Dennis M."
      ],
      "year": "2026",
      "type": "Forschungsdaten",
      "language": "en",
      "venue": null,
      "publisher": null,
      "pages": null,
      "peerReviewed": null,
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.5281/zenodo.21594688",
          "kind": "doi"
        },
        {
          "label": "OpenAlex ID",
          "url": "https://openalex.org/W7171331829",
          "kind": "external"
        }
      ],
      "doiUrl": "https://doi.org/10.5281/zenodo.21594688",
      "fullTextUrl": null,
      "detailPath": "/publications/23002-supplementary-dataset-llm-assisted-ontology-evolution-for-hazards-and-physical-threats-continuous-identification-and-integration-of-emerging-threat-concepts",
      "apa7": "Martinez, S. V. P., Aldenhoff, T. T., Arz von Straussenburg, A. F., & Riehle, D. M. (2026). Supplementary Dataset: LLM-Assisted Ontology Evolution for Hazards and Physical Threats – Continuous Identification and Integration of Emerging Threat Concepts. https://doi.org/10.5281/zenodo.21594688",
      "bibtex": "@misc{Martinez2026Supplementary,\n\tauthor = {Martinez, Servando V. Pizarro and Aldenhoff, Timon T. and Arz von Straussenburg, Arnold F. and Riehle, Dennis M.},\n\tdoi = {10.5281/zenodo.21594688},\n\tyear = {2026},\n\ttitle = {Supplementary {Dataset}: LLM-{Assisted} {Ontology} {Evolution} for {Hazards} and {Physical} {Threats} -- {Continuous} {Identification} and {Integration} of {Emerging} {Threat} {Concepts}},\n\turl = {https://doi.org/10.5281/zenodo.21594688},\n\thowpublished = {https://doi.org/10.5281/zenodo.21594688},\n}"
    },
    {
      "id": 19059,
      "title": "Enabling Responsible LLM-Based Grading in Higher Education – Design Guidelines and a Reproducible Data Preparation Pipeline",
      "authors": "Arnold F. Arz von Straussenburg, Anna Wolters, Timon T. Aldenhoff, Dennis M. Riehle",
      "authorNames": [
        "Arz von Straussenburg, Arnold F.",
        "Wolters, Anna",
        "Aldenhoff, Timon T.",
        "Riehle, Dennis M."
      ],
      "year": "2025",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Local Solutions for Global Challenges : 20th International Conference on Design Science Research in Information Systems and Technology, DESRIST 2025, Montego Bay, Jamaica, June 2-4, 2025, Proceedings, Part II",
      "publisher": "Springer Nature Switzerland",
      "pages": "3-20",
      "peerReviewed": "ja",
      "access": "Restricted Access",
      "abstract": "This paper addresses the increasing demand for accurate, fair, and efficient grading of essay-style assessments in higher education by integrating institutional requirements with recent advances in large language models (LLMs). We propose a pipeline emphasizing privacy, explainability, consistency, and fairness. To ensure privacy, the system operates on local servers and employs rigorous anonymization of student data. Grading events integrate task prompts, instructor guidelines, student submissions, grader commentary, and final scores into structured records, enhancing evaluation accuracy and transparency. We detail the development and validation process, fine-tuning two local LLMs using historical course data. Results demonstrate the models’ ability to effectively replicate original grading decisions while safeguarding student data. Additionally, we discuss how this framework aligns with the interests of students, educators, and policymakers. Our approach establishes a foundational methodology for responsibly integrating AI-driven grading into higher education. This contribution fosters trust among stakeholders and sets a clear direction for future implementation and research efforts.",
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-031-93979-2_1",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-031-93979-2_1",
      "fullTextUrl": null,
      "detailPath": "/publications/19059-enabling-responsible-llm-based-grading-in-higher-education-design-guidelines-and-a-reproducible-data-preparation-pipeline",
      "apa7": "Arz von Straussenburg, A. F., Wolters, A., Aldenhoff, T. T., & Riehle, D. M. (2025). Enabling Responsible LLM-Based Grading in Higher Education – Design Guidelines and a Reproducible Data Preparation Pipeline. In S. Chatterjee, J. Brocke, & R. Anderson (Eds.), Local Solutions for Global Challenges : 20th International Conference on Design Science Research in Information Systems and Technology, DESRIST 2025, Montego Bay, Jamaica, June 2-4, 2025, Proceedings, Part II (pp. 3–20). Springer Nature Switzerland. https://doi.org/10.1007/978-3-031-93979-2_1",
      "bibtex": "@inproceedings{Arz2025Enabling,\n\taddress = {Cham},\n\tauthor = {Arz von Straussenburg, Arnold F. and Wolters, Anna and Aldenhoff, Timon T. and Riehle, Dennis M.},\n\tbooktitle = {Local {Solutions} for {Global} {Challenges} : 20th {International} {Conference} on {Design} {Science} {Research} in {Information} {Systems} and {Technology}, {DESRIST} 2025, {Montego} {Bay}, {Jamaica}, {June} 2-4, 2025, {Proceedings}, {Part} {II}},\n\tdoi = {10.1007/978-3-031-93979-2_1},\n\teditor = {Chatterjee, Samir and Brocke, Jan and Anderson, Ricardo},\n\tyear = {2025},\n\tpages = {3--20},\n\torganization = {Springer Nature Switzerland},\n\ttitle = {Enabling {Responsible} {LLM}-{Based} {Grading} in {Higher} {Education} -- {Design} {Guidelines} and a {Reproducible} {Data} {Preparation} {Pipeline}},\n\turl = {https://doi.org/10.1007/978-3-031-93979-2_1},\n}"
    },
    {
      "id": 19061,
      "title": "Designing Grammar-Guided LLM Outputs for Open Data Integration – A DSR Approach to IoT Data Platforms",
      "authors": "Dennis M. Riehle, Arnold F. Arz von Straussenburg, Timon T. Aldenhoff",
      "authorNames": [
        "Riehle, Dennis M.",
        "Arz von Straussenburg, Arnold F.",
        "Aldenhoff, Timon T."
      ],
      "year": "2025",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Local Solutions for Global Challenges : 20th International Conference on Design Science Research in Information Systems and Technology, DESRIST 2025, Montego Bay, Jamaica, June 2-4, 2025, Proceedings, Part I",
      "publisher": "Springer Nature Switzerland",
      "pages": "178-195",
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": "This paper designs and implements an artifact for converting unstructured or semi-structured open data into outputs conforming to the OGC SensorThings API (STA). Motivated by the growing influx of heterogeneous data in Internet-of-Things environments, the study employs an Action Design Research process to apply formalized grammars to Large Language Models (LLMs) to produce valid, STA-compliant JSON documents. Early prototypes using JSON schemas and Pydantic models highlighted the need for stricter control mechanisms to handle real-world open data complexity. Evaluation across multiple open data sources demonstrates the effectiveness of grammar-driven constraints in reducing malformed or incomplete outputs. Three smaller LLMs—Qwen 2.5 Instruct, Llama 3.1 Instruct, and Phi-4—were tested, showing that grammar length and input context can significantly influence output quality and model throughput. The findings underscore the advantages of embedding strict syntax requirements without sacrificing flexibility for diverse use cases. While domain-level validation (e.g., verifying realistic time-series values) remains a future direction, this research confirms the promise of grammar-based generation for streamlining data ingestion in IoT platforms. The approach facilitates more consistent and maintainable pipelines, potentially boosting interoperability and data quality in sensor-driven environments.",
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-031-93976-1_12",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-031-93976-1_12",
      "fullTextUrl": null,
      "detailPath": "/publications/19061-designing-grammar-guided-llm-outputs-for-open-data-integration-a-dsr-approach-to-iot-data-platforms",
      "apa7": "Riehle, D. M., Arz von Straussenburg, A. F., & Aldenhoff, T. T. (2025). Designing Grammar-Guided LLM Outputs for Open Data Integration – A DSR Approach to IoT Data Platforms. In S. Chatterjee, J. Brocke, & R. Anderson (Eds.), Local Solutions for Global Challenges : 20th International Conference on Design Science Research in Information Systems and Technology, DESRIST 2025, Montego Bay, Jamaica, June 2-4, 2025, Proceedings, Part I (pp. 178–195). Springer Nature Switzerland. https://doi.org/10.1007/978-3-031-93976-1_12",
      "bibtex": "@inproceedings{Riehle2025Designing,\n\taddress = {Cham},\n\tauthor = {Riehle, Dennis M. and Arz von Straussenburg, Arnold F. and Aldenhoff, Timon T.},\n\tbooktitle = {Local {Solutions} for {Global} {Challenges} : 20th {International} {Conference} on {Design} {Science} {Research} in {Information} {Systems} and {Technology}, {DESRIST} 2025, {Montego} {Bay}, {Jamaica}, {June} 2-4, 2025, {Proceedings}, {Part} {I}},\n\tdoi = {10.1007/978-3-031-93976-1_12},\n\teditor = {Chatterjee, Samir and Brocke, Jan and Anderson, Ricardo},\n\tyear = {2025},\n\tpages = {178--195},\n\torganization = {Springer Nature Switzerland},\n\ttitle = {Designing {Grammar}-{Guided} {LLM} {Outputs} for {Open} {Data} {Integration} -- {A} {DSR} {Approach} to {IoT} {Data} {Platforms}},\n\turl = {https://doi.org/10.1007/978-3-031-93976-1_12},\n}"
    },
    {
      "id": 19337,
      "title": "SMEs aiming to operate as Data Trusts: A Reference Architecture",
      "authors": "Florian Rieder, Timon Aldenhoff, David Acev, Sankalp Biyani, Dennis M. Riehle, Maria Wimmer",
      "authorNames": [
        "Rieder, Florian",
        "Aldenhoff, Timon",
        "Acev, David",
        "Biyani, Sankalp",
        "Riehle, Dennis M.",
        "Wimmer, Maria"
      ],
      "year": "2025",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "PACIS 2025 Proceedings",
      "publisher": "Association for Information Systems (AIS)",
      "pages": null,
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": "As data has become a critical asset in today’s digital economies, the sharing and reuse of data has received high attention from researchers. New concepts of data intermediaries have evolved, addressing the strategic goal of greater digital sovereignty while ensuring compliance with European legal frameworks. This paper introduces an initial concept for a reference architecture for Data Trusts, which act as intermediaries facilitating secure and trustworthy data stewardship and sharing within relevant ecosystems. Through a structured analysis of existing literature, we identify and evaluate four distinct Data Trust architectures using qualitative and quantitative criteria. Our analysis reveals notable diversity in application domains, core components, and candidate technologies. Building on this, we derive a foundational and overarching schema for developing a holistic, integrated reference architecture. As our research particularly targets SMEs aspiring to establish themselves as Data Trusts, we spot specific challenges and requirements they face in fulfilling this role.",
      "links": [
        {
          "label": "Full text",
          "url": "https://aisel.aisnet.org/pacis2025/dig_plat/di/5/",
          "kind": "full-text"
        },
        {
          "label": "Conference",
          "url": "https://pacis2025.aisconferences.org/",
          "kind": "conference"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://aisel.aisnet.org/pacis2025/dig_plat/di/5/",
      "detailPath": "/publications/19337-smes-aiming-to-operate-as-data-trusts-a-reference-architecture",
      "apa7": "Rieder, F., Aldenhoff, T., Acev, D., Biyani, S., Riehle, D. M., & Wimmer, M. (2025). SMEs aiming to operate as Data Trusts: A Reference Architecture. In M. Myers, R. A. Alias, & W. F. Boh (Eds.), PACIS 2025 Proceedings. Association for Information Systems (AIS). https://aisel.aisnet.org/pacis2025/dig_plat/di/5/",
      "bibtex": "@inproceedings{Rieder2025SMEs,\n\taddress = {Atlanta, Georgia},\n\tauthor = {Rieder, Florian and Aldenhoff, Timon and Acev, David and Biyani, Sankalp and Riehle, Dennis M. and Wimmer, Maria},\n\tbooktitle = {PACIS 2025 {Proceedings}},\n\teditor = {Myers, Michael and Alias, Rose Alinda and Boh, Wai Fong},\n\tyear = {2025},\n\torganization = {Association for Information Systems (AIS)},\n\ttitle = {SMEs aiming to operate as {Data} {Trusts}: A {Reference} {Architecture}},\n\turl = {https://aisel.aisnet.org/pacis2025/dig_plat/di/5/},\n}"
    },
    {
      "id": 19362,
      "title": "Systematic analysis of data governance frameworks and their relevance to data trusts",
      "authors": "David Acev, Sankalp Biyani, Florian Rieder, Timon Aldenhoff, Mevludin Blazevic, Dennis Riehle, Maria A. Wimmer",
      "authorNames": [
        "Acev, David",
        "Biyani, Sankalp",
        "Rieder, Florian",
        "Aldenhoff, Timon",
        "Blazevic, Mevludin",
        "Riehle, Dennis",
        "Wimmer, Maria A."
      ],
      "year": "2025",
      "type": "Journalartikel",
      "language": "en",
      "venue": "Management Review Quarterly",
      "publisher": null,
      "pages": null,
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": "A unified framework outlining the procedures and methods necessary to adhere to data management standards is essential for effective Data Governance. Data Governance Frameworks serve as a guide to secure and trustworthy data exchange between different (legal) entities. Their specific implications differ based on the field they are incorporated in. Thus, to extract their full potential, they need to be suitably designed. However, there is a lack of knowledge in the literature concerning the assets and components of Data Governance Frameworks tailored for data intermediaries, including Data Trusts. Moreover, there is a limited understanding of what crucial components the frameworks consist of and how they can be managed to maximize frameworks’ performance. The level of effectiveness of such frameworks needs to be measured by analyzing the performance of certain assets. These relations between the components and the assets are yet to be thoroughly explored and precisely defined. Establishing a strong link between the components and assets gives an overview to practitioners on how the intended assets can be fulfilled properly with the corresponding component. Therefore, practitioners can tackle the respective management components to achieve the intended trustworthiness in the data trust ecosystem. This study conducts a systematic analysis of existing Data Governance Frameworks, identifying the crucial assets as well as components, and provides a mapping between them. The findings set a base that enables the development of a comprehensive Data Governance Framework tailored specifically for Data Trusts.",
      "links": [
        {
          "label": "Full text",
          "url": "https://link.springer.com/article/10.1007/s11301-025-00545-1",
          "kind": "full-text"
        },
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/s11301-025-00545-1",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/s11301-025-00545-1",
      "fullTextUrl": "https://link.springer.com/article/10.1007/s11301-025-00545-1",
      "detailPath": "/publications/19362-systematic-analysis-of-data-governance-frameworks-and-their-relevance-to-data-trusts",
      "apa7": "Acev, D., Biyani, S., Rieder, F., Aldenhoff, T., Blazevic, M., Riehle, D., & Wimmer, M. A. (2025). Systematic analysis of data governance frameworks and their relevance to data trusts. Management Review Quarterly. https://doi.org/10.1007/s11301-025-00545-1",
      "bibtex": "@article{Acev2025Systematic,\n\tauthor = {Acev, David and Biyani, Sankalp and Rieder, Florian and Aldenhoff, Timon and Blazevic, Mevludin and Riehle, Dennis and Wimmer, Maria A.},\n\tjournal = {Management Review Quarterly},\n\tdoi = {10.1007/s11301-025-00545-1},\n\tyear = {2025},\n\ttitle = {Systematic analysis of data governance frameworks and their relevance to data trusts},\n\turl = {https://link.springer.com/article/10.1007/s11301-025-00545-1},\n\thowpublished = {https://link.springer.com/article/10.1007/s11301-025-00545-1},\n}"
    },
    {
      "id": 19768,
      "title": "Designing an Intelligent Tutoring Chatbot for Declarative Process Modeling Education (Extended Abstract)",
      "authors": "Sabine Nagel, Anna Wolters, Dennis M. Riehle, Patrick Delfmann",
      "authorNames": [
        "Nagel, Sabine",
        "Wolters, Anna",
        "Riehle, Dennis M.",
        "Delfmann, Patrick"
      ],
      "year": "2025",
      "type": "Meeting Abstract",
      "language": "en",
      "venue": "Proceedings of the 15th International Workshop on Enterprise Modeling and Information Systems Architectures, EMISA 2025, Heilbronn, Gemany, May 14-16, 2025",
      "publisher": "Gesellschaft für Informatik",
      "pages": "57-58",
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.18420/EMISA2025-07",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.18420/EMISA2025-07",
      "fullTextUrl": null,
      "detailPath": "/publications/19768-designing-an-intelligent-tutoring-chatbot-for-declarative-process-modeling-education-extended-abstract",
      "apa7": "Nagel, S., Wolters, A., Riehle, D. M., & Delfmann, P. (2025). Designing an Intelligent Tutoring Chatbot for Declarative Process Modeling Education (Extended Abstract). In L. Pufahl & J.-R. Rehse (Eds.), Proceedings of the 15th International Workshop on Enterprise Modeling and Information Systems Architectures, EMISA 2025, Heilbronn, Gemany, May 14-16, 2025 (pp. 57–58). Gesellschaft für Informatik. https://doi.org/10.18420/EMISA2025-07",
      "bibtex": "@inproceedings{Nagel2025Designing,\n\taddress = {Bonn},\n\tauthor = {Nagel, Sabine and Wolters, Anna and Riehle, Dennis M. and Delfmann, Patrick},\n\tbooktitle = {Proceedings of the 15th {International} {Workshop} on {Enterprise} {Modeling} and {Information} {Systems} {Architectures}, {EMISA} 2025, {Heilbronn}, {Gemany}, {May} 14-16, 2025},\n\tdoi = {10.18420/EMISA2025-07},\n\teditor = {Pufahl, Luise and Rehse, Jana-Rebecca},\n\tyear = {2025},\n\tpages = {57--58},\n\torganization = {Gesellschaft f{\\\" u}r Informatik},\n\ttitle = {Designing an {Intelligent} {Tutoring} {Chatbot} for {Declarative} {Process} {Modeling} {Education} ({Extended} {Abstract})},\n\turl = {https://doi.org/10.18420/EMISA2025-07},\n}"
    },
    {
      "id": 20297,
      "title": "IoT Artifacts in Information Systems Research – A Design Science Problem",
      "authors": "Arnold F. Arz von Straussenburg, Timon T. Aldenhoff, Marc Nilges, Dennis M. Riehle",
      "authorNames": [
        "Arz von Straussenburg, Arnold F.",
        "Aldenhoff, Timon T.",
        "Nilges, Marc",
        "Riehle, Dennis M."
      ],
      "year": "2025",
      "type": "Journalartikel",
      "language": "en",
      "venue": "Communications of the Association for Information Systems",
      "publisher": null,
      "pages": null,
      "peerReviewed": "ja",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://aisel.aisnet.org/cais/vol57/iss1/71",
          "kind": "full-text"
        },
        {
          "label": "DOI",
          "url": "https://doi.org/10.17705/1CAIS.05547",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.17705/1CAIS.05547",
      "fullTextUrl": "https://aisel.aisnet.org/cais/vol57/iss1/71",
      "detailPath": "/publications/20297-iot-artifacts-in-information-systems-research-a-design-science-problem",
      "apa7": "Arz von Straussenburg, A. F., Aldenhoff, T. T., Nilges, M., & Riehle, D. M. (2025). IoT Artifacts in Information Systems Research – A Design Science Problem. Communications of the Association for Information Systems, 57. https://doi.org/10.17705/1CAIS.05547",
      "bibtex": "@article{Arz2025IoT,\n\tauthor = {Arz von Straussenburg, Arnold F. and Aldenhoff, Timon T. and Nilges, Marc and Riehle, Dennis M.},\n\tjournal = {Communications of the Association for Information Systems},\n\tdoi = {10.17705/1CAIS.05547},\n\tyear = {2025},\n\ttitle = {IoT {Artifacts} in {Information} {Systems} {Research} -- {A} {Design} {Science} {Problem}},\n\turl = {https://aisel.aisnet.org/cais/vol57/iss1/71},\n\thowpublished = {https://aisel.aisnet.org/cais/vol57/iss1/71},\n\tvolume = {57},\n}"
    },
    {
      "id": 21881,
      "title": "Roles and Rights Management for Data Trusts",
      "authors": "David Acev, Arnold F. Arz Von Straussenburg, Florian Rieder, Timon T. Aldenhoff, Sankalp Biyani, Dennis M. Riehle, Maria A. Wimmer",
      "authorNames": [
        "Acev, David",
        "Arz Von Straussenburg, Arnold F.",
        "Rieder, Florian",
        "Aldenhoff, Timon T.",
        "Biyani, Sankalp",
        "Riehle, Dennis M.",
        "Wimmer, Maria A."
      ],
      "year": "2025",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "ACIS 2025 proceedings",
      "publisher": "Association for Information Systems (AIS)",
      "pages": null,
      "peerReviewed": "ja",
      "access": "Restricted Access",
      "abstract": "In a data trust ecosystem, the data flow from one end to another must be thoroughly observed and suitably managed. To achieve secure and trustworthy data sharing, a comprehensive framework for data access needs to be implemented. The design of such a framework requires delineating the obligatory components and their interconnection to generate a coherent and seamless data exchange between different data actors (entities). Identifying and unequivocally amalgamating the management components and access control models contributes to meeting the requirements for the design of a roles and rights management framework, which can guarantee a smooth and reliable data flow between different entities in data trust ecosystems. This study applies design science research to determine the requirements and to design a roles and rights management framework as an essential element of the data trust ecosystem.",
      "links": [
        {
          "label": "Full text",
          "url": "https://aisel.aisnet.org/acis2025/95/",
          "kind": "full-text"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://aisel.aisnet.org/acis2025/95/",
      "detailPath": "/publications/21881-roles-and-rights-management-for-data-trusts",
      "apa7": "Acev, D., Arz Von Straussenburg, A. F., Rieder, F., Aldenhoff, T. T., Biyani, S., Riehle, D. M., & Wimmer, M. A. (2025). Roles and Rights Management for Data Trusts. ACIS 2025 Proceedings. https://aisel.aisnet.org/acis2025/95/",
      "bibtex": "@inproceedings{Acev2025Roles,\n\taddress = {Atlanta, Georgia},\n\tauthor = {Acev, David and Arz Von Straussenburg, Arnold F. and Rieder, Florian and Aldenhoff, Timon T. and Biyani, Sankalp and Riehle, Dennis M. and Wimmer, Maria A.},\n\tbooktitle = {ACIS 2025 proceedings},\n\tyear = {2025},\n\torganization = {Association for Information Systems (AIS)},\n\ttitle = {Roles and {Rights} {Management} for {Data} {Trusts}},\n\turl = {https://aisel.aisnet.org/acis2025/95/},\n}"
    },
    {
      "id": 22203,
      "title": "AI Agents as Governance Actors in Data Trusts – A Normative and Design Framework",
      "authors": "Arnold F. Arz von Straussenburg, Jens Joachim Marga, Timon T. Aldenhoff, Dennis M. Riehle",
      "authorNames": [
        "Arz von Straussenburg, Arnold F.",
        "Marga, Jens Joachim",
        "Aldenhoff, Timon T.",
        "Riehle, Dennis M."
      ],
      "year": "2025",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "AIS Insights",
      "publisher": null,
      "pages": null,
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://ais-insights.ai/summaries/139",
          "kind": "full-text"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://ais-insights.ai/summaries/139",
      "detailPath": "/publications/22203-ai-agents-as-governance-actors-in-data-trusts-a-normative-and-design-framework",
      "apa7": "Arz von Straussenburg, A. F., Marga, J. J., Aldenhoff, T. T., & Riehle, D. M. (2025). AI Agents as Governance Actors in Data Trusts – A Normative and Design Framework. AIS Insights. https://ais-insights.ai/summaries/139",
      "bibtex": "@inproceedings{Arz2025AI,\n\tauthor = {Arz von Straussenburg, Arnold F. and Marga, Jens Joachim and Aldenhoff, Timon T. and Riehle, Dennis M.},\n\tbooktitle = {AIS {Insights}},\n\tyear = {2025},\n\ttitle = {AI {Agents} as {Governance} {Actors} in {Data} {Trusts} -- {A} {Normative} and {Design} {Framework}},\n\turl = {https://ais-insights.ai/summaries/139},\n\thowpublished = {https://ais-insights.ai/summaries/139},\n}"
    },
    {
      "id": 19043,
      "title": "Towards Hybrid Architectures : Integrating Large Language Models in Informative Chatbots",
      "authors": "Arnold F. Arz von Straussenburg, Anna Wolters",
      "authorNames": ["Arz von Straussenburg, Arnold F.", "Wolters, Anna"],
      "year": "2025",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Solutions and Technologies for Responsible Digitalization : \nProceedings of the 18th International Conference on Wirtschaftsinformatik, Paderborn, Germany, 2023",
      "publisher": "Springer Nature Switzerland",
      "pages": "333-341",
      "peerReviewed": "keine Angabe",
      "access": "Restricted Access",
      "abstract": "Informative chatbots embedded in an organization-specific context can provide a reliable, interactive, and engaging source of information for users. However, traditional chatbot techniques have limitations in processing and understanding user input and generating human-like responses. On the other hand, the latest implementations of large language models show promising results in these domains but have limitations in providing accurate and up-to-date facts from domain-specific knowledge bases. With the advent of popular chatbots like Chat-GPT, they are increasingly becoming part of organizations' digital infrastructure. In this research-in-progress paper, we argue that the strengths and weaknesses of traditional techniques and large language models are complementary. Therefore, we propose a hybrid chatbot architecture that utilizes inter-agent communication to compensate for disadvantages while enhancing the chatbot's abilities, as perceived by the user. This approach will form the basis for development and evaluation using Design Science Research (DSR) as part of our research.",
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-031-80122-8_21",
          "kind": "doi"
        },
        {
          "label": "Conference",
          "url": "https://wi2023.de/",
          "kind": "conference"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-031-80122-8_21",
      "fullTextUrl": null,
      "detailPath": "/publications/19043-towards-hybrid-architectures-integrating-large-language-models-in-informative-chatbots",
      "apa7": "Arz von Straussenburg, A. F., & Wolters, A. (2025). Towards Hybrid Architectures : Integrating Large Language Models in Informative Chatbots. In D. Beverungen, C. Lehrer, & M. Trier (Eds.), Solutions and Technologies for Responsible Digitalization : \nProceedings of the 18th International Conference on Wirtschaftsinformatik, Paderborn, Germany, 2023 (pp. 333–341). Springer Nature Switzerland. https://doi.org/10.1007/978-3-031-80122-8_21",
      "bibtex": "@inproceedings{Arz2025Towards,\n\taddress = {Cham},\n\tauthor = {Arz von Straussenburg, Arnold F. and Wolters, Anna},\n\tbooktitle = {Solutions and {Technologies} for {Responsible} {Digitalization} : \nProceedings of the 18th {International} {Conference} on {Wirtschaftsinformatik}, {Paderborn}, {Germany}, 2023},\n\tdoi = {10.1007/978-3-031-80122-8_21},\n\teditor = {Beverungen, Daniel and Lehrer, Christiane and Trier, Matthias},\n\tyear = {2025},\n\tpages = {333--341},\n\torganization = {Springer Nature Switzerland},\n\ttitle = {Towards {Hybrid} {Architectures} : Integrating {Large} {Language} {Models} in {Informative} {Chatbots}},\n\turl = {https://doi.org/10.1007/978-3-031-80122-8_21},\n}"
    },
    {
      "id": 19598,
      "title": "KI-Kompetenzmodell Grundlagen : „Wurzel & Stamm“ : \nWhitepaper",
      "authors": "Birte C. Gnau-Franké, Andreas Mauthe, Henning Pätzold, Arnold Arz von Straussenburg, Paul Bohlander, Anna Braun, Joshua Dohmen, Nicolai Glasenapp, Imke von Helden-Sarnowski, Christopher Latz, Iris Meißner, Carolin Metz, Murielle Paganetti, Jolina Weishäupl, Sandra Wingender, Anna Wolters, Eva L. Wyss",
      "authorNames": [
        "Gnau-Franké, Birte C.",
        "Mauthe, Andreas",
        "Pätzold, Henning",
        "Arz von Straussenburg, Arnold",
        "Bohlander, Paul",
        "Braun, Anna",
        "Dohmen, Joshua",
        "Glasenapp, Nicolai",
        "von Helden-Sarnowski, Imke",
        "Latz, Christopher",
        "Meißner, Iris",
        "Metz, Carolin",
        "Paganetti, Murielle",
        "Weishäupl, Jolina",
        "Wingender, Sandra",
        "Wolters, Anna",
        "Wyss, Eva L."
      ],
      "year": "2025",
      "type": "Arbeitspapier/Forschungsbericht",
      "language": "de",
      "venue": null,
      "publisher": "Universität Koblenz",
      "pages": null,
      "peerReviewed": null,
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://opus4.kobv.de/opus4-uni-koblenz/frontdoor/deliver/index/docId/2578/file/Whitepaper-KI-Kompetenzmodell.pdf",
          "kind": "full-text"
        },
        {
          "label": "DOI",
          "url": "https://doi.org/10.82549/opus4-2578",
          "kind": "doi"
        },
        {
          "label": "URN",
          "url": "https://nbn-resolving.org/urn:nbn:de:hbz:kob7-25780",
          "kind": "external"
        }
      ],
      "doiUrl": "https://doi.org/10.82549/opus4-2578",
      "fullTextUrl": "https://opus4.kobv.de/opus4-uni-koblenz/frontdoor/deliver/index/docId/2578/file/Whitepaper-KI-Kompetenzmodell.pdf",
      "detailPath": "/publications/19598-ki-kompetenzmodell-grundlagen-wurzel-stamm-whitepaper",
      "apa7": "Gnau-Franké, B. C., Mauthe, A., Pätzold, H., Arz von Straussenburg, A., Bohlander, P., Braun, A., Dohmen, J., Glasenapp, N., von Helden-Sarnowski, I., Latz, C., Meißner, I., Metz, C., Paganetti, M., Weishäupl, J., Wingender, S., Wolters, A., & Wyss, E. L. (2025). KI-Kompetenzmodell Grundlagen : „Wurzel & Stamm“ : \nWhitepaper. Universität Koblenz. https://doi.org/10.82549/opus4-2578",
      "bibtex": "@misc{Gnau2025KI,\n\taddress = {Koblenz},\n\tauthor = {Gnau-Frank{\\' e}, Birte C. and Mauthe, Andreas and P{\\\" a}tzold, Henning and Arz von Straussenburg, Arnold and Bohlander, Paul and Braun, Anna and Dohmen, Joshua and Glasenapp, Nicolai and von Helden-Sarnowski, Imke and Latz, Christopher and Mei\\ss{}ner, Iris and Metz, Carolin and Paganetti, Murielle and Weish{\\\" a}upl, Jolina and Wingender, Sandra and Wolters, Anna and Wyss, Eva L.},\n\tdoi = {10.82549/opus4-2578},\n\tyear = {2025},\n\tpublisher = {Universit{\\\" a}t Koblenz},\n\ttitle = {KI-{Kompetenzmodell} {Grundlagen} : \\quotedblbase{}{Wurzel} \\& {Stamm}`` : \nWhitepaper},\n\turl = {https://opus4.kobv.de/opus4-uni-koblenz/frontdoor/deliver/index/docId/2578/file/Whitepaper-KI-Kompetenzmodell.pdf},\n}"
    },
    {
      "id": 16682,
      "title": "AI Literacy in Adult Education - A Literature Review",
      "authors": "Anna Wolters, Arnold Arz von Straussenburg, Dennis Riehle",
      "authorNames": [
        "Wolters, Anna",
        "Arz von Straussenburg, Arnold",
        "Riehle, Dennis"
      ],
      "year": "2024",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceedings of the 57th Hawaii International Conference on System Sciences HICSS 2024: Hilton Hawaiian Village Waikiki Beach Resort, Honolulu January 3-6, 2024",
      "publisher": "University of Hawaii at Manoa",
      "pages": "6888-6897",
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://scholarspace.manoa.hawaii.edu/bitstreams/82c9e583-a73c-4152-8fe9-87191394b4a1/download",
          "kind": "full-text"
        },
        { "label": "DOI", "url": "https://doi.org/10125/107211", "kind": "doi" }
      ],
      "doiUrl": "https://doi.org/10125/107211",
      "fullTextUrl": "https://scholarspace.manoa.hawaii.edu/bitstreams/82c9e583-a73c-4152-8fe9-87191394b4a1/download",
      "detailPath": "/publications/16682-ai-literacy-in-adult-education-a-literature-review",
      "apa7": "Wolters, A., Arz von Straussenburg, A., & Riehle, D. (2024). AI Literacy in Adult Education - A Literature Review. In T. X. Bui (Ed.), Proceedings of the 57th Hawaii International Conference on System Sciences HICSS 2024: Hilton Hawaiian Village Waikiki Beach Resort, Honolulu January 3-6, 2024 (pp. 6888–6897). University of Hawaii at Manoa. https://doi.org/10125/107211",
      "bibtex": "@inproceedings{Wolters2024AI,\n\taddress = {Honolulu, HI},\n\tauthor = {Wolters, Anna and Arz von Straussenburg, Arnold and Riehle, Dennis},\n\tbooktitle = {Proceedings of the 57th {Hawaii} {International} {Conference} on {System} {Sciences} {HICSS} 2024: Hilton {Hawaiian} {Village} {Waikiki} {Beach} {Resort}, {Honolulu} {January} 3-6, 2024},\n\tdoi = {10125/107211},\n\teditor = {Bui, Tung X.},\n\tisbn = {978-0-9981331-7-1},\n\tyear = {2024},\n\tpages = {6888--6897},\n\torganization = {University of Hawaii at Manoa},\n\ttitle = {AI {Literacy} in {Adult} {Education} - {A} {Literature} {Review}},\n\turl = {https://scholarspace.manoa.hawaii.edu/bitstreams/82c9e583-a73c-4152-8fe9-87191394b4a1/download},\n}"
    },
    {
      "id": 17079,
      "title": "Comparing On-Premise IoT Platforms: Empowering University of Things Ecosystems with Effective Device Management",
      "authors": "Mevludin Blazevic, Dennis M. Riehle",
      "authorNames": ["Blazevic, Mevludin", "Riehle, Dennis M."],
      "year": "2024",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceedings of the 9th International Conference on Internet of Things, Big Data and Security IoTBDS  2024. Angers, France. April 28 - 30, 2024",
      "publisher": "SciTePress",
      "pages": "310-320",
      "peerReviewed": "ja",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.5220/0012727000003705",
          "kind": "doi"
        },
        {
          "label": "Conference",
          "url": "https://iotbds.scitevents.org/?y=2024",
          "kind": "conference"
        }
      ],
      "doiUrl": "https://doi.org/10.5220/0012727000003705",
      "fullTextUrl": null,
      "detailPath": "/publications/17079-comparing-on-premise-iot-platforms-empowering-university-of-things-ecosystems-with-effective-device-management",
      "apa7": "Blazevic, M., & Riehle, D. M. (2024). Comparing On-Premise IoT Platforms: Empowering University of Things Ecosystems with Effective Device Management. In A. Kobusinska, A. Jacobsson, & V. Chang (Eds.), Proceedings of the 9th International Conference on Internet of Things, Big Data and Security IoTBDS  2024. Angers, France. April 28 - 30, 2024 (pp. 310–320). SciTePress. https://doi.org/10.5220/0012727000003705",
      "bibtex": "@inproceedings{Blazevic2024Comparing,\n\taddress = {Set{\\' u}bal},\n\tauthor = {Blazevic, Mevludin and Riehle, Dennis M.},\n\tbooktitle = {Proceedings of the 9th {International} {Conference} on {Internet} of {Things}, {Big} {Data} and {Security} {IoTBDS}  2024. {Angers}, {France}. {April} 28 - 30, 2024},\n\tdoi = {10.5220/0012727000003705},\n\teditor = {Kobusinska, Anna and Jacobsson, Andreas and Chang, Victor},\n\tisbn = {978-989-758-699-6},\n\tyear = {2024},\n\tpages = {310--320},\n\torganization = {SciTePress},\n\ttitle = {Comparing {On}-{Premise} {IoT} {Platforms}: Empowering {University} of {Things} {Ecosystems} with {Effective} {Device} {Management}},\n\turl = {https://doi.org/10.5220/0012727000003705},\n}"
    },
    {
      "id": 17192,
      "title": "Towards a Smarter Tomorrow: A Design Science Perspective on Building a Smart Campus IoT Data Platform",
      "authors": "Mevludin Blazevic, Timon T. Aldenhoff, Dennis M. Riehle",
      "authorNames": [
        "Blazevic, Mevludin",
        "Aldenhoff, Timon T.",
        "Riehle, Dennis M."
      ],
      "year": "2024",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Design Science Research for a Resilient Future: 19th International Conference on Design Science Research in Information Systems and Technology, DESRIST 2024, Trollhättan, Sweden, June 3–5, 2024, Proceedings",
      "publisher": "Springer",
      "pages": "267-277",
      "peerReviewed": "ja",
      "access": "Restricted Access",
      "abstract": "In the area of Internet of Things (IoT) data storage, the integration of Relational Database Management Systems (RDBMS) and Time Series Database (TSD) approaches represents a promising reliable, and scalable solution. This paper aims to design and instantiate a reference architecture for an IoT data platform tailored for a smart campus or University of Things (UoT) environment. The approach includes combining RDBMS and TSD technologies within a single, unified data platform. This integration combines relational data, which is commonly used in Information Systems (IS), with time-stamped information from various IoT sensors deployed across the university campus. The collected sensor data comprises millions of data points over time, which are effectively integrated into the IoT data platform, facilitating quick and dependable access to time series data, and eliminating the need for complex preprocessing or indexing. By applying the Action Design Research (ADR) method, requirements for the data platform derived from the existing smart campus infrastructure are gathered before designing the platform. The findings reveal that combining RDBMS and TSDs concepts represents an easy-to-implement and scalable solution for IoT infrastructures.",
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-031-61175-9_18",
          "kind": "doi"
        },
        {
          "label": "Conference",
          "url": "https://www.hv.se/om-oss/event-och-konferenser/desrist-2024/",
          "kind": "conference"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-031-61175-9_18",
      "fullTextUrl": null,
      "detailPath": "/publications/17192-towards-a-smarter-tomorrow-a-design-science-perspective-on-building-a-smart-campus-iot-data-platform",
      "apa7": "Blazevic, M., Aldenhoff, T. T., & Riehle, D. M. (2024). Towards a Smarter Tomorrow: A Design Science Perspective on Building a Smart Campus IoT Data Platform. In M. Mandviwalla, M. Söllner, & T. Tuunanen (Eds.), Design Science Research for a Resilient Future: 19th International Conference on Design Science Research in Information Systems and Technology, DESRIST 2024, Trollhättan, Sweden, June 3–5, 2024, Proceedings (pp. 267–277). Springer. https://doi.org/10.1007/978-3-031-61175-9_18",
      "bibtex": "@inproceedings{Blazevic2024Towards,\n\taddress = {Cham},\n\tauthor = {Blazevic, Mevludin and Aldenhoff, Timon T. and Riehle, Dennis M.},\n\tbooktitle = {Design {Science} {Research} for a {Resilient} {Future}: 19th {International} {Conference} on {Design} {Science} {Research} in {Information} {Systems} and {Technology}, {DESRIST} 2024, {Trollh}{\\\" a}ttan, {Sweden}, {June} 3--5, 2024, {Proceedings}},\n\tdoi = {10.1007/978-3-031-61175-9_18},\n\teditor = {Mandviwalla, Munir and S{\\\" o}llner, Matthias and Tuunanen, Tuure},\n\tisbn = {978-3-031-61174-2},\n\tyear = {2024},\n\tpages = {267--277},\n\torganization = {Springer},\n\ttitle = {Towards a {Smarter} {Tomorrow}: A {Design} {Science} {Perspective} on {Building} a {Smart} {Campus} {IoT} {Data} {Platform}},\n\turl = {https://doi.org/10.1007/978-3-031-61175-9_18},\n}"
    },
    {
      "id": 17195,
      "title": "Designing for High Availability - A Reference Architecture for IoT Data Platforms",
      "authors": "Timon T. Aldenhoff, Arnold F. Arz von Straussenburg, Dennis M. Riehle",
      "authorNames": [
        "Aldenhoff, Timon T.",
        "Arz von Straussenburg, Arnold F.",
        "Riehle, Dennis M."
      ],
      "year": "2024",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Pacific-Asia Conference on Information Systems PACIS 2024 Proceedings. Ho Chi Minh City, Vietnam, July 1 - 5, 2024",
      "publisher": "Association for Information Systems/AIS eLibrary",
      "pages": "1273-1289",
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": "This paper presents a novel Reference Architecture (RA) for designing complex Internet of Things (IoT) data platforms with a focus on High Availability (HA). HA is crucial in various IoT applications, from smart cities to industrial sectors like smart farming, where system disruptions can lead to significant losses. The RA aims to guide businesses in designing IoT data platforms that ensure uninterrupted operations and maintain data integrity. We identify essential features such as redundancy, replication, and a layered approach by synthesizing insights from existing RAs and architectures of IoT data plat-forms, particularly in large-scale implementations. A Design Science Research approach is used to develop a comprehensive RA for HA iteratively. This comprehensive framework contributes to the field of Information Systems by providing a blueprint for developing scalable and resilient IoT data platforms capable of accommodating the rapid growth of IoT data across diverse domains.",
      "links": [
        {
          "label": "Full text",
          "url": "https://aisel.aisnet.org/pacis2024/track06_dpe/track06_dpe/1",
          "kind": "full-text"
        },
        {
          "label": "Conference",
          "url": "https://pacis2024.aisconferences.org/",
          "kind": "conference"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://aisel.aisnet.org/pacis2024/track06_dpe/track06_dpe/1",
      "detailPath": "/publications/17195-designing-for-high-availability-a-reference-architecture-for-iot-data-platforms",
      "apa7": "Aldenhoff, T. T., Arz von Straussenburg, A. F., & Riehle, D. M. (2024). Designing for High Availability - A Reference Architecture for IoT Data Platforms. In T. Q. Phan, B. Tan, L. Hoanh-Su, & N. H. Thuan (Eds.), Pacific-Asia Conference on Information Systems PACIS 2024 Proceedings. Ho Chi Minh City, Vietnam, July 1 - 5, 2024 (pp. 1273–1289). Association for Information Systems/AIS eLibrary. https://aisel.aisnet.org/pacis2024/track06_dpe/track06_dpe/1",
      "bibtex": "@inproceedings{Aldenhoff2024Designing,\n\taddress = {Atlanta, GA},\n\tauthor = {Aldenhoff, Timon T. and Arz von Straussenburg, Arnold F. and Riehle, Dennis M.},\n\tbooktitle = {Pacific-{Asia} {Conference} on {Information} {Systems} {PACIS} 2024 {Proceedings}. {Ho} {Chi} {Minh} {City}, {Vietnam}, {July} 1 - 5, 2024},\n\teditor = {Phan, Tuan Q. and Tan, Bernard and Hoanh-Su, Le and Thuan, Nguyen Hoang},\n\tyear = {2024},\n\tpages = {1273--1289},\n\torganization = {Association for Information Systems/AIS eLibrary},\n\ttitle = {Designing for {High} {Availability} - {A} {Reference} {Architecture} for {IoT} {Data} {Platforms}},\n\turl = {https://aisel.aisnet.org/pacis2024/track06_dpe/track06_dpe/1},\n}"
    },
    {
      "id": 17305,
      "title": "Sensing the Unseen - Using CO₂ as a Key Indicator for Occupancy Detection in Smart Collaboration Spaces",
      "authors": "Mevludin Blazevic, Arnold F. Arz von Straussenburg, Dennis M. Riehle",
      "authorNames": [
        "Blazevic, Mevludin",
        "Arz von Straussenburg, Arnold F.",
        "Riehle, Dennis M."
      ],
      "year": "2024",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "CENTERIS 2023 - International Conference on ENTERprise Information Systems / ProjMAN - International Conference on Project MANagement / HCist - International Conference on Health and Social Care Information Systems and Technologies 2023, Porto, Portugal, November 8-10, 2023",
      "publisher": "Elsevier",
      "pages": "1312-1319",
      "peerReviewed": "keine Angabe",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1016/j.procs.2024.06.301",
          "kind": "doi"
        },
        {
          "label": "ISSN",
          "url": "https://portal.issn.org/resource/ISSN/1877-0509",
          "kind": "external"
        }
      ],
      "doiUrl": "https://doi.org/10.1016/j.procs.2024.06.301",
      "fullTextUrl": null,
      "detailPath": "/publications/17305-sensing-the-unseen-using-co-as-a-key-indicator-for-occupancy-detection-in-smart-collaboration-spaces",
      "apa7": "Blazevic, M., Arz von Straussenburg, A. F., & Riehle, D. M. (2024). Sensing the Unseen - Using CO₂ as a Key Indicator for Occupancy Detection in Smart Collaboration Spaces. In R. Filipe & M. M. Cruz da Cunha (Eds.), CENTERIS 2023 - International Conference on ENTERprise Information Systems / ProjMAN - International Conference on Project MANagement / HCist - International Conference on Health and Social Care Information Systems and Technologies 2023, Porto, Portugal, November 8-10, 2023 (pp. 1312–1319). Elsevier. https://doi.org/10.1016/j.procs.2024.06.301",
      "bibtex": "@inproceedings{Blazevic2024Sensing,\n\taddress = {Amsterdam},\n\tauthor = {Blazevic, Mevludin and Arz von Straussenburg, Arnold F. and Riehle, Dennis M.},\n\tbooktitle = {CENTERIS 2023 - {International} {Conference} on {ENTERprise} {Information} {Systems} / {ProjMAN} - {International} {Conference} on {Project} {MANagement} / {HCist} - {International} {Conference} on {Health} and {Social} {Care} {Information} {Systems} and {Technologies} 2023, {Porto}, {Portugal}, {November} 8-10, 2023},\n\tdoi = {10.1016/j.procs.2024.06.301},\n\teditor = {Filipe, Ricardo and Cruz da Cunha, Maria Manuela},\n\tyear = {2024},\n\tpages = {1312--1319},\n\torganization = {Elsevier},\n\ttitle = {Sensing the {Unseen} - {Using} {CO2} as a {Key} {Indicator} for {Occupancy} {Detection} in {Smart} {Collaboration} {Spaces}},\n\turl = {https://doi.org/10.1016/j.procs.2024.06.301},\n}"
    },
    {
      "id": 17306,
      "title": "Adopting Artificial Intelligence in a Decision Support System - Learnings from Comment Moderation Systems",
      "authors": "Dennis M. Riehle, Anna Wolters, Kilian Müller",
      "authorNames": ["Riehle, Dennis M.", "Wolters, Anna", "Müller, Kilian"],
      "year": "2024",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "CENTERIS 2023 - International Conference on ENTERprise Information Systems / ProjMAN - International Conference on Project MANagement / HCist - International Conference on Health and Social Care Information Systems and Technologies 2023, Porto, Portugal, November 8-10, 2023",
      "publisher": "Elsevier",
      "pages": "1847-1855",
      "peerReviewed": "keine Angabe",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1016/j.procs.2024.06.366",
          "kind": "doi"
        },
        {
          "label": "ISSN",
          "url": "https://portal.issn.org/resource/ISSN/1877-0509",
          "kind": "external"
        }
      ],
      "doiUrl": "https://doi.org/10.1016/j.procs.2024.06.366",
      "fullTextUrl": null,
      "detailPath": "/publications/17306-adopting-artificial-intelligence-in-a-decision-support-system-learnings-from-comment-moderation-systems",
      "apa7": "Riehle, D. M., Wolters, A., & Müller, K. (2024). Adopting Artificial Intelligence in a Decision Support System - Learnings from Comment Moderation Systems. In R. Filipe & M. M. Cruz da Cunha (Eds.), CENTERIS 2023 - International Conference on ENTERprise Information Systems / ProjMAN - International Conference on Project MANagement / HCist - International Conference on Health and Social Care Information Systems and Technologies 2023, Porto, Portugal, November 8-10, 2023 (pp. 1847–1855). Elsevier. https://doi.org/10.1016/j.procs.2024.06.366",
      "bibtex": "@inproceedings{Riehle2024Adopting,\n\taddress = {Amsterdam},\n\tauthor = {Riehle, Dennis M. and Wolters, Anna and M{\\\" u}ller, Kilian},\n\tbooktitle = {CENTERIS 2023 - {International} {Conference} on {ENTERprise} {Information} {Systems} / {ProjMAN} - {International} {Conference} on {Project} {MANagement} / {HCist} - {International} {Conference} on {Health} and {Social} {Care} {Information} {Systems} and {Technologies} 2023, {Porto}, {Portugal}, {November} 8-10, 2023},\n\tdoi = {10.1016/j.procs.2024.06.366},\n\teditor = {Filipe, Ricardo and Cruz da Cunha, Maria Manuela},\n\tyear = {2024},\n\tpages = {1847--1855},\n\torganization = {Elsevier},\n\ttitle = {Adopting {Artificial} {Intelligence} in a {Decision} {Support} {System} - {Learnings} from {Comment} {Moderation} {Systems}},\n\turl = {https://doi.org/10.1016/j.procs.2024.06.366},\n}"
    },
    {
      "id": 17345,
      "title": "Evaluation Framework for Large Language Model-based Conversational Agents",
      "authors": "Anna Wolters, Arnold Arz von Straussenburg, Dennis Riehle",
      "authorNames": [
        "Wolters, Anna",
        "Arz von Straussenburg, Arnold",
        "Riehle, Dennis"
      ],
      "year": "2024",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Pacific-Asia Conference on Information Systems PACIS 2024 Proceedings. Ho Chi Minh City, Vietnam, July 1 - 5, 2024",
      "publisher": "Association for Information Systems/AIS eLibrary",
      "pages": "1390-1406",
      "peerReviewed": "ja",
      "access": "Restricted Access",
      "abstract": "The integration of Large Language Models (LLM) in Conversational Agents (CA) enables a significant advancement in the agents’ ability to understand and respond to user queries in a more human-like manner. Despite the widespread adoption of LLMs in these agents, there exists a noticeable lack of research on standardized evaluation methods. Addressing this research gap, our study proposes a comprehensive evaluation framework tailored explicitly to LLM-based conversational agents. In a Design Science Research (DSR) project, we construct an evaluation framework that incorporates four essential components: the pre-defined objectives of the agents, corresponding tasks, and the selection of appropriate datasets and metrics. Our framework outlines how these elements relate to each other in the evaluation and enables a structured approach for the evaluation. We demonstrate how such a framework enables a more systematic evaluation process. This framework can be a guiding tool for researchers and developers working with LLM-based conversational agents.",
      "links": [
        {
          "label": "Full text",
          "url": "https://aisel.aisnet.org/pacis2024/track01_aibussoc/track01_aibussoc/14",
          "kind": "full-text"
        },
        {
          "label": "Conference",
          "url": "https://pacis2024.aisconferences.org/",
          "kind": "conference"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://aisel.aisnet.org/pacis2024/track01_aibussoc/track01_aibussoc/14",
      "detailPath": "/publications/17345-evaluation-framework-for-large-language-model-based-conversational-agents",
      "apa7": "Wolters, A., Arz von Straussenburg, A., & Riehle, D. (2024). Evaluation Framework for Large Language Model-based Conversational Agents. In T. Q. Phan, B. Tan, L. Hoanh-Su, & N. H. Thuan (Eds.), Pacific-Asia Conference on Information Systems PACIS 2024 Proceedings. Ho Chi Minh City, Vietnam, July 1 - 5, 2024 (pp. 1390–1406). Association for Information Systems/AIS eLibrary. https://aisel.aisnet.org/pacis2024/track01_aibussoc/track01_aibussoc/14",
      "bibtex": "@inproceedings{Wolters2024Evaluation,\n\taddress = {Atlanta, GA},\n\tauthor = {Wolters, Anna and Arz von Straussenburg, Arnold and Riehle, Dennis},\n\tbooktitle = {Pacific-{Asia} {Conference} on {Information} {Systems} {PACIS} 2024 {Proceedings}. {Ho} {Chi} {Minh} {City}, {Vietnam}, {July} 1 - 5, 2024},\n\teditor = {Phan, Tuan Q. and Tan, Bernard and Hoanh-Su, Le and Thuan, Nguyen Hoang},\n\tyear = {2024},\n\tpages = {1390--1406},\n\torganization = {Association for Information Systems/AIS eLibrary},\n\ttitle = {Evaluation {Framework} for {Large} {Language} {Model}-based {Conversational} {Agents}},\n\turl = {https://aisel.aisnet.org/pacis2024/track01_aibussoc/track01_aibussoc/14},\n}"
    },
    {
      "id": 18332,
      "title": "Designing an Intelligent Tutoring Chatbot for Declarative Process Modeling Education",
      "authors": "Sabine Nagel, Anna Wolters, Dennis M. Riehle, Patrick Delfmann",
      "authorNames": [
        "Nagel, Sabine",
        "Wolters, Anna",
        "Riehle, Dennis M.",
        "Delfmann, Patrick"
      ],
      "year": "2024",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "ACIS 2024 Proceedings : Digital Futures for a Sustainable Society",
      "publisher": "AIS",
      "pages": null,
      "peerReviewed": "keine Angabe",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://aisel.aisnet.org/acis2024/162/",
          "kind": "full-text"
        },
        {
          "label": "Conference",
          "url": "https://aisel.aisnet.org/acis2024/",
          "kind": "conference"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://aisel.aisnet.org/acis2024/162/",
      "detailPath": "/publications/18332-designing-an-intelligent-tutoring-chatbot-for-declarative-process-modeling-education",
      "apa7": "Nagel, S., Wolters, A., Riehle, D. M., & Delfmann, P. (2024). Designing an Intelligent Tutoring Chatbot for Declarative Process Modeling Education. ACIS 2024 Proceedings : Digital Futures for a Sustainable Society. https://aisel.aisnet.org/acis2024/162/",
      "bibtex": "@inproceedings{Nagel2024Designing,\n\taddress = {Atlanta, GA},\n\tauthor = {Nagel, Sabine and Wolters, Anna and Riehle, Dennis M. and Delfmann, Patrick},\n\tbooktitle = {ACIS 2024 {Proceedings} : Digital {Futures} for a {Sustainable} {Society}},\n\tyear = {2024},\n\torganization = {AIS},\n\ttitle = {Designing an {Intelligent} {Tutoring} {Chatbot} for {Declarative} {Process} {Modeling} {Education}},\n\turl = {https://aisel.aisnet.org/acis2024/162/},\n}"
    },
    {
      "id": 18416,
      "title": "EduClare – An Intelligent Tutoring Chatbot for Teaching Declarative Process Modeling",
      "authors": "Sabine Nagel, Anna Wolters, Dennis Riehle, Patrick Delfmann",
      "authorNames": [
        "Nagel, Sabine",
        "Wolters, Anna",
        "Riehle, Dennis",
        "Delfmann, Patrick"
      ],
      "year": "2024",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceedings of the ICPM Doctoral Consortium and Demo Track 2024 co-located with 6th International Conference on Process Mining (ICPM 2024)",
      "publisher": "CEUR/RWTH",
      "pages": null,
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "URN",
          "url": "https://ceur-ws.org/Vol-3783/paper_326.pdf",
          "kind": "external"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": null,
      "detailPath": "/publications/18416-educlare-an-intelligent-tutoring-chatbot-for-teaching-declarative-process-modeling",
      "apa7": "Nagel, S., Wolters, A., Riehle, D., & Delfmann, P. (2024). EduClare – An Intelligent Tutoring Chatbot for Teaching Declarative Process Modeling. In J. De Weerdt, G. Meroni, H. Aa, & K. Winter (Eds.), Proceedings of the ICPM Doctoral Consortium and Demo Track 2024 co-located with 6th International Conference on Process Mining (ICPM 2024). CEUR/RWTH.",
      "bibtex": "@inproceedings{Nagel2024EduClare,\n\taddress = {Aachen},\n\tauthor = {Nagel, Sabine and Wolters, Anna and Riehle, Dennis and Delfmann, Patrick},\n\tbooktitle = {Proceedings of the {ICPM} {Doctoral} {Consortium} and {Demo} {Track} 2024 co-located with 6th {International} {Conference} on {Process} {Mining} ({ICPM} 2024)},\n\teditor = {De Weerdt, Jochen and Meroni, Giovanni and Aa, Han and Winter, Karolin},\n\tyear = {2024},\n\torganization = {CEUR/RWTH},\n\ttitle = {EduClare -- {An} {Intelligent} {Tutoring} {Chatbot} for {Teaching} {Declarative} {Process} {Modeling}},\n}"
    },
    {
      "id": 18466,
      "title": "Extending the SensorThings API Data Model – Improving Interoperability and Use Case Flexibility in IoT",
      "authors": "Arnold F. Arz von Straussenburg, Timon T. Aldenhoff, Dennis M. Riehle",
      "authorNames": [
        "Arz von Straussenburg, Arnold F.",
        "Aldenhoff, Timon T.",
        "Riehle, Dennis M."
      ],
      "year": "2024",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "ER 2024 : companion proceedings of the 43rd International Conference on Conceptual Modeling: ER Forum, Special Topics, Posters and Demos : Pittsburgh, Pennsylvania, USA, October 28-31, 2024",
      "publisher": "CEUR/RWTH",
      "pages": "1-14",
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": "This study presents an enhancement to the OGC SensorThings API Data Model tailored for Internet of Things (IoT) environments, demonstrated with a Smart Farming application enhancement. The designed data model addresses critical challenges faced in real-world settings like industrial environments, adhering to the FAIR principles of Findability, Accessibility, and, in particular, Interoperability and Reusability. Beyond the practical use case of crop monitoring, we offer a conceptual framework for future projects across various domains. The resulting architecture demonstrates how modular components improve adaptability and extendibility through standardization and interoperability. This modular approach decouples modules such as device management from data storage, ensuring consistent data handling and supporting the integration and maintenance of diverse and evolving applications. The iterative development and evaluation process underlines the solution’s effectiveness in managing IoT environments in practice. The findings highlight the potential for these extensible modules to be applied in other contexts, promoting a standardized yet flexible approach to IoT data management, supporting effective database design, and deriving best practices and design guidance for future projects. Additionally, our models approach IoT heterogeneity and interoperability, demonstrating clear advantages in modularity and standardized data handling, essential for managing complex, real-world IoT deployments in Smart Farming.",
      "links": [
        {
          "label": "Full text",
          "url": "https://ceur-ws.org/Vol-3849/forum1.pdf",
          "kind": "full-text"
        },
        {
          "label": "Conference",
          "url": "https://resources.sei.cmu.edu/news-events/events/er2024/",
          "kind": "conference"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://ceur-ws.org/Vol-3849/forum1.pdf",
      "detailPath": "/publications/18466-extending-the-sensorthings-api-data-model-improving-interoperability-and-use-case-flexibility-in-iot",
      "apa7": "Arz von Straussenburg, A. F., Aldenhoff, T. T., & Riehle, D. M. (2024). Extending the SensorThings API Data Model – Improving Interoperability and Use Case Flexibility in IoT. In E. Gallinucci, H. Yasar, P. Chen, S. Liaskos, P. Marcel, S. Cesare, & F. Gailly (Eds.), ER 2024 : companion proceedings of the 43rd International Conference on Conceptual Modeling: ER Forum, Special Topics, Posters and Demos : Pittsburgh, Pennsylvania, USA, October 28-31, 2024 (pp. 1–14). CEUR/RWTH. https://ceur-ws.org/Vol-3849/forum1.pdf",
      "bibtex": "@inproceedings{Arz2024Extending,\n\taddress = {Aachen},\n\tauthor = {Arz von Straussenburg, Arnold F. and Aldenhoff, Timon T. and Riehle, Dennis M.},\n\tbooktitle = {ER 2024 : companion proceedings of the 43rd {International} {Conference} on {Conceptual} {Modeling}: ER {Forum}, {Special} {Topics}, {Posters} and {Demos} : Pittsburgh, {Pennsylvania}, {USA}, {October} 28-31, 2024},\n\teditor = {Gallinucci, Enrico and Yasar, Hasan and Chen, Peter and Liaskos, Sotirios and Marcel, Patrick and Cesare, Sergio and Gailly, Frederik},\n\tyear = {2024},\n\tpages = {1--14},\n\torganization = {CEUR/RWTH},\n\ttitle = {Extending the {SensorThings} {API} {Data} {Model} -- {Improving} {Interoperability} and {Use} {Case} {Flexibility} in {IoT}},\n\turl = {https://ceur-ws.org/Vol-3849/forum1.pdf},\n}"
    },
    {
      "id": 20971,
      "title": "Enabling Smart Collaboration Spaces in Organizations: Foundations and an Integrated IoT Architecture",
      "authors": "Mevludin Blazevic, Dennis M. Riehle",
      "authorNames": ["Blazevic, Mevludin", "Riehle, Dennis M."],
      "year": "2024",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Pacific-Asia Conference on Information Systems PACIS 2024 Proceedings. Ho Chi Minh City, Vietnam, July 1 - 5, 2024",
      "publisher": "Association for Information Systems/AIS eLibrary",
      "pages": null,
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://aisel.aisnet.org/pacis2024/track20_general/track20_general/12",
          "kind": "full-text"
        },
        {
          "label": "Conference",
          "url": "https://pacis2024.aisconferences.org/",
          "kind": "conference"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://aisel.aisnet.org/pacis2024/track20_general/track20_general/12",
      "detailPath": "/publications/20971-enabling-smart-collaboration-spaces-in-organizations-foundations-and-an-integrated-iot-architecture",
      "apa7": "Blazevic, M., & Riehle, D. M. (2024). Enabling Smart Collaboration Spaces in Organizations: Foundations and an Integrated IoT Architecture. In T. Q. Phan, B. Tan, L. Hoanh-Su, & N. H. Thuan (Eds.), Pacific-Asia Conference on Information Systems PACIS 2024 Proceedings. Ho Chi Minh City, Vietnam, July 1 - 5, 2024. Association for Information Systems/AIS eLibrary. https://aisel.aisnet.org/pacis2024/track20_general/track20_general/12",
      "bibtex": "@inproceedings{Blazevic2024Enabling,\n\taddress = {Atlanta, GA},\n\tauthor = {Blazevic, Mevludin and Riehle, Dennis M.},\n\tbooktitle = {Pacific-{Asia} {Conference} on {Information} {Systems} {PACIS} 2024 {Proceedings}. {Ho} {Chi} {Minh} {City}, {Vietnam}, {July} 1 - 5, 2024},\n\teditor = {Phan, Tuan Q. and Tan, Bernard and Hoanh-Su, Le and Thuan, Nguyen Hoang},\n\tyear = {2024},\n\torganization = {Association for Information Systems/AIS eLibrary},\n\ttitle = {Enabling {Smart} {Collaboration} {Spaces} in {Organizations}: Foundations and an {Integrated} {IoT} {Architecture}},\n\turl = {https://aisel.aisnet.org/pacis2024/track20_general/track20_general/12},\n}"
    },
    {
      "id": 14025,
      "title": "University of Things: Opportunities and Challenges for a Smart Campus Environment based on IoT Sensors and Business Processes",
      "authors": "Mevludin Blazevic, Dennis M. Riehle",
      "authorNames": ["Blazevic, Mevludin", "Riehle, Dennis M."],
      "year": "2023",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceedings of the 8th International Conference on Internet of Things, Big Data and Security  IoTBDS: Prague, Czech Republic; 21 to 23 April 2023",
      "publisher": "SciTePress",
      "pages": "105-114",
      "peerReviewed": "ja",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.5220/0011761900003482",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.5220/0011761900003482",
      "fullTextUrl": null,
      "detailPath": "/publications/14025-university-of-things-opportunities-and-challenges-for-a-smart-campus-environment-based-on-iot-sensors-and-business-processes",
      "apa7": "Blazevic, M., & Riehle, D. M. (2023). University of Things: Opportunities and Challenges for a Smart Campus Environment based on IoT Sensors and Business Processes. In G. Wills, L. Buttyán, P. Kacsuk, & V. Chang (Eds.), Proceedings of the 8th International Conference on Internet of Things, Big Data and Security  IoTBDS: Prague, Czech Republic; 21 to 23 April 2023 (pp. 105–114). SciTePress. https://doi.org/10.5220/0011761900003482",
      "bibtex": "@inproceedings{Blazevic2023University,\n\taddress = {Set{\\' u}bal},\n\tauthor = {Blazevic, Mevludin and Riehle, Dennis M.},\n\tbooktitle = {Proceedings of the 8th {International} {Conference} on {Internet} of {Things}, {Big} {Data} and {Security}  {IoTBDS}: Prague, {Czech} {Republic}; 21 to 23 {April} 2023},\n\tdoi = {10.5220/0011761900003482},\n\teditor = {Wills, Gary and Butty{\\' a}n, Levente and Kacsuk, P{\\' e}ter and Chang, Victor},\n\tisbn = {978-989-758-643-9},\n\tyear = {2023},\n\tpages = {105--114},\n\torganization = {SciTePress},\n\ttitle = {University of {Things}: Opportunities and {Challenges} for a {Smart} {Campus} {Environment} based on {IoT} {Sensors} and {Business} {Processes}},\n\turl = {https://doi.org/10.5220/0011761900003482},\n}"
    },
    {
      "id": 14030,
      "title": "On-Premise Internet of Things (IoT) Data Storage: Comparison of Database Management Systems",
      "authors": "Anna Wolters, Mevludin Blazevic, Dennis M. Riehle",
      "authorNames": [
        "Wolters, Anna",
        "Blazevic, Mevludin",
        "Riehle, Dennis M."
      ],
      "year": "2023",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceedings of the 8th International Conference on Internet of Things, Big Data and Security  IoTBDS: Prague, Czech Republic; 21 to 23 April 2023",
      "publisher": "SciTePress",
      "pages": "140-149",
      "peerReviewed": "ja",
      "access": "Restricted Access",
      "abstract": "The Internet of Things (IoT) connects millions of devices, leading to the production of vast amounts of data. For such data to be of value, efficient and effective data storage is of utmost importance. In this paper, we present a comparison of on-premise database management systems in the context of the IoT. We perform a market analysis on relational, Not Only SQL (NoSQL), and time-series database systems as well as a requirement analysis in order to comprehensively compare database systems based on functional and non-functional criteria. After an initial selection, we compare MySQL, PostgreSQL, Cassandra, MongoDB, InfluxDB, and QuestDB. As a result, we provide a best practice guide to support the decision-making on which database to select for an IoT use case.",
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.5220/0011851200003482",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.5220/0011851200003482",
      "fullTextUrl": null,
      "detailPath": "/publications/14030-on-premise-internet-of-things-iot-data-storage-comparison-of-database-management-systems",
      "apa7": "Wolters, A., Blazevic, M., & Riehle, D. M. (2023). On-Premise Internet of Things (IoT) Data Storage: Comparison of Database Management Systems. In G. Wills, L. Buttyán, P. Kacsuk, & V. Chang (Eds.), Proceedings of the 8th International Conference on Internet of Things, Big Data and Security  IoTBDS: Prague, Czech Republic; 21 to 23 April 2023 (pp. 140–149). SciTePress. https://doi.org/10.5220/0011851200003482",
      "bibtex": "@inproceedings{Wolters2023On,\n\taddress = {Set{\\' u}bal},\n\tauthor = {Wolters, Anna and Blazevic, Mevludin and Riehle, Dennis M.},\n\tbooktitle = {Proceedings of the 8th {International} {Conference} on {Internet} of {Things}, {Big} {Data} and {Security}  {IoTBDS}: Prague, {Czech} {Republic}; 21 to 23 {April} 2023},\n\tdoi = {10.5220/0011851200003482},\n\teditor = {Wills, Gary and Butty{\\' a}n, Levente and Kacsuk, P{\\' e}ter and Chang, Victor},\n\tisbn = {978-989-758-643-9},\n\tyear = {2023},\n\tpages = {140--149},\n\torganization = {SciTePress},\n\ttitle = {On-{Premise} {Internet} of {Things} ({IoT}) {Data} {Storage}: Comparison of {Database} {Management} {Systems}},\n\turl = {https://doi.org/10.5220/0011851200003482},\n}"
    },
    {
      "id": 14741,
      "title": "Measuring the Actual Office Workspace Utilization in a Desk Sharing Environment Based on IoT Sensors",
      "authors": "Arnold F. Arz von Straußenburg, Mevludin Blazevic, Dennis M. Riehle",
      "authorNames": [
        "Arz von Straußenburg, Arnold F.",
        "Blazevic, Mevludin",
        "Riehle, Dennis M."
      ],
      "year": "2023",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Design Science Research for a New Society: Society 5.0: 18th International Conference on Design Science Research in Information Systems and Technology, DESRIST 2023, Pretoria, South Africa, May 31 – June 2, 2023, Proceedings",
      "publisher": "Springer Nature Switzerland AG",
      "pages": "69-83",
      "peerReviewed": "ja",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-031-32808-4_5",
          "kind": "doi"
        },
        {
          "label": "Conference",
          "url": "https://desrist2023.org/",
          "kind": "conference"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-031-32808-4_5",
      "fullTextUrl": null,
      "detailPath": "/publications/14741-measuring-the-actual-office-workspace-utilization-in-a-desk-sharing-environment-based-on-iot-sensors",
      "apa7": "Arz von Straußenburg, A. F., Blazevic, M., & Riehle, D. M. (2023). Measuring the Actual Office Workspace Utilization in a Desk Sharing Environment Based on IoT Sensors. In A. Gerber & R. Baskerville (Eds.), Design Science Research for a New Society: Society 5.0: 18th International Conference on Design Science Research in Information Systems and Technology, DESRIST 2023, Pretoria, South Africa, May 31 – June 2, 2023, Proceedings (pp. 69–83). Springer Nature Switzerland AG. https://doi.org/10.1007/978-3-031-32808-4_5",
      "bibtex": "@inproceedings{Arz2023Measuring,\n\taddress = {Cham},\n\tauthor = {Arz von Strau\\ss{}enburg, Arnold F. and Blazevic, Mevludin and Riehle, Dennis M.},\n\tbooktitle = {Design {Science} {Research} for a {New} {Society}: Society 5.0: 18th {International} {Conference} on {Design} {Science} {Research} in {Information} {Systems} and {Technology}, {DESRIST} 2023, {Pretoria}, {South} {Africa}, {May} 31 -- {June} 2, 2023, {Proceedings}},\n\tdoi = {10.1007/978-3-031-32808-4_5},\n\teditor = {Gerber, Aurona and Baskerville, Richard},\n\tisbn = {978-3-031-32807-7},\n\tyear = {2023},\n\tpages = {69--83},\n\torganization = {Springer Nature Switzerland AG},\n\ttitle = {Measuring the {Actual} {Office} {Workspace} {Utilization} in a {Desk} {Sharing} {Environment} {Based} on {IoT} {Sensors}},\n\turl = {https://doi.org/10.1007/978-3-031-32808-4_5},\n}"
    },
    {
      "id": 15462,
      "title": "Designing Virtual Conference Venues Through Integration of Game Engine Technologies and Event Management Information Systems",
      "authors": "Anna Wolters, Nico Hakenes, Friedrich Chasin, Dennis M. Riehle",
      "authorNames": [
        "Wolters, Anna",
        "Hakenes, Nico",
        "Chasin, Friedrich",
        "Riehle, Dennis M."
      ],
      "year": "2023",
      "type": "Sonstiger Publikationstyp",
      "language": "en",
      "venue": "18th International Conference on Design Science Research in Information Systems and Technology DESRIST 2023",
      "publisher": null,
      "pages": "1-15",
      "peerReviewed": "ja",
      "access": null,
      "abstract": "In a human-centered society 5.0, participation in events such as trade fairs and academic conferences should fit the consumer’s profile and enable restriction-free participation by addressing potential economic, spatial, temporal, and individual constraints. Global challenges that have emerged or intensified in the past few years have caused a transformation in the event industry. Solutions that make the industry more resilient to future global challenges are now being explored. Within this transformation, the shift from physical to digital spaces gained importance. However, creating an environment that can satisfy the participants’ needs in interaction and immersion remains a challenge for both, academia and the event industry. This paper introduces an integration framework for game engine technologies and event management systems to enable restriction-free participation while strengthening the collaboration between participants in a virtual event. The use of the integration framework is demonstrated in an industry setting where a state-of-the-art game engine accessed through browser technologies is used to recreate a physical conference venue and populate it with content from an open-source event management information system.",
      "links": [
        {
          "label": "Conference",
          "url": "https://desrist2023.org/",
          "kind": "conference"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": null,
      "detailPath": "/publications/15462-designing-virtual-conference-venues-through-integration-of-game-engine-technologies-and-event-management-information-systems",
      "apa7": "Wolters, A., Hakenes, N., Chasin, F., & Riehle, D. M. (2023). Designing Virtual Conference Venues Through Integration of Game Engine Technologies and Event Management Information Systems. In 18th International Conference on Design Science Research in Information Systems and Technology DESRIST 2023 (pp. 1–15).",
      "bibtex": "@misc{Wolters2023Designing,\n\tauthor = {Wolters, Anna and Hakenes, Nico and Chasin, Friedrich and Riehle, Dennis M.},\n\tyear = {2023},\n\tpages = {1--15},\n\ttitle = {Designing {Virtual} {Conference} {Venues} {Through} {Integration} of {Game} {Engine} {Technologies} and {Event} {Management} {Information} {Systems}},\n}"
    },
    {
      "id": 16760,
      "title": "Sensor-based Use Case Advancements in Smart Parking - Pioneering the Next Generation of Smart City Applications",
      "authors": "Dennis Riehle, Arnold Arz von Straussenburg, Mevludin Blazevic, Anna Wolters",
      "authorNames": [
        "Riehle, Dennis",
        "Arz von Straussenburg, Arnold",
        "Blazevic, Mevludin",
        "Wolters, Anna"
      ],
      "year": "2023",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceedings of the 34th Australasian Conference on Information Systems ACIS 2023, 5-8 December 2023, Wellington, New Zealand",
      "publisher": "Association for Information Systems/AIS eLibrary",
      "pages": null,
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://aisel.aisnet.org/acis2023/127",
          "kind": "full-text"
        },
        {
          "label": "Conference",
          "url": "https://acis.aaisnet.org/",
          "kind": "conference"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://aisel.aisnet.org/acis2023/127",
      "detailPath": "/publications/16760-sensor-based-use-case-advancements-in-smart-parking-pioneering-the-next-generation-of-smart-city-applications",
      "apa7": "Riehle, D., Arz von Straussenburg, A., Blazevic, M., & Wolters, A. (2023). Sensor-based Use Case Advancements in Smart Parking - Pioneering the Next Generation of Smart City Applications. Proceedings of the 34th Australasian Conference on Information Systems ACIS 2023, 5-8 December 2023, Wellington, New Zealand. https://aisel.aisnet.org/acis2023/127",
      "bibtex": "@inproceedings{Riehle2023Sensor,\n\taddress = {Atlanta, GA},\n\tauthor = {Riehle, Dennis and Arz von Straussenburg, Arnold and Blazevic, Mevludin and Wolters, Anna},\n\tbooktitle = {Proceedings of the 34th {Australasian} {Conference} on {Information} {Systems} {ACIS} 2023, 5-8 {December} 2023, {Wellington}, {New} {Zealand}},\n\tyear = {2023},\n\torganization = {Association for Information Systems/AIS eLibrary},\n\ttitle = {Sensor-based {Use} {Case} {Advancements} in {Smart} {Parking} - {Pioneering} the {Next} {Generation} of {Smart} {City} {Applications}},\n\turl = {https://aisel.aisnet.org/acis2023/127},\n}"
    },
    {
      "id": 16430,
      "title": "Towards Hybrid Architectures: Integrating Large Language Models in Informative Chatbots",
      "authors": "Arnold F. Arz von Straussenburg, Anna Wolters",
      "authorNames": ["Arz von Straussenburg, Arnold F.", "Wolters, Anna"],
      "year": "2023",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Digital Responsibility: Social, Ethical, Ecological implications of IS: 18. Internationale Tagung Wirtschaftsinformatik WI 2023, Tagungsband; Paderborn; 18. - 21. September 2023",
      "publisher": "Association for Information Systems/AIS eLibrary",
      "pages": "133-133",
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://aisel.aisnet.org/wi2023/9",
          "kind": "full-text"
        },
        {
          "label": "Conference",
          "url": "https://wi2023.de/",
          "kind": "conference"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://aisel.aisnet.org/wi2023/9",
      "detailPath": "/publications/16430-towards-hybrid-architectures-integrating-large-language-models-in-informative-chatbots",
      "apa7": "Arz von Straussenburg, A. F., & Wolters, A. (2023). Towards Hybrid Architectures: Integrating Large Language Models in Informative Chatbots. In D. Beverungen, C. Lehrer, & M. Trier (Eds.), Digital Responsibility: Social, Ethical, Ecological implications of IS: 18. Internationale Tagung Wirtschaftsinformatik WI 2023, Tagungsband; Paderborn; 18. - 21. September 2023 (pp. 133–133). Association for Information Systems/AIS eLibrary. https://aisel.aisnet.org/wi2023/9",
      "bibtex": "@inproceedings{Arz2023Towards,\n\taddress = {Atlanta, GA},\n\tauthor = {Arz von Straussenburg, Arnold F. and Wolters, Anna},\n\tbooktitle = {Digital {Responsibility}: Social, {Ethical}, {Ecological} implications of {IS}: 18. {Internationale} {Tagung} {Wirtschaftsinformatik} {WI} 2023, {Tagungsband}; {Paderborn}; 18. - 21. {September} 2023},\n\teditor = {Beverungen, Daniel and Lehrer, Christiane and Trier, Matthias},\n\tyear = {2023},\n\tpages = {133--133},\n\torganization = {Association for Information Systems/AIS eLibrary},\n\ttitle = {Towards {Hybrid} {Architectures}: Integrating {Large} {Language} {Models} in {Informative} {Chatbots}},\n\turl = {https://aisel.aisnet.org/wi2023/9},\n}"
    },
    {
      "id": 12193,
      "title": "Incremental Machine Learning for Text Classification in Comment Moderation Systems",
      "authors": "Anna Wolters, Kilian Müller, Dennis M. Riehle",
      "authorNames": ["Wolters, Anna", "Müller, Kilian", "Riehle, Dennis M."],
      "year": "2022",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Disinformation in Open Online Media: 4th Multidisciplinary International Symposium, MISDOOM 2022, Boise, ID, USA, October 11–12, 2022, Proceedings",
      "publisher": "Gorgan University of Agricultural Sciences and Natural Resources",
      "pages": "138-153",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-031-18253-2_10",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-031-18253-2_10",
      "fullTextUrl": null,
      "detailPath": "/publications/12193-incremental-machine-learning-for-text-classification-in-comment-moderation-systems",
      "apa7": "Wolters, A., Müller, K., & Riehle, D. M. (2022). Incremental Machine Learning for Text Classification in Comment Moderation Systems. In F. Spezzano, A. Amaral, D. Ceolin, L. Fazio, & E. Serra (Eds.), Disinformation in Open Online Media: 4th Multidisciplinary International Symposium, MISDOOM 2022, Boise, ID, USA, October 11–12, 2022, Proceedings (pp. 138–153). Gorgan University of Agricultural Sciences and Natural Resources. https://doi.org/10.1007/978-3-031-18253-2_10",
      "bibtex": "@inproceedings{Wolters2022Incremental,\n\taddress = {Gorgan},\n\tauthor = {Wolters, Anna and M{\\\" u}ller, Kilian and Riehle, Dennis M.},\n\tbooktitle = {Disinformation in {Open} {Online} {Media}: 4th {Multidisciplinary} {International} {Symposium}, {MISDOOM} 2022, {Boise}, {ID}, {USA}, {October} 11--12, 2022, {Proceedings}},\n\tdoi = {10.1007/978-3-031-18253-2_10},\n\teditor = {Spezzano, Francesca and Amaral, Adriana and Ceolin, Davide and Fazio, Lisa and Serra, Edoardo},\n\tyear = {2022},\n\tpages = {138--153},\n\torganization = {{Gorgan University of Agricultural Sciences and Natural Resources}},\n\ttitle = {Incremental {Machine} {Learning} for {Text} {Classification} in {Comment} {Moderation} {Systems}},\n\turl = {https://doi.org/10.1007/978-3-031-18253-2_10},\n}"
    },
    {
      "id": 12194,
      "title": "Moderating the Good, the Bad, and the Hateful: Moderators’ Attitudes Towards ML-based Comment Moderation Support Systems",
      "authors": "Holger Koelmann, Kilian Müller, Marco Niemann, Dennis M. Riehle",
      "authorNames": [
        "Koelmann, Holger",
        "Müller, Kilian",
        "Niemann, Marco",
        "Riehle, Dennis M."
      ],
      "year": "2022",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Disinformation in Open Online Media: 4th Multidisciplinary International Symposium, MISDOOM 2022, Boise, ID, USA, October 11–12, 2022, Proceedings",
      "publisher": "Gorgan University of Agricultural Sciences and Natural Resources",
      "pages": "100-113",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-031-18253-2_7",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-031-18253-2_7",
      "fullTextUrl": null,
      "detailPath": "/publications/12194-moderating-the-good-the-bad-and-the-hateful-moderators-attitudes-towards-ml-based-comment-moderation-support-systems",
      "apa7": "Koelmann, H., Müller, K., Niemann, M., & Riehle, D. M. (2022). Moderating the Good, the Bad, and the Hateful: Moderators’ Attitudes Towards ML-based Comment Moderation Support Systems. In F. Spezzano, A. Amaral, D. Ceolin, L. Fazio, & E. Serra (Eds.), Disinformation in Open Online Media: 4th Multidisciplinary International Symposium, MISDOOM 2022, Boise, ID, USA, October 11–12, 2022, Proceedings (pp. 100–113). Gorgan University of Agricultural Sciences and Natural Resources. https://doi.org/10.1007/978-3-031-18253-2_7",
      "bibtex": "@inproceedings{Koelmann2022Moderating,\n\taddress = {Gorgan},\n\tauthor = {Koelmann, Holger and M{\\\" u}ller, Kilian and Niemann, Marco and Riehle, Dennis M.},\n\tbooktitle = {Disinformation in {Open} {Online} {Media}: 4th {Multidisciplinary} {International} {Symposium}, {MISDOOM} 2022, {Boise}, {ID}, {USA}, {October} 11--12, 2022, {Proceedings}},\n\tdoi = {10.1007/978-3-031-18253-2_7},\n\teditor = {Spezzano, Francesca and Amaral, Adriana and Ceolin, Davide and Fazio, Lisa and Serra, Edoardo},\n\tyear = {2022},\n\tpages = {100--113},\n\torganization = {{Gorgan University of Agricultural Sciences and Natural Resources}},\n\ttitle = {Moderating the {Good}, the {Bad}, and the {Hateful}: Moderators\\textquoteright{} {Attitudes} {Towards} {ML}-based {Comment} {Moderation} {Support} {Systems}},\n\turl = {https://doi.org/10.1007/978-3-031-18253-2_7},\n}"
    },
    {
      "id": 12214,
      "title": "(Semi-)Automatische Kommentarmoderation zur Erhaltung Konstruktiver Diskurse",
      "authors": "Marco Niemann, Dennis Assenmacher, Jens Brunk, Dennis M. Riehle, Jörg Becker",
      "authorNames": [
        "Niemann, Marco",
        "Assenmacher, Dennis",
        "Brunk, Jens",
        "Riehle, Dennis M.",
        "Becker, Jörg"
      ],
      "year": "2022",
      "type": "Sammelbandbeitrag",
      "language": "de",
      "venue": "Hate Speech: Definitionen, Ausprägungen, Lösungen",
      "publisher": "Springer VS",
      "pages": "249-274",
      "peerReviewed": null,
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-658-35658-3_13",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-658-35658-3_13",
      "fullTextUrl": null,
      "detailPath": "/publications/12214-semi-automatische-kommentarmoderation-zur-erhaltung-konstruktiver-diskurse",
      "apa7": "Niemann, M., Assenmacher, D., Brunk, J., Riehle, D. M., & Becker, J. (2022). (Semi-)Automatische Kommentarmoderation zur Erhaltung Konstruktiver Diskurse. In G. Weitzel & S. Mündges (Eds.), Hate Speech: Definitionen, Ausprägungen, Lösungen (pp. 249–274). Springer VS. https://doi.org/10.1007/978-3-658-35658-3_13",
      "bibtex": "@inbook{Niemann2022Semi,\n\taddress = {Wiesbaden},\n\tauthor = {Niemann, Marco and Assenmacher, Dennis and Brunk, Jens and Riehle, Dennis M. and Becker, J{\\\" o}rg},\n\tbooktitle = {Hate {Speech}: Definitionen, {Auspr}{\\\" a}gungen, {L}{\\\" o}sungen},\n\tdoi = {10.1007/978-3-658-35658-3_13},\n\teditor = {Weitzel, Gerrit and M{\\\" u}ndges, Stephan},\n\tisbn = {Niemann2022SKZ},\n\tyear = {2022},\n\tpages = {249--274},\n\tpublisher = {Springer VS},\n\ttitle = {({Semi}-){Automatische} {Kommentarmoderation} zur {Erhaltung} {Konstruktiver} {Diskurse}},\n\turl = {https://doi.org/10.1007/978-3-658-35658-3_13},\n}"
    },
    {
      "id": 12216,
      "title": "The Diagramed Model Query Language 2.0: Design, Implementation, and Evaluation",
      "authors": "Patrick Delfmann, Dennis M. Riehle, Steffen Höhenberger, Carl Corea, Christoph Drodt",
      "authorNames": [
        "Delfmann, Patrick",
        "Riehle, Dennis M.",
        "Höhenberger, Steffen",
        "Corea, Carl",
        "Drodt, Christoph"
      ],
      "year": "2022",
      "type": "Sammelbandbeitrag",
      "language": "en",
      "venue": "Process Querying Methods",
      "publisher": "Gorgan University of Agricultural Sciences and Natural Resources",
      "pages": "115-148",
      "peerReviewed": null,
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-030-92875-9_5",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-030-92875-9_5",
      "fullTextUrl": null,
      "detailPath": "/publications/12216-the-diagramed-model-query-language-2-0-design-implementation-and-evaluation",
      "apa7": "Delfmann, P., Riehle, D. M., Höhenberger, S., Corea, C., & Drodt, C. (2022). The Diagramed Model Query Language 2.0: Design, Implementation, and Evaluation. In A. Polyvyanyy (Ed.), Process Querying Methods (pp. 115–148). Gorgan University of Agricultural Sciences and Natural Resources. https://doi.org/10.1007/978-3-030-92875-9_5",
      "bibtex": "@inbook{Delfmann2022Diagramed,\n\taddress = {Gorgan},\n\tauthor = {Delfmann, Patrick and Riehle, Dennis M. and H{\\\" o}henberger, Steffen and Corea, Carl and Drodt, Christoph},\n\tbooktitle = {Process {Querying} {Methods}},\n\tdoi = {10.1007/978-3-030-92875-9_5},\n\teditor = {Polyvyanyy, Artem},\n\tyear = {2022},\n\tpages = {115--148},\n\tpublisher = {{Gorgan University of Agricultural Sciences and Natural Resources}},\n\ttitle = {The {Diagramed} {Model} {Query} {Language} 2.0: Design, {Implementation}, and {Evaluation}},\n\turl = {https://doi.org/10.1007/978-3-030-92875-9_5},\n}"
    },
    {
      "id": 12238,
      "title": "Review of Design-Oriented Green Information Systems Research",
      "authors": "Alfred Benedikt Brendel, Friedrich Chasin, Milad Mirbabaie, Dennis M. Riehle, Christine Harnischmacher",
      "authorNames": [
        "Brendel, Alfred Benedikt",
        "Chasin, Friedrich",
        "Mirbabaie, Milad",
        "Riehle, Dennis M.",
        "Harnischmacher, Christine"
      ],
      "year": "2022",
      "type": "Journalartikel",
      "language": "en",
      "venue": "Sustainability",
      "publisher": null,
      "pages": null,
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.3390/su14084650",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.3390/su14084650",
      "fullTextUrl": null,
      "detailPath": "/publications/12238-review-of-design-oriented-green-information-systems-research",
      "apa7": "Brendel, A. B., Chasin, F., Mirbabaie, M., Riehle, D. M., & Harnischmacher, C. (2022). Review of Design-Oriented Green Information Systems Research. Sustainability, 14(4). https://doi.org/10.3390/su14084650",
      "bibtex": "@article{Brendel2022Review,\n\tauthor = {Brendel, Alfred Benedikt and Chasin, Friedrich and Mirbabaie, Milad and Riehle, Dennis M. and Harnischmacher, Christine},\n\tjournal = {Sustainability},\n\tdoi = {10.3390/su14084650},\n\tnumber = {4},\n\tyear = {2022},\n\ttitle = {Review of {Design}-{Oriented} {Green} {Information} {Systems} {Research}},\n\turl = {https://doi.org/10.3390/su14084650},\n\thowpublished = {https://doi.org/10.3390/su14084650},\n\tvolume = {14},\n}"
    },
    {
      "id": 12183,
      "title": "One-click Application Deployment - An Approach for Automated Deployment of Instantiable Cross-platform Mobile Applications",
      "authors": "Arnold Arz Von Straussenburg, Friedrich Chasin",
      "authorNames": ["Arz Von Straussenburg, Arnold", "Chasin, Friedrich"],
      "year": "2022",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceedings of the 55th Hawaii International Conference on System Sciences HICSS 2022; Virtual Event; Maui, Hawaii, USA; January 4-7, 2022",
      "publisher": "University of Hawaii at Manoa",
      "pages": "7752-7761",
      "peerReviewed": "nein",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.24251/HICSS.2022.932",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.24251/HICSS.2022.932",
      "fullTextUrl": null,
      "detailPath": "/publications/12183-one-click-application-deployment-an-approach-for-automated-deployment-of-instantiable-cross-platform-mobile-applications",
      "apa7": "Arz Von Straussenburg, A., & Chasin, F. (2022). One-click Application Deployment - An Approach for Automated Deployment of Instantiable Cross-platform Mobile Applications. In T. X. Bui (Ed.), Proceedings of the 55th Hawaii International Conference on System Sciences HICSS 2022; Virtual Event; Maui, Hawaii, USA; January 4-7, 2022 (pp. 7752–7761). University of Hawaii at Manoa. https://doi.org/10.24251/HICSS.2022.932",
      "bibtex": "@inproceedings{Arz2022One,\n\taddress = {Honolulu, HI},\n\tauthor = {Arz Von Straussenburg, Arnold and Chasin, Friedrich},\n\tbooktitle = {Proceedings of the 55th {Hawaii} {International} {Conference} on {System} {Sciences} {HICSS} 2022; {Virtual} {Event}; {Maui}, {Hawaii}, {USA}; {January} 4-7, 2022},\n\tdoi = {10.24251/HICSS.2022.932},\n\teditor = {Bui, Tung X.},\n\tisbn = {978-0-9981331-5-7},\n\tyear = {2022},\n\tpages = {7752--7761},\n\torganization = {University of Hawaii at Manoa},\n\ttitle = {One-click {Application} {Deployment} - {An} {Approach} for {Automated} {Deployment} of {Instantiable} {Cross}-platform {Mobile} {Applications}},\n\turl = {https://doi.org/10.24251/HICSS.2022.932},\n}"
    },
    {
      "id": 13804,
      "title": "RP-Mod & RP-Crowd: Moderator- and Crowd-Annotated German News Comment Datasets",
      "authors": "Dennis Assenmacher, Marco Niemann, Kilian Müller, Moritz V. Seiler, Dennis M. Riehle, Heike Trautmann",
      "authorNames": [
        "Assenmacher, Dennis",
        "Niemann, Marco",
        "Müller, Kilian",
        "Seiler, Moritz V.",
        "Riehle, Dennis M.",
        "Trautmann, Heike"
      ],
      "year": "2021",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceedings of the Neural Information Processing Systems Track on Datasets and Benchmarks 1 (NeurIPS Datasets and Benchmarks 2021)",
      "publisher": "Curran Associates",
      "pages": "1-14",
      "peerReviewed": "ja",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://datasets-benchmarks-proceedings.neurips.cc/paper/2021/hash/c9e1074f5b3f9fc8ea15d152add07294-Abstract-round2.html",
          "kind": "full-text"
        },
        {
          "label": "DOI",
          "url": "https://doi.org/10.5281/zenodo.5291339",
          "kind": "doi"
        },
        {
          "label": "Conference",
          "url": "https://neurips.cc/virtual/2021/events/Datasets%20and%20Benchmarks",
          "kind": "conference"
        }
      ],
      "doiUrl": "https://doi.org/10.5281/zenodo.5291339",
      "fullTextUrl": "https://datasets-benchmarks-proceedings.neurips.cc/paper/2021/hash/c9e1074f5b3f9fc8ea15d152add07294-Abstract-round2.html",
      "detailPath": "/publications/13804-rp-mod-rp-crowd-moderator-and-crowd-annotated-german-news-comment-datasets",
      "apa7": "Assenmacher, D., Niemann, M., Müller, K., Seiler, M. V., Riehle, D. M., & Trautmann, H. (2021). RP-Mod & RP-Crowd: Moderator- and Crowd-Annotated German News Comment Datasets. In J. Vanschoren & S. Yeung (Eds.), Proceedings of the Neural Information Processing Systems Track on Datasets and Benchmarks 1 (NeurIPS Datasets and Benchmarks 2021) (pp. 1–14). Curran Associates. https://doi.org/10.5281/zenodo.5291339",
      "bibtex": "@inproceedings{Assenmacher2021RP,\n\taddress = {Red Hook, NY},\n\tauthor = {Assenmacher, Dennis and Niemann, Marco and M{\\\" u}ller, Kilian and Seiler, Moritz V. and Riehle, Dennis M. and Trautmann, Heike},\n\tbooktitle = {Proceedings of the {Neural} {Information} {Processing} {Systems} {Track} on {Datasets} and {Benchmarks} 1 ({NeurIPS} {Datasets} and {Benchmarks} 2021)},\n\tdoi = {10.5281/zenodo.5291339},\n\teditor = {Vanschoren, Joaquin and Yeung, Serena},\n\tyear = {2021},\n\tpages = {1--14},\n\torganization = {Curran Associates},\n\ttitle = {RP-{Mod} \\& {RP}-{Crowd}: Moderator- and {Crowd}-{Annotated} {German} {News} {Comment} {Datasets}},\n\turl = {https://datasets-benchmarks-proceedings.neurips.cc/paper/2021/hash/c9e1074f5b3f9fc8ea15d152add07294-Abstract-round2.html},\n}"
    },
    {
      "id": 8727,
      "title": "Abusive Comments in Online Media and How to Fight Them: State of the Domain and a Call to Action",
      "authors": "Marco Niemann, Jens Welsing, Dennis M. Riehle, Jens Brunk, Dennis Assenmacher, Jörg Becker",
      "authorNames": [
        "Niemann, Marco",
        "Welsing, Jens",
        "Riehle, Dennis M.",
        "Brunk, Jens",
        "Assenmacher, Dennis",
        "Becker, Jörg"
      ],
      "year": "2020",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Disinformation in Open Online Media: Second Multidisciplinary International Symposium, MISDOOM 2020, Leiden, The Netherlands, October 26–27, 2020, Proceedings",
      "publisher": "Gorgan University of Agricultural Sciences and Natural Resources",
      "pages": "122-137",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-030-61841-4_9",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-030-61841-4_9",
      "fullTextUrl": null,
      "detailPath": "/publications/8727-abusive-comments-in-online-media-and-how-to-fight-them-state-of-the-domain-and-a-call-to-action",
      "apa7": "Niemann, M., Welsing, J., Riehle, D. M., Brunk, J., Assenmacher, D., & Becker, J. (2020). Abusive Comments in Online Media and How to Fight Them: State of the Domain and a Call to Action. Disinformation in Open Online Media: Second Multidisciplinary International Symposium, MISDOOM 2020, Leiden, The Netherlands, October 26–27, 2020, Proceedings, 122–137. https://doi.org/10.1007/978-3-030-61841-4_9",
      "bibtex": "@inproceedings{Niemann2020Abusive,\n\taddress = {Gorgan},\n\tauthor = {Niemann, Marco and Welsing, Jens and Riehle, Dennis M. and Brunk, Jens and Assenmacher, Dennis and Becker, J{\\\" o}rg},\n\tbooktitle = {Disinformation in {Open} {Online} {Media}: Second {Multidisciplinary} {International} {Symposium}, {MISDOOM} 2020, {Leiden}, {The} {Netherlands}, {October} 26--27, 2020, {Proceedings}},\n\tdoi = {10.1007/978-3-030-61841-4_9},\n\tisbn = {978-3-030-61840-7},\n\tyear = {2020},\n\tpages = {122--137},\n\torganization = {{Gorgan University of Agricultural Sciences and Natural Resources}},\n\ttitle = {Abusive {Comments} in {Online} {Media} and {How} to {Fight} {Them}: State of the {Domain} and a {Call} to {Action}},\n\turl = {https://doi.org/10.1007/978-3-030-61841-4_9},\n}"
    },
    {
      "id": 8728,
      "title": "FakeYou! - A Gamified Approach for Building and Evaluating Resilience Against Fake News",
      "authors": "Lena Clever, Dennis Assenmacher, Kilian Müller, Moritz Vinzent Seiler, Dennis M. Riehle, Mike Preuss, Christian Grimme",
      "authorNames": [
        "Clever, Lena",
        "Assenmacher, Dennis",
        "Müller, Kilian",
        "Seiler, Moritz Vinzent",
        "Riehle, Dennis M.",
        "Preuss, Mike",
        "Grimme, Christian"
      ],
      "year": "2020",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Disinformation in Open Online Media: Second Multidisciplinary International Symposium, MISDOOM 2020, Leiden, The Netherlands, October 26–27, 2020, Proceedings",
      "publisher": "Gorgan University of Agricultural Sciences and Natural Resources",
      "pages": "218-232",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-030-61841-4_15",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-030-61841-4_15",
      "fullTextUrl": null,
      "detailPath": "/publications/8728-fakeyou-a-gamified-approach-for-building-and-evaluating-resilience-against-fake-news",
      "apa7": "Clever, L., Assenmacher, D., Müller, K., Seiler, M. V., Riehle, D. M., Preuss, M., & Grimme, C. (2020). FakeYou! - A Gamified Approach for Building and Evaluating Resilience Against Fake News. Disinformation in Open Online Media: Second Multidisciplinary International Symposium, MISDOOM 2020, Leiden, The Netherlands, October 26–27, 2020, Proceedings, 218–232. https://doi.org/10.1007/978-3-030-61841-4_15",
      "bibtex": "@inproceedings{Clever2020FakeYou,\n\taddress = {Gorgan},\n\tauthor = {Clever, Lena and Assenmacher, Dennis and M{\\\" u}ller, Kilian and Seiler, Moritz Vinzent and Riehle, Dennis M. and Preuss, Mike and Grimme, Christian},\n\tbooktitle = {Disinformation in {Open} {Online} {Media}: Second {Multidisciplinary} {International} {Symposium}, {MISDOOM} 2020, {Leiden}, {The} {Netherlands}, {October} 26--27, 2020, {Proceedings}},\n\tdoi = {10.1007/978-3-030-61841-4_15},\n\tisbn = {978-3-030-61840-7},\n\tyear = {2020},\n\tpages = {218--232},\n\torganization = {{Gorgan University of Agricultural Sciences and Natural Resources}},\n\ttitle = {FakeYou! - {A} {Gamified} {Approach} for {Building} and {Evaluating} {Resilience} {Against} {Fake} {News}},\n\turl = {https://doi.org/10.1007/978-3-030-61841-4_15},\n}"
    },
    {
      "id": 8729,
      "title": "Building an Integrated Comment Moderation System - Towards a Semi-Automatic Moderation Tool",
      "authors": "Dennis M. Riehle, Marco Niemann, Jens Brunk, Dennis Assenmacher, Heike Trautmann, Jörg Becker",
      "authorNames": [
        "Riehle, Dennis M.",
        "Niemann, Marco",
        "Brunk, Jens",
        "Assenmacher, Dennis",
        "Trautmann, Heike",
        "Becker, Jörg"
      ],
      "year": "2020",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Social Computing and Social Media. Participation, User Experience, Consumer Experience, and Applications of Social Computing: 12th International Conference, SCSM 2020, Held as Part of the 22nd HCI International Conference, HCII 2020, Copenhagen, Denmark, July 19–24, 2020, Proceedings, Part II",
      "publisher": "Gorgan University of Agricultural Sciences and Natural Resources",
      "pages": "keine Angaben-keine Angaben",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-030-49576-3_6",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-030-49576-3_6",
      "fullTextUrl": null,
      "detailPath": "/publications/8729-building-an-integrated-comment-moderation-system-towards-a-semi-automatic-moderation-tool",
      "apa7": "Riehle, D. M., Niemann, M., Brunk, J., Assenmacher, D., Trautmann, H., & Becker, J. (2020). Building an Integrated Comment Moderation System - Towards a Semi-Automatic Moderation Tool. In G. Meiselwitz (Ed.), Social Computing and Social Media. Participation, User Experience, Consumer Experience, and Applications of Social Computing: 12th International Conference, SCSM 2020, Held as Part of the 22nd HCI International Conference, HCII 2020, Copenhagen, Denmark, July 19–24, 2020, Proceedings, Part II (p. keine Angaben-keine Angaben). Gorgan University of Agricultural Sciences and Natural Resources. https://doi.org/10.1007/978-3-030-49576-3_6",
      "bibtex": "@inproceedings{Riehle2020Building,\n\taddress = {Gorgan},\n\tauthor = {Riehle, Dennis M. and Niemann, Marco and Brunk, Jens and Assenmacher, Dennis and Trautmann, Heike and Becker, J{\\\" o}rg},\n\tbooktitle = {Social {Computing} and {Social} {Media}. {Participation}, {User} {Experience}, {Consumer} {Experience}, and {Applications} of {Social} {Computing}: 12th {International} {Conference}, {SCSM} 2020, {Held} as {Part} of the 22nd {HCI} {International} {Conference}, {HCII} 2020, {Copenhagen}, {Denmark}, {July} 19--24, 2020, {Proceedings}, {Part} {II}},\n\tdoi = {10.1007/978-3-030-49576-3_6},\n\teditor = {Meiselwitz, Gabriele},\n\tisbn = {978-3-030-49575-6},\n\tyear = {2020},\n\tpages = {keine Angaben--keine Angaben},\n\torganization = {{Gorgan University of Agricultural Sciences and Natural Resources}},\n\ttitle = {Building an {Integrated} {Comment} {Moderation} {System} - {Towards} a {Semi}-{Automatic} {Moderation} {Tool}},\n\turl = {https://doi.org/10.1007/978-3-030-49576-3_6},\n}"
    },
    {
      "id": 8812,
      "title": "Do not disturb!: trust in decision support systems improves work outcomes under certain conditions",
      "authors": "Lea S. Müller, Sarah M. Meeßen, Meinald T. Thielsch, Christoph Nohe, Dennis M. Riehle, Guido Hertel",
      "authorNames": [
        "Müller, Lea S.",
        "Meeßen, Sarah M.",
        "Thielsch, Meinald T.",
        "Nohe, Christoph",
        "Riehle, Dennis M.",
        "Hertel, Guido"
      ],
      "year": "2020",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceedings of the Conference on Mensch und Computer MuC 2020 held from September 6 to 9, 2020 at the University of Magdeburg",
      "publisher": "ACM Association for Computing Machinery",
      "pages": "229-237",
      "peerReviewed": "nein",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://dl.acm.org/doi/pdf/10.1145/3404983.3405515",
          "kind": "full-text"
        },
        {
          "label": "DOI",
          "url": "https://doi.org/10.1145/3404983.3405515",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1145/3404983.3405515",
      "fullTextUrl": "https://dl.acm.org/doi/pdf/10.1145/3404983.3405515",
      "detailPath": "/publications/8812-do-not-disturb-trust-in-decision-support-systems-improves-work-outcomes-under-certain-conditions",
      "apa7": "Müller, L. S., Meeßen, S. M., Thielsch, M. T., Nohe, C., Riehle, D. M., & Hertel, G. (2020). Do not disturb!: trust in decision support systems improves work outcomes under certain conditions. Proceedings of the Conference on Mensch Und Computer MuC 2020 Held from September 6 to 9, 2020 at the University of Magdeburg, 229–237. https://doi.org/10.1145/3404983.3405515",
      "bibtex": "@inproceedings{Muller2020Do,\n\taddress = {New York, NY},\n\tauthor = {M{\\\" u}ller, Lea S. and Mee\\ss{}en, Sarah M. and Thielsch, Meinald T. and Nohe, Christoph and Riehle, Dennis M. and Hertel, Guido},\n\tbooktitle = {Proceedings of the {Conference} on {Mensch} und {Computer} {MuC} 2020 held from {September} 6 to 9, 2020 at the {University} of {Magdeburg}},\n\tdoi = {10.1145/3404983.3405515},\n\tisbn = {978-1-4503-7540-5},\n\tyear = {2020},\n\tpages = {229--237},\n\torganization = {ACM Association for Computing Machinery},\n\ttitle = {Do not disturb!: trust in decision support systems improves work outcomes under certain conditions},\n\turl = {https://dl.acm.org/doi/pdf/10.1145/3404983.3405515},\n}"
    },
    {
      "id": 8829,
      "title": "Trust is essential: Positive effects of information systems on users’ memory require trust in the system",
      "authors": "Sarah M. Meeßen, Meinald T. Thielsch, Dennis M. Riehle, Guido Hertel",
      "authorNames": [
        "Meeßen, Sarah M.",
        "Thielsch, Meinald T.",
        "Riehle, Dennis M.",
        "Hertel, Guido"
      ],
      "year": "2020",
      "type": "Journalartikel",
      "language": "en",
      "venue": "Ergonomics",
      "publisher": null,
      "pages": "909-926",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1080/00140139.2020.1758797",
          "kind": "doi"
        },
        {
          "label": "ISSN",
          "url": "https://portal.issn.org/resource/ISSN/0014-0139",
          "kind": "external"
        },
        {
          "label": "eISSN",
          "url": "https://portal.issn.org/resource/ISSN/1366-5847",
          "kind": "external"
        }
      ],
      "doiUrl": "https://doi.org/10.1080/00140139.2020.1758797",
      "fullTextUrl": null,
      "detailPath": "/publications/8829-trust-is-essential-positive-effects-of-information-systems-on-users-memory-require-trust-in-the-system",
      "apa7": "Meeßen, S. M., Thielsch, M. T., Riehle, D. M., & Hertel, G. (2020). Trust is essential: Positive effects of information systems on users’ memory require trust in the system. Ergonomics, 63(7), 909–926. https://doi.org/10.1080/00140139.2020.1758797",
      "bibtex": "@article{Meeen2020Trust,\n\tauthor = {Mee\\ss{}en, Sarah M. and Thielsch, Meinald T. and Riehle, Dennis M. and Hertel, Guido},\n\tjournal = {Ergonomics},\n\tdoi = {10.1080/00140139.2020.1758797},\n\tnumber = {7},\n\tyear = {2020},\n\tpages = {909--926},\n\ttitle = {Trust is essential: Positive effects of information systems on users\\textquoteright{} memory require trust in the system},\n\turl = {https://doi.org/10.1080/00140139.2020.1758797},\n\thowpublished = {https://doi.org/10.1080/00140139.2020.1758797},\n\tvolume = {63},\n}"
    },
    {
      "id": 8732,
      "title": "Checking Business Process Models for Compliance - Comparing Graph Matching and Temporal Logic",
      "authors": "Dennis M. Riehle",
      "authorNames": ["Riehle, Dennis M."],
      "year": "2019",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Business Process Management Workshops: BPM 2018 International Workshops, Sydney, NSW, Australia, September 9-14, 2018, Revised Papers",
      "publisher": "Gorgan University of Agricultural Sciences and Natural Resources",
      "pages": "403-415",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-030-11641-5_32",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-030-11641-5_32",
      "fullTextUrl": null,
      "detailPath": "/publications/8732-checking-business-process-models-for-compliance-comparing-graph-matching-and-temporal-logic",
      "apa7": "Riehle, D. M. (2019). Checking Business Process Models for Compliance - Comparing Graph Matching and Temporal Logic. Business Process Management Workshops: BPM 2018 International Workshops, Sydney, NSW, Australia, September 9-14, 2018, Revised Papers, 403–415. https://doi.org/10.1007/978-3-030-11641-5_32",
      "bibtex": "@inproceedings{Riehle2019Checking,\n\taddress = {Gorgan},\n\tauthor = {Riehle, Dennis M.},\n\tbooktitle = {Business {Process} {Management} {Workshops}: BPM 2018 {International} {Workshops}, {Sydney}, {NSW}, {Australia}, {September} 9-14, 2018, {Revised} {Papers}},\n\tdoi = {10.1007/978-3-030-11641-5_32},\n\tisbn = {978-3-030-11640-8},\n\tyear = {2019},\n\tpages = {403--415},\n\torganization = {{Gorgan University of Agricultural Sciences and Natural Resources}},\n\ttitle = {Checking {Business} {Process} {Models} for {Compliance} - {Comparing} {Graph} {Matching} and {Temporal} {Logic}},\n\turl = {https://doi.org/10.1007/978-3-030-11641-5_32},\n}"
    },
    {
      "id": 8806,
      "title": "Can Analytics as a Service Save the Online Discussion Culture? - The Case of Comment Moderation in the Media Industry",
      "authors": "Jens Brunk, Marco Niemann, Dennis M. Riehle",
      "authorNames": ["Brunk, Jens", "Niemann, Marco", "Riehle, Dennis M."],
      "year": "2019",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceedings of the 21st IEEE Conference on Business Informatics CBI 2019: 15 - 17 July 2019; Moscow, Russia",
      "publisher": "IEEE Computer Society",
      "pages": "472-481",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1109/CBI.2019.00061",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1109/CBI.2019.00061",
      "fullTextUrl": null,
      "detailPath": "/publications/8806-can-analytics-as-a-service-save-the-online-discussion-culture-the-case-of-comment-moderation-in-the-media-industry",
      "apa7": "Brunk, J., Niemann, M., & Riehle, D. M. (2019). Can Analytics as a Service Save the Online Discussion Culture? - The Case of Comment Moderation in the Media Industry. Proceedings of the 21st IEEE Conference on Business Informatics CBI 2019: 15 - 17 July 2019; Moscow, Russia, 472–481. https://doi.org/10.1109/CBI.2019.00061",
      "bibtex": "@inproceedings{Brunk2019Can,\n\taddress = {Los Alamitos, CA},\n\tauthor = {Brunk, Jens and Niemann, Marco and Riehle, Dennis M.},\n\tbooktitle = {Proceedings of the 21st {IEEE} {Conference} on {Business} {Informatics} {CBI} 2019: 15 - 17 {July} 2019; {Moscow}, {Russia}},\n\tdoi = {10.1109/CBI.2019.00061},\n\tisbn = {978-1-7281-0650-2},\n\tyear = {2019},\n\tpages = {472--481},\n\torganization = {IEEE Computer Society},\n\ttitle = {Can {Analytics} as a {Service} {Save} the {Online} {Discussion} {Culture}? - {The} {Case} of {Comment} {Moderation} in the {Media} {Industry}},\n\turl = {https://doi.org/10.1109/CBI.2019.00061},\n}"
    },
    {
      "id": 8807,
      "title": "Effect of Transparency and Trust on Acceptance of Automatic Online Comment Moderation Systems",
      "authors": "Jens Brunk, Jana Mattern, Dennis M. Riehle",
      "authorNames": ["Brunk, Jens", "Mattern, Jana", "Riehle, Dennis M."],
      "year": "2019",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceedings of the 21st IEEE Conference on Business Informatics CBI 2019: 15 - 17 July 2019; Moscow, Russia",
      "publisher": "IEEE Computer Society",
      "pages": "429-435",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1109/CBI.2019.00056",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1109/CBI.2019.00056",
      "fullTextUrl": null,
      "detailPath": "/publications/8807-effect-of-transparency-and-trust-on-acceptance-of-automatic-online-comment-moderation-systems",
      "apa7": "Brunk, J., Mattern, J., & Riehle, D. M. (2019). Effect of Transparency and Trust on Acceptance of Automatic Online Comment Moderation Systems. Proceedings of the 21st IEEE Conference on Business Informatics CBI 2019: 15 - 17 July 2019; Moscow, Russia, 429–435. https://doi.org/10.1109/CBI.2019.00056",
      "bibtex": "@inproceedings{Brunk2019Effect,\n\taddress = {Los Alamitos, CA},\n\tauthor = {Brunk, Jens and Mattern, Jana and Riehle, Dennis M.},\n\tbooktitle = {Proceedings of the 21st {IEEE} {Conference} on {Business} {Informatics} {CBI} 2019: 15 - 17 {July} 2019; {Moscow}, {Russia}},\n\tdoi = {10.1109/CBI.2019.00056},\n\tisbn = {978-1-7281-0650-2},\n\tyear = {2019},\n\tpages = {429--435},\n\torganization = {IEEE Computer Society},\n\ttitle = {Effect of {Transparency} and {Trust} on {Acceptance} of {Automatic} {Online} {Comment} {Moderation} {Systems}},\n\turl = {https://doi.org/10.1109/CBI.2019.00056},\n}"
    },
    {
      "id": 8808,
      "title": "Which Business Information do Decision-Makers need at Work? - Towards a Classification Framework",
      "authors": "Dennis M. Riehle, Jonathan Radas",
      "authorNames": ["Riehle, Dennis M.", "Radas, Jonathan"],
      "year": "2019",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceedings of the 21st IEEE Conference on Business Informatics CBI 2019: 15 - 17 July 2019; Moscow, Russia",
      "publisher": "IEEE Computer Society",
      "pages": "312-139",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1109/CBI.2019.00042",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1109/CBI.2019.00042",
      "fullTextUrl": null,
      "detailPath": "/publications/8808-which-business-information-do-decision-makers-need-at-work-towards-a-classification-framework",
      "apa7": "Riehle, D. M., & Radas, J. (2019). Which Business Information do Decision-Makers need at Work? - Towards a Classification Framework. Proceedings of the 21st IEEE Conference on Business Informatics CBI 2019: 15 - 17 July 2019; Moscow, Russia, 312–139. https://doi.org/10.1109/CBI.2019.00042",
      "bibtex": "@inproceedings{Riehle2019Which,\n\taddress = {Los Alamitos, CA},\n\tauthor = {Riehle, Dennis M. and Radas, Jonathan},\n\tbooktitle = {Proceedings of the 21st {IEEE} {Conference} on {Business} {Informatics} {CBI} 2019: 15 - 17 {July} 2019; {Moscow}, {Russia}},\n\tdoi = {10.1109/CBI.2019.00042},\n\tisbn = {978-1-7281-0650-2},\n\tyear = {2019},\n\tpages = {312--139},\n\torganization = {IEEE Computer Society},\n\ttitle = {Which {Business} {Information} do {Decision}-{Makers} need at {Work}? - {Towards} a {Classification} {Framework}},\n\turl = {https://doi.org/10.1109/CBI.2019.00042},\n}"
    },
    {
      "id": 8828,
      "title": "Directed Forgetting in Organizations: The Positive Effects of Decision Support Systems on Mental Resources and Well-being",
      "authors": "Guido Hertel, Sarah M. Meeßen, Dennis M. Riehle, Meinald T. Thielsch, Christoph Nohe, Jörg Becker",
      "authorNames": [
        "Hertel, Guido",
        "Meeßen, Sarah M.",
        "Riehle, Dennis M.",
        "Thielsch, Meinald T.",
        "Nohe, Christoph",
        "Becker, Jörg"
      ],
      "year": "2019",
      "type": "Journalartikel",
      "language": "en",
      "venue": "Ergonomics",
      "publisher": null,
      "pages": "597-611",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1080/00140139.2019.1574361",
          "kind": "doi"
        },
        {
          "label": "ISSN",
          "url": "https://portal.issn.org/resource/ISSN/0014-0139",
          "kind": "external"
        },
        {
          "label": "eISSN",
          "url": "https://portal.issn.org/resource/ISSN/1366-5847",
          "kind": "external"
        }
      ],
      "doiUrl": "https://doi.org/10.1080/00140139.2019.1574361",
      "fullTextUrl": null,
      "detailPath": "/publications/8828-directed-forgetting-in-organizations-the-positive-effects-of-decision-support-systems-on-mental-resources-and-well-being",
      "apa7": "Hertel, G., Meeßen, S. M., Riehle, D. M., Thielsch, M. T., Nohe, C., & Becker, J. (2019). Directed Forgetting in Organizations: The Positive Effects of Decision Support Systems on Mental Resources and Well-being. Ergonomics, 62(5), 597–611. https://doi.org/10.1080/00140139.2019.1574361",
      "bibtex": "@article{Hertel2019Directed,\n\tauthor = {Hertel, Guido and Mee\\ss{}en, Sarah M. and Riehle, Dennis M. and Thielsch, Meinald T. and Nohe, Christoph and Becker, J{\\\" o}rg},\n\tjournal = {Ergonomics},\n\tdoi = {10.1080/00140139.2019.1574361},\n\tnumber = {5},\n\tyear = {2019},\n\tpages = {597--611},\n\ttitle = {Directed {Forgetting} in {Organizations}: The {Positive} {Effects} of {Decision} {Support} {Systems} on {Mental} {Resources} and {Well}-being},\n\turl = {https://doi.org/10.1080/00140139.2019.1574361},\n\thowpublished = {https://doi.org/10.1080/00140139.2019.1574361},\n\tvolume = {62},\n}"
    },
    {
      "id": 8841,
      "title": "A Web-Based Information System to Evaluate Different Versions of IT Artifacts in Online Experiments",
      "authors": "Dennis M. Riehle, Stefan Fleischer, Jörg Becker",
      "authorNames": ["Riehle, Dennis M.", "Fleischer, Stefan", "Becker, Jörg"],
      "year": "2019",
      "type": "Journalartikel",
      "language": "en",
      "venue": "AIS-Transactions on Enterprise Systems",
      "publisher": null,
      "pages": "1-12",
      "peerReviewed": "nein",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://aes-journal.com/index.php/ais-tes/article/view/10/15",
          "kind": "full-text"
        },
        {
          "label": "DOI",
          "url": "https://doi.org/10.30844/aistes.v4i1.10",
          "kind": "doi"
        },
        {
          "label": "ISSN",
          "url": "https://portal.issn.org/resource/ISSN/1867-7134",
          "kind": "external"
        }
      ],
      "doiUrl": "https://doi.org/10.30844/aistes.v4i1.10",
      "fullTextUrl": "https://aes-journal.com/index.php/ais-tes/article/view/10/15",
      "detailPath": "/publications/8841-a-web-based-information-system-to-evaluate-different-versions-of-it-artifacts-in-online-experiments",
      "apa7": "Riehle, D. M., Fleischer, S., & Becker, J. (2019). A Web-Based Information System to Evaluate Different Versions of IT Artifacts in Online Experiments. AIS-Transactions on Enterprise Systems, 4(1), 1–12. https://doi.org/10.30844/aistes.v4i1.10",
      "bibtex": "@article{Riehle2019Web,\n\tauthor = {Riehle, Dennis M. and Fleischer, Stefan and Becker, J{\\\" o}rg},\n\tjournal = {AIS-Transactions on Enterprise Systems},\n\tdoi = {10.30844/aistes.v4i1.10},\n\tnumber = {1},\n\tyear = {2019},\n\tpages = {1--12},\n\ttitle = {A {Web}-{Based} {Information} {System} to {Evaluate} {Different} {Versions} of {IT} {Artifacts} in {Online} {Experiments}},\n\turl = {https://aes-journal.com/index.php/ais-tes/article/view/10/15},\n\thowpublished = {https://aes-journal.com/index.php/ais-tes/article/view/10/15},\n\tvolume = {4},\n}"
    },
    {
      "id": 8842,
      "title": "Intentional Forgetting in Socio-Digital Work Systems: System Characteristics and User-related Psychological Consequences on Emotion, Cognition, and Behavior",
      "authors": "Thomas Ellwart, Anna-Sophie Ulfert, Conny H. Antoni, Jörg Becker, Christian Frings, Kyra Göbel, Guido Hertel, Anette Kluge, Sarah M. Meeßen, Cornelia Niessen, Christoph Nohe, Dennis M. Riehle, Yannick Runge, Ute Schmid, Arnulf Schüffler, Michael Siebers, Sabine Sonnentag, Tobias Tempel, Meinald T. Thielsch, Wilken Wehrt",
      "authorNames": [
        "Ellwart, Thomas",
        "Ulfert, Anna-Sophie",
        "Antoni, Conny H.",
        "Becker, Jörg",
        "Frings, Christian",
        "Göbel, Kyra",
        "Hertel, Guido",
        "Kluge, Anette",
        "Meeßen, Sarah M.",
        "Niessen, Cornelia",
        "Nohe, Christoph",
        "Riehle, Dennis M.",
        "Runge, Yannick",
        "Schmid, Ute",
        "Schüffler, Arnulf",
        "Siebers, Michael",
        "Sonnentag, Sabine",
        "Tempel, Tobias",
        "Thielsch, Meinald T.",
        "Wehrt, Wilken"
      ],
      "year": "2019",
      "type": "Journalartikel",
      "language": "en",
      "venue": "AIS-Transactions on Enterprise Systems",
      "publisher": null,
      "pages": "1-19",
      "peerReviewed": "nein",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://www.aes-journal.com/index.php/ais-tes/article/view/16/14",
          "kind": "full-text"
        },
        {
          "label": "DOI",
          "url": "https://doi.org/10.30844/aistes.v4i1.16",
          "kind": "doi"
        },
        {
          "label": "ISSN",
          "url": "https://portal.issn.org/resource/ISSN/1867-7134",
          "kind": "external"
        }
      ],
      "doiUrl": "https://doi.org/10.30844/aistes.v4i1.16",
      "fullTextUrl": "https://www.aes-journal.com/index.php/ais-tes/article/view/16/14",
      "detailPath": "/publications/8842-intentional-forgetting-in-socio-digital-work-systems-system-characteristics-and-user-related-psychological-consequences-on-emotion-cognition-and-behavior",
      "apa7": "Ellwart, T., Ulfert, A.-S., Antoni, C. H., Becker, J., Frings, C., Göbel, K., Hertel, G., Kluge, A., Meeßen, S. M., Niessen, C., Nohe, C., Riehle, D. M., Runge, Y., Schmid, U., Schüffler, A., Siebers, M., Sonnentag, S., Tempel, T., Thielsch, M. T., & Wehrt, W. (2019). Intentional Forgetting in Socio-Digital Work Systems: System Characteristics and User-related Psychological Consequences on Emotion, Cognition, and Behavior. AIS-Transactions on Enterprise Systems, 4(1), 1–19. https://doi.org/10.30844/aistes.v4i1.16",
      "bibtex": "@article{Ellwart2019Intentional,\n\tauthor = {Ellwart, Thomas and Ulfert, Anna-Sophie and Antoni, Conny H. and Becker, J{\\\" o}rg and Frings, Christian and G{\\\" o}bel, Kyra and Hertel, Guido and Kluge, Anette and Mee\\ss{}en, Sarah M. and Niessen, Cornelia and Nohe, Christoph and Riehle, Dennis M. and Runge, Yannick and Schmid, Ute and Sch{\\\" u}ffler, Arnulf and Siebers, Michael and Sonnentag, Sabine and Tempel, Tobias and Thielsch, Meinald T. and Wehrt, Wilken},\n\tjournal = {AIS-Transactions on Enterprise Systems},\n\tdoi = {10.30844/aistes.v4i1.16},\n\tnumber = {1},\n\tyear = {2019},\n\tpages = {1--19},\n\ttitle = {Intentional {Forgetting} in {Socio}-{Digital} {Work} {Systems}: System {Characteristics} and {User}-related {Psychological} {Consequences} on {Emotion}, {Cognition}, and {Behavior}},\n\turl = {https://www.aes-journal.com/index.php/ais-tes/article/view/16/14},\n\thowpublished = {https://www.aes-journal.com/index.php/ais-tes/article/view/16/14},\n\tvolume = {4},\n}"
    },
    {
      "id": 8896,
      "title": "Digitalisation and Automation of Compliance Management: A Model-based Method for Ensuring Business Process Compliance",
      "authors": "Dennis M. Riehle",
      "authorNames": ["Riehle, Dennis M."],
      "year": "2019",
      "type": "Monographie",
      "language": "en",
      "venue": null,
      "publisher": "Westfälische Wilhelms-Universität Münster",
      "pages": null,
      "peerReviewed": "nein",
      "access": null,
      "abstract": null,
      "links": [],
      "doiUrl": null,
      "fullTextUrl": null,
      "detailPath": "/publications/8896-digitalisation-and-automation-of-compliance-management-a-model-based-method-for-ensuring-business-process-compliance",
      "apa7": "Riehle, D. M. (2019). Digitalisation and Automation of Compliance Management: A Model-based Method for Ensuring Business Process Compliance. Westfälische Wilhelms-Universität Münster.",
      "bibtex": "@book{Riehle2019Digitalisation,\n\taddress = {M{\\\" u}nster},\n\tauthor = {Riehle, Dennis M.},\n\tyear = {2019},\n\tpublisher = {Westf{\\\" a}lische Wilhelms-Universit{\\\" a}t M{\\\" u}nster},\n\ttitle = {Digitalisation and {Automation} of {Compliance} {Management}: A {Model}-based {Method} for {Ensuring} {Business} {Process} {Compliance}},\n}"
    },
    {
      "id": 8902,
      "title": "What is Abusive Language? --- Integrating Different Views on Abusive Language for Machine Learning",
      "authors": "Marco Niemann, Dennis M. Riehle, Jens Brunk, Jörg Becker",
      "authorNames": [
        "Niemann, Marco",
        "Riehle, Dennis M.",
        "Brunk, Jens",
        "Becker, Jörg"
      ],
      "year": "2019",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Disinformation in Open Online Media: First Multidisciplinary International Symposium, MISDOOM 2019, Hamburg, Germany, February 27 – March 1, 2019, Revised Selected Papers",
      "publisher": "Gorgan University of Agricultural Sciences and Natural Resources",
      "pages": "59-73",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-030-39627-5_6",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-030-39627-5_6",
      "fullTextUrl": null,
      "detailPath": "/publications/8902-what-is-abusive-language-integrating-different-views-on-abusive-language-for-machine-learning",
      "apa7": "Niemann, M., Riehle, D. M., Brunk, J., & Becker, J. (2019). What is Abusive Language? --- Integrating Different Views on Abusive Language for Machine Learning. Disinformation in Open Online Media: First Multidisciplinary International Symposium, MISDOOM 2019, Hamburg, Germany, February 27 – March 1, 2019, Revised Selected Papers, 59–73. https://doi.org/10.1007/978-3-030-39627-5_6",
      "bibtex": "@inproceedings{Niemann2019What,\n\taddress = {Gorgan},\n\tauthor = {Niemann, Marco and Riehle, Dennis M. and Brunk, Jens and Becker, J{\\\" o}rg},\n\tbooktitle = {Disinformation in {Open} {Online} {Media}: First {Multidisciplinary} {International} {Symposium}, {MISDOOM} 2019, {Hamburg}, {Germany}, {February} 27 -- {March} 1, 2019, {Revised} {Selected} {Papers}},\n\tdoi = {10.1007/978-3-030-39627-5_6},\n\tisbn = {978-3-030-39626-8},\n\tyear = {2019},\n\tpages = {59--73},\n\torganization = {{Gorgan University of Agricultural Sciences and Natural Resources}},\n\ttitle = {What is {Abusive} {Language}? --- {Integrating} {Different} {Views} on {Abusive} {Language} for {Machine} {Learning}},\n\turl = {https://doi.org/10.1007/978-3-030-39627-5_6},\n}"
    },
    {
      "id": 9549,
      "title": "Trust Management - An Information Systems Perspective",
      "authors": "Friedrich Chasin, Dennis M. Riehle, Michael Rosemann",
      "authorNames": [
        "Chasin, Friedrich",
        "Riehle, Dennis M.",
        "Rosemann, Michael"
      ],
      "year": "2019",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceedings of the 27th European Conference on Information Systems ECIS 2019 - Infromation Systems for a Sharing Society: June 8 - 14, 2019; Stockholm and Uppsala, Sweden",
      "publisher": "Association for Information Systems/AIS eLibrary",
      "pages": "keine Angaben-keine Angaben",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://aisel.aisnet.org/ecis2019_rip/57",
          "kind": "full-text"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://aisel.aisnet.org/ecis2019_rip/57",
      "detailPath": "/publications/9549-trust-management-an-information-systems-perspective",
      "apa7": "Chasin, F., Riehle, D. M., & Rosemann, M. (2019). Trust Management - An Information Systems Perspective. Proceedings of the 27th European Conference on Information Systems ECIS 2019 - Infromation Systems for a Sharing Society: June 8 - 14, 2019; Stockholm and Uppsala, Sweden, keine Angaben-keine Angaben. https://aisel.aisnet.org/ecis2019_rip/57",
      "bibtex": "@inproceedings{Chasin2019Trust,\n\taddress = {Atlanta, GA},\n\tauthor = {Chasin, Friedrich and Riehle, Dennis M. and Rosemann, Michael},\n\tbooktitle = {Proceedings of the 27th {European} {Conference} on {Information} {Systems} {ECIS} 2019 - {Infromation} {Systems} for a {Sharing} {Society}: June 8 - 14, 2019; {Stockholm} and {Uppsala}, {Sweden}},\n\tisbn = {978-1-7336325-0-8},\n\tyear = {2019},\n\tpages = {keine Angaben--keine Angaben},\n\torganization = {Association for Information Systems/AIS eLibrary},\n\ttitle = {Trust {Management} - {An} {Information} {Systems} {Perspective}},\n\turl = {https://aisel.aisnet.org/ecis2019_rip/57},\n}"
    },
    {
      "id": 8853,
      "title": "Collaborative Specification Engineering: Kollaborative Entwicklung einer Sprachspezifikation der Ereignisgesteuerten Prozesskette unter Verwendung einer wikibasierten Onlineplattform",
      "authors": "Oliver Thomas, Jörg Becker, Sven Jannaber, Dennis M. Riehle, Immo Leising",
      "authorNames": [
        "Thomas, Oliver",
        "Becker, Jörg",
        "Jannaber, Sven",
        "Riehle, Dennis M.",
        "Leising, Immo"
      ],
      "year": "2018",
      "type": "Arbeitspapier/Forschungsbericht",
      "language": "de",
      "venue": null,
      "publisher": "Universität Münster, Institut für Wirtschaftsinformatik",
      "pages": null,
      "peerReviewed": null,
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://www.wi.uni-muenster.de/sites/wi/files/public/research/arbeitsberichte/ab140.pdf",
          "kind": "full-text"
        },
        {
          "label": "ISSN",
          "url": "https://portal.issn.org/resource/ISSN/1438-3985",
          "kind": "external"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://www.wi.uni-muenster.de/sites/wi/files/public/research/arbeitsberichte/ab140.pdf",
      "detailPath": "/publications/8853-collaborative-specification-engineering-kollaborative-entwicklung-einer-sprachspezifikation-der-ereignisgesteuerten-prozesskette-unter-verwendung-einer-wikibasierten-onlineplattform",
      "apa7": "Thomas, O., Becker, J., Jannaber, S., Riehle, D. M., & Leising, I. (2018). Collaborative Specification Engineering: Kollaborative Entwicklung einer Sprachspezifikation der Ereignisgesteuerten Prozesskette unter Verwendung einer wikibasierten Onlineplattform (Arbeitsberichte Des Instituts Für Wirtschaftsinformatik). Universität Münster, Institut für Wirtschaftsinformatik. https://www.wi.uni-muenster.de/sites/wi/files/public/research/arbeitsberichte/ab140.pdf",
      "bibtex": "@misc{Thomas2018Collaborative,\n\taddress = {M{\\\" u}nster},\n\tauthor = {Thomas, Oliver and Becker, J{\\\" o}rg and Jannaber, Sven and Riehle, Dennis M. and Leising, Immo},\n\tseries = {Arbeitsberichte des {Instituts} f{\\\" u}r {Wirtschaftsinformatik}},\n\tyear = {2018},\n\tpublisher = {Universit{\\\" a}t M{\\\" u}nster, Institut f{\\\" u}r Wirtschaftsinformatik},\n\ttitle = {Collaborative {Specification} {Engineering}: Kollaborative {Entwicklung} einer {Sprachspezifikation} der {Ereignisgesteuerten} {Prozesskette} unter {Verwendung} einer wikibasierten {Onlineplattform}},\n\turl = {https://www.wi.uni-muenster.de/sites/wi/files/public/research/arbeitsberichte/ab140.pdf},\n}"
    },
    {
      "id": 8894,
      "title": "Building a Web-Based Information System to Evaluate IT-Artefacts in Online Experiments - The Case of Intentional Forgetting",
      "authors": "Dennis M. Riehle, Stefan Fleischer, Jörg Becker",
      "authorNames": ["Riehle, Dennis M.", "Fleischer, Stefan", "Becker, Jörg"],
      "year": "2018",
      "type": "Konferenzposter",
      "language": "en",
      "venue": "Conference on Intentional Forgetting in Organisations and Work Settings",
      "publisher": null,
      "pages": null,
      "peerReviewed": "nein",
      "access": null,
      "abstract": null,
      "links": [],
      "doiUrl": null,
      "fullTextUrl": null,
      "detailPath": "/publications/8894-building-a-web-based-information-system-to-evaluate-it-artefacts-in-online-experiments-the-case-of-intentional-forgetting",
      "apa7": "Riehle, D. M., Fleischer, S., & Becker, J. (2018). Building a Web-Based Information System to Evaluate IT-Artefacts in Online Experiments - The Case of Intentional Forgetting. Conference on Intentional Forgetting in Organisations and Work Settings.",
      "bibtex": "@inproceedings{Riehle2018Building,\n\tauthor = {Riehle, Dennis M. and Fleischer, Stefan and Becker, J{\\\" o}rg},\n\tbooktitle = {Conference on {Intentional} {Forgetting} in {Organisations} and {Work} {Settings}},\n\tyear = {2018},\n\ttitle = {Building a {Web}-{Based} {Information} {System} to {Evaluate} {IT}-{Artefacts} in {Online} {Experiments} - {The} {Case} of {Intentional} {Forgetting}},\n}"
    },
    {
      "id": 8897,
      "title": "Intentional forgetting in organizations: the positive effects of decision support systems on mental resources and well-being",
      "authors": "Guido Hertel, Sarah M. Meeßen, Dennis M. Riehle, Meinald T. Thielsch, Christoph Nohe, Jörg Becker",
      "authorNames": [
        "Hertel, Guido",
        "Meeßen, Sarah M.",
        "Riehle, Dennis M.",
        "Thielsch, Meinald T.",
        "Nohe, Christoph",
        "Becker, Jörg"
      ],
      "year": "2018",
      "type": "Meeting Abstract",
      "language": "en",
      "venue": "Psychologie gestaltet: 51. Kongress der Deutschen Gesellschaft für Psychologie (DGPs) - Abstracts: 14. bis 20. September 2018 in Frankfurt am Main",
      "publisher": "Pabst",
      "pages": "361-361",
      "peerReviewed": "nein",
      "access": null,
      "abstract": null,
      "links": [],
      "doiUrl": null,
      "fullTextUrl": null,
      "detailPath": "/publications/8897-intentional-forgetting-in-organizations-the-positive-effects-of-decision-support-systems-on-mental-resources-and-well-being",
      "apa7": "Hertel, G., Meeßen, S. M., Riehle, D. M., Thielsch, M. T., Nohe, C., & Becker, J. (2018). Intentional forgetting in organizations: the positive effects of decision support systems on mental resources and well-being. In J. Hartig & H. Horz (Eds.), Psychologie gestaltet: 51. Kongress der Deutschen Gesellschaft für Psychologie (DGPs) - Abstracts: 14. bis 20. September 2018 in Frankfurt am Main (pp. 361–361). Pabst.",
      "bibtex": "@inproceedings{Hertel2018Intentional,\n\taddress = {Lengerich},\n\tauthor = {Hertel, Guido and Mee\\ss{}en, Sarah M. and Riehle, Dennis M. and Thielsch, Meinald T. and Nohe, Christoph and Becker, J{\\\" o}rg},\n\tbooktitle = {Psychologie gestaltet: 51. {Kongress} der {Deutschen} {Gesellschaft} f{\\\" u}r {Psychologie} ({DGPs}) - {Abstracts}: 14. bis 20. {September} 2018 in {Frankfurt} am {Main}},\n\teditor = {Hartig, Johannes and Horz, Holger},\n\tisbn = {978-3-95853-437-7},\n\tyear = {2018},\n\tpages = {361--361},\n\torganization = {Pabst},\n\ttitle = {Intentional forgetting in organizations: the positive effects of decision support systems on mental resources and well-being},\n}"
    },
    {
      "id": 9552,
      "title": "Prediction of Customer Movements in Large Tourism Industries by the Means of Process Mining",
      "authors": "Jens Brunk, Dennis M. Riehle, Patrick Delfmann",
      "authorNames": ["Brunk, Jens", "Riehle, Dennis M.", "Delfmann, Patrick"],
      "year": "2018",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceeding of the 26th European Conference on Information Systems - \"Beyond Digitization - Facets of Socio-Technical Change\" ECIS 2018: Portsmouth, UK, June 23-28, 2018",
      "publisher": "Association for Information Systems/AIS eLibrary",
      "pages": "Research Papers 40-Research Papers 40",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://aisel.aisnet.org/ecis2018_rp/40",
          "kind": "full-text"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://aisel.aisnet.org/ecis2018_rp/40",
      "detailPath": "/publications/9552-prediction-of-customer-movements-in-large-tourism-industries-by-the-means-of-process-mining",
      "apa7": "Brunk, J., Riehle, D. M., & Delfmann, P. (2018). Prediction of Customer Movements in Large Tourism Industries by the Means of Process Mining. Proceeding of the 26th European Conference on Information Systems - “Beyond Digitization - Facets of Socio-Technical Change” ECIS 2018: Portsmouth, UK, June 23-28, 2018, Research Papers 40-Research Papers 40. https://aisel.aisnet.org/ecis2018_rp/40",
      "bibtex": "@inproceedings{Brunk2018Prediction,\n\taddress = {Atlanta, GA},\n\tauthor = {Brunk, Jens and Riehle, Dennis M. and Delfmann, Patrick},\n\tbooktitle = {Proceeding of the 26th {European} {Conference} on {Information} {Systems} - \"{Beyond} {Digitization} - {Facets} of {Socio}-{Technical} {Change}\" {ECIS} 2018: Portsmouth, {UK}, {June} 23-28, 2018},\n\tisbn = {978-1-86137-667-1},\n\tyear = {2018},\n\tpages = {Research Papers 40--Research Papers 40},\n\torganization = {Association for Information Systems/AIS eLibrary},\n\ttitle = {Prediction of {Customer} {Movements} in {Large} {Tourism} {Industries} by the {Means} of {Process} {Mining}},\n\turl = {https://aisel.aisnet.org/ecis2018_rp/40},\n}"
    },
    {
      "id": 11131,
      "title": "Discussing the Value of Automatic Hate Speech Detection in Online Debates",
      "authors": "Sebastian Köffer, Dennis M. Riehle, Steffen Höhenberger, Jörg Becker",
      "authorNames": [
        "Köffer, Sebastian",
        "Riehle, Dennis M.",
        "Höhenberger, Steffen",
        "Becker, Jörg"
      ],
      "year": "2018",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Multikonferenz Wirtschaftsinformatik MKWI 2018; Data driven X - Turning Data into Value Band 1: 6. - 9. März 2018, Leuphana Universität Lüneburg",
      "publisher": "Leuphana Universität Lüneburg, Institut für Wirtschaftsinformatik",
      "pages": "83-94",
      "peerReviewed": "nein",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://www.leuphana.de/fileadmin/user_upload/Forschungseinrichtungen/ieg/files/MKWI2018/MKWI2018_Band1.pdf#section*.14",
          "kind": "full-text"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://www.leuphana.de/fileadmin/user_upload/Forschungseinrichtungen/ieg/files/MKWI2018/MKWI2018_Band1.pdf#section*.14",
      "detailPath": "/publications/11131-discussing-the-value-of-automatic-hate-speech-detection-in-online-debates",
      "apa7": "Köffer, S., Riehle, D. M., Höhenberger, S., & Becker, J. (2018). Discussing the Value of Automatic Hate Speech Detection in Online Debates. Multikonferenz Wirtschaftsinformatik MKWI 2018; Data Driven X - Turning Data into Value Band 1: 6. - 9. März 2018, Leuphana Universität Lüneburg, 83–94. https://www.leuphana.de/fileadmin/user_upload/Forschungseinrichtungen/ieg/files/MKWI2018/MKWI2018_Band1.pdf#section*.14",
      "bibtex": "@inproceedings{Koffer2018Discussing,\n\taddress = {L{\\\" u}neburg},\n\tauthor = {K{\\\" o}ffer, Sebastian and Riehle, Dennis M. and H{\\\" o}henberger, Steffen and Becker, J{\\\" o}rg},\n\tbooktitle = {Multikonferenz {Wirtschaftsinformatik} {MKWI} 2018; {Data} driven {X} - {Turning} {Data} into {Value} {Band} 1: 6. - 9. {M}{\\\" a}rz 2018, {Leuphana} {Universit}{\\\" a}t {L}{\\\" u}neburg},\n\tisbn = {978-3-935786-72-0},\n\tyear = {2018},\n\tpages = {83--94},\n\torganization = {Leuphana Universit{\\\" a}t L{\\\" u}neburg, Institut f{\\\" u}r Wirtschaftsinformatik},\n\ttitle = {Discussing the {Value} of {Automatic} {Hate} {Speech} {Detection} in {Online} {Debates}},\n\turl = {https://www.leuphana.de/fileadmin/user_upload/Forschungseinrichtungen/ieg/files/MKWI2018/MKWI2018_Band1.pdf#section*.14},\n}"
    },
    {
      "id": 5274,
      "title": "Live Query - Visualized Process Analysis",
      "authors": "Dennis M. Riehle, Steffen Höhenberger, Rainer Cording, Patrick Delfmann",
      "authorNames": [
        "Riehle, Dennis M.",
        "Höhenberger, Steffen",
        "Cording, Rainer",
        "Delfmann, Patrick"
      ],
      "year": "2017",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "13. Internationale Tagung Wirtschaftsinformatik „Towards Thought Leadership in Digital Transformation“: 12. - 15. Februar 2017, Universität St.Gallen",
      "publisher": "Institut für Wirtschaftsinformatik (IWI-HSG) Universität St.Gallen",
      "pages": "1295-1298",
      "peerReviewed": "nein",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://www.wi2017.ch/images/wi2017-0344.pdf",
          "kind": "full-text"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://www.wi2017.ch/images/wi2017-0344.pdf",
      "detailPath": "/publications/5274-live-query-visualized-process-analysis",
      "apa7": "Riehle, D. M., Höhenberger, S., Cording, R., & Delfmann, P. (2017). Live Query - Visualized Process Analysis. 13. Internationale Tagung Wirtschaftsinformatik „Towards Thought Leadership in Digital Transformation“: 12. - 15. Februar 2017, Universität St.Gallen, 1295–1298. https://www.wi2017.ch/images/wi2017-0344.pdf",
      "bibtex": "@inproceedings{Riehle2017Live,\n\taddress = {St.Gallen},\n\tauthor = {Riehle, Dennis M. and H{\\\" o}henberger, Steffen and Cording, Rainer and Delfmann, Patrick},\n\tbooktitle = {13. {Internationale} {Tagung} {Wirtschaftsinformatik} \\quotedblbase{}{Towards} {Thought} {Leadership} in {Digital} {Transformation}``: 12. - 15. {Februar} 2017, {Universit}{\\\" a}t {St}.{Gallen}},\n\tyear = {2017},\n\tpages = {1295--1298},\n\torganization = {Institut f{\\\" u}r Wirtschaftsinformatik (IWI-HSG) Universit{\\\" a}t St.Gallen},\n\ttitle = {Live {Query} - {Visualized} {Process} {Analysis}},\n\turl = {https://www.wi2017.ch/images/wi2017-0344.pdf},\n}"
    },
    {
      "id": 5308,
      "title": "Automatically Annotating Business Process Models with Ontology Concepts at Design-Time",
      "authors": "Dennis M. Riehle, Sven Jannaber, Patrick Delfmann, Oliver Thomas, Jörg Becker",
      "authorNames": [
        "Riehle, Dennis M.",
        "Jannaber, Sven",
        "Delfmann, Patrick",
        "Thomas, Oliver",
        "Becker, Jörg"
      ],
      "year": "2017",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Advances in Conceptual Modeling: ER 2017 Workshops AHA, MoBiD, MREBA, OntoCom, and QMMQ, Valencia, Spain, November 6–9, 2017, Proceedings",
      "publisher": "Gorgan University of Agricultural Sciences and Natural Resources",
      "pages": "177-186",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-319-70625-2_17",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-319-70625-2_17",
      "fullTextUrl": null,
      "detailPath": "/publications/5308-automatically-annotating-business-process-models-with-ontology-concepts-at-design-time",
      "apa7": "Riehle, D. M., Jannaber, S., Delfmann, P., Thomas, O., & Becker, J. (2017). Automatically Annotating Business Process Models with Ontology Concepts at Design-Time. Advances in Conceptual Modeling: ER 2017 Workshops AHA, MoBiD, MREBA, OntoCom, and QMMQ, Valencia, Spain, November 6–9, 2017, Proceedings, 177–186. https://doi.org/10.1007/978-3-319-70625-2_17",
      "bibtex": "@inproceedings{Riehle2017Automatically,\n\taddress = {Gorgan},\n\tauthor = {Riehle, Dennis M. and Jannaber, Sven and Delfmann, Patrick and Thomas, Oliver and Becker, J{\\\" o}rg},\n\tbooktitle = {Advances in {Conceptual} {Modeling}: ER 2017 {Workshops} {AHA}, {MoBiD}, {MREBA}, {OntoCom}, and {QMMQ}, {Valencia}, {Spain}, {November} 6--9, 2017, {Proceedings}},\n\tdoi = {10.1007/978-3-319-70625-2_17},\n\tisbn = {978-3-319-70624-5},\n\tyear = {2017},\n\tpages = {177--186},\n\torganization = {{Gorgan University of Agricultural Sciences and Natural Resources}},\n\ttitle = {Automatically {Annotating} {Business} {Process} {Models} with {Ontology} {Concepts} at {Design}-{Time}},\n\turl = {https://doi.org/10.1007/978-3-319-70625-2_17},\n}"
    },
    {
      "id": 5309,
      "title": "[εm] – Process Analysis using a Meta Modeling Tool",
      "authors": "Dennis M. Riehle, Steffen Höhenberger, Jens Brunk, Patrick Delfmann, Jörg Becker",
      "authorNames": [
        "Riehle, Dennis M.",
        "Höhenberger, Steffen",
        "Brunk, Jens",
        "Delfmann, Patrick",
        "Becker, Jörg"
      ],
      "year": "2017",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceedings of the ER Forum 2017 and the ER 2017 Demo Track: co-located with the 36th International Conference on Conceptual Modelling (ER 2017); Valencia, Spain, November 6-9, 2017",
      "publisher": "CEUR/RWTH",
      "pages": "334-337",
      "peerReviewed": "nein",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://ceur-ws.org/Vol-1979/paper-25.pdf",
          "kind": "full-text"
        },
        {
          "label": "URN",
          "url": "https://nbn-resolving.org/urn:nbn:de:0074-1979-5",
          "kind": "external"
        },
        {
          "label": "ISSN",
          "url": "https://portal.issn.org/resource/ISSN/1613-0073",
          "kind": "external"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://ceur-ws.org/Vol-1979/paper-25.pdf",
      "detailPath": "/publications/5309-m-process-analysis-using-a-meta-modeling-tool",
      "apa7": "Riehle, D. M., Höhenberger, S., Brunk, J., Delfmann, P., & Becker, J. (2017). [εm] – Process Analysis using a Meta Modeling Tool. Proceedings of the ER Forum 2017 and the ER 2017 Demo Track: Co-Located with the 36th International Conference on Conceptual Modelling (ER 2017); Valencia, Spain, November 6-9, 2017, 334–337. https://ceur-ws.org/Vol-1979/paper-25.pdf",
      "bibtex": "@inproceedings{Riehle2017m,\n\taddress = {Aachen},\n\tauthor = {Riehle, Dennis M. and H{\\\" o}henberger, Steffen and Brunk, Jens and Delfmann, Patrick and Becker, J{\\\" o}rg},\n\tbooktitle = {Proceedings of the {ER} {Forum} 2017 and the {ER} 2017 {Demo} {Track}: co-located with the 36th {International} {Conference} on {Conceptual} {Modelling} ({ER} 2017); {Valencia}, {Spain}, {November} 6-9, 2017},\n\tyear = {2017},\n\tpages = {334--337},\n\torganization = {CEUR/RWTH},\n\ttitle = {[$\\varepsilon$m] -- {Process} {Analysis} using a {Meta} {Modeling} {Tool}},\n\turl = {https://ceur-ws.org/Vol-1979/paper-25.pdf},\n}"
    },
    {
      "id": 5355,
      "title": "Designing a Framework for the Development of Domain-Specific Process Modelling Languages",
      "authors": "Sven Jannaber, Dennis M. Riehle, Patrick Delfmann, Oliver Thomas, Jörg Becker",
      "authorNames": [
        "Jannaber, Sven",
        "Riehle, Dennis M.",
        "Delfmann, Patrick",
        "Thomas, Oliver",
        "Becker, Jörg"
      ],
      "year": "2017",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Designing the Digital Transformation: 12th International Conference, DESRIST 2017, Karlsruhe, Germany, May 30 – June 1, 2017, Proceedings",
      "publisher": "Gorgan University of Agricultural Sciences and Natural Resources",
      "pages": "39-54",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-319-59144-5_3",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-319-59144-5_3",
      "fullTextUrl": null,
      "detailPath": "/publications/5355-designing-a-framework-for-the-development-of-domain-specific-process-modelling-languages",
      "apa7": "Jannaber, S., Riehle, D. M., Delfmann, P., Thomas, O., & Becker, J. (2017). Designing a Framework for the Development of Domain-Specific Process Modelling Languages. Designing the Digital Transformation: 12th International Conference, DESRIST 2017, Karlsruhe, Germany, May 30 – June 1, 2017, Proceedings, 39–54. https://doi.org/10.1007/978-3-319-59144-5_3",
      "bibtex": "@inproceedings{Jannaber2017Designing,\n\taddress = {Gorgan},\n\tauthor = {Jannaber, Sven and Riehle, Dennis M. and Delfmann, Patrick and Thomas, Oliver and Becker, J{\\\" o}rg},\n\tbooktitle = {Designing the {Digital} {Transformation}: 12th {International} {Conference}, {DESRIST} 2017, {Karlsruhe}, {Germany}, {May} 30 -- {June} 1, 2017, {Proceedings}},\n\tdoi = {10.1007/978-3-319-59144-5_3},\n\tisbn = {978-3-319-59143-8},\n\tyear = {2017},\n\tpages = {39--54},\n\torganization = {{Gorgan University of Agricultural Sciences and Natural Resources}},\n\ttitle = {Designing a {Framework} for the {Development} of {Domain}-{Specific} {Process} {Modelling} {Languages}},\n\turl = {https://doi.org/10.1007/978-3-319-59144-5_3},\n}"
    },
    {
      "id": 8718,
      "title": "Development of a Domain-Specific Language for Run-Time Process Modelling — Making Use of Smart Glasses in BPM",
      "authors": "Sven Jannaber, Benedikt Zobel, Dennis M. Riehle, Oliver Thomas, Jörg Becker",
      "authorNames": [
        "Jannaber, Sven",
        "Zobel, Benedikt",
        "Riehle, Dennis M.",
        "Thomas, Oliver",
        "Becker, Jörg"
      ],
      "year": "2017",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Informatik 2017: 25.- 29. September 2017; Chemnitz, Deutschland",
      "publisher": "Gesellschaft für Informatik",
      "pages": "857-862",
      "peerReviewed": "nein",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://dl.gi.de/bitstream/handle/20.500.12116/4108/B10-8.pdf?sequence=1&isAllowed=y",
          "kind": "full-text"
        },
        {
          "label": "DOI",
          "url": "https://doi.org/10.18420/in2017_85",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.18420/in2017_85",
      "fullTextUrl": "https://dl.gi.de/bitstream/handle/20.500.12116/4108/B10-8.pdf?sequence=1&isAllowed=y",
      "detailPath": "/publications/8718-development-of-a-domain-specific-language-for-run-time-process-modelling-making-use-of-smart-glasses-in-bpm",
      "apa7": "Jannaber, S., Zobel, B., Riehle, D. M., Thomas, O., & Becker, J. (2017). Development of a Domain-Specific Language for Run-Time Process Modelling — Making Use of Smart Glasses in BPM. Informatik 2017: 25.- 29. September 2017; Chemnitz, Deutschland, 857–862. https://doi.org/10.18420/in2017_85",
      "bibtex": "@inproceedings{Jannaber2017Development,\n\taddress = {Bonn},\n\tauthor = {Jannaber, Sven and Zobel, Benedikt and Riehle, Dennis M. and Thomas, Oliver and Becker, J{\\\" o}rg},\n\tbooktitle = {Informatik 2017: 25.- 29. {September} 2017; {Chemnitz}, {Deutschland}},\n\tdoi = {10.18420/in2017_85},\n\tisbn = {978-3-88579-669-5},\n\tyear = {2017},\n\tpages = {857--862},\n\torganization = {Gesellschaft f{\\\" u}r Informatik},\n\ttitle = {Development of a {Domain}-{Specific} {Language} for {Run}-{Time} {Process} {Modelling} --- {Making} {Use} of {Smart} {Glasses} in {BPM}},\n\turl = {https://dl.gi.de/bitstream/handle/20.500.12116/4108/B10-8.pdf?sequence=1&isAllowed=y},\n}"
    },
    {
      "id": 8818,
      "title": "Software-Tools zur Prozessmodellierung",
      "authors": "Jörg Becker, Steffen Höhenberger, Dennis M. Riehle",
      "authorNames": [
        "Becker, Jörg",
        "Höhenberger, Steffen",
        "Riehle, Dennis M."
      ],
      "year": "2017",
      "type": "Sammelbandbeitrag",
      "language": "de",
      "venue": "Handbuch Dienstleistungsmanagement",
      "publisher": "Vahlen",
      "pages": "1007-1024",
      "peerReviewed": "nein",
      "access": null,
      "abstract": null,
      "links": [],
      "doiUrl": null,
      "fullTextUrl": null,
      "detailPath": "/publications/8818-software-tools-zur-prozessmodellierung",
      "apa7": "Becker, J., Höhenberger, S., & Riehle, D. M. (2017). Software-Tools zur Prozessmodellierung. In Handbuch Dienstleistungsmanagement (pp. 1007–1024). Vahlen.",
      "bibtex": "@inbook{Becker2017Software,\n\taddress = {M{\\\" u}nchen},\n\tauthor = {Becker, J{\\\" o}rg and H{\\\" o}henberger, Steffen and Riehle, Dennis M.},\n\tbooktitle = {Handbuch {Dienstleistungsmanagement}},\n\tisbn = {978-3-8006-5242-6},\n\tyear = {2017},\n\tpages = {1007--1024},\n\tpublisher = {Vahlen},\n\ttitle = {Software-{Tools} zur {Prozessmodellierung}},\n}"
    },
    {
      "id": 9567,
      "title": "Help is on the Way - Providing User Support for EPC modelling via a Systematic procedure Model: Research-in-Progress Papers 19",
      "authors": "Sven Jannaber, Dennis M. Riehle, Patrick Delfmann, Oliver Thomas",
      "authorNames": [
        "Jannaber, Sven",
        "Riehle, Dennis M.",
        "Delfmann, Patrick",
        "Thomas, Oliver"
      ],
      "year": "2017",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceeding of the 25th European Conference on Information Systems ECIS 2017: Guimarães, Portugal, June 5-10, 2017",
      "publisher": "Association for Information Systems/AIS eLibrary",
      "pages": "keine Angaben-keine Angaben",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://aisel.aisnet.org/ecis2017_rip/19",
          "kind": "full-text"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://aisel.aisnet.org/ecis2017_rip/19",
      "detailPath": "/publications/9567-help-is-on-the-way-providing-user-support-for-epc-modelling-via-a-systematic-procedure-model-research-in-progress-papers-19",
      "apa7": "Jannaber, S., Riehle, D. M., Delfmann, P., & Thomas, O. (2017). Help is on the Way - Providing User Support for EPC modelling via a Systematic procedure Model: Research-in-Progress Papers 19. Proceeding of the 25th European Conference on Information Systems ECIS 2017: Guimarães, Portugal, June 5-10, 2017, keine Angaben-keine Angaben. https://aisel.aisnet.org/ecis2017_rip/19",
      "bibtex": "@inproceedings{Jannaber2017Help,\n\taddress = {Atlanta, GA},\n\tauthor = {Jannaber, Sven and Riehle, Dennis M. and Delfmann, Patrick and Thomas, Oliver},\n\tbooktitle = {Proceeding of the 25th {European} {Conference} on {Information} {Systems} {ECIS} 2017: Guimar{\\~ a}es, {Portugal}, {June} 5-10, 2017},\n\tyear = {2017},\n\tpages = {keine Angaben--keine Angaben},\n\torganization = {Association for Information Systems/AIS eLibrary},\n\ttitle = {Help is on the {Way} - {Providing} {User} {Support} for {EPC} modelling via a {Systematic} procedure {Model}: Research-in-{Progress} {Papers} 19},\n\turl = {https://aisel.aisnet.org/ecis2017_rip/19},\n}"
    },
    {
      "id": 5296,
      "title": "Invigorating Event-driven Process Chains - Towards an integrated meta model for EPC standardization",
      "authors": "Sven Jannaber, Arne Karhof, Dennis M. Riehle, Oliver Thomas, Patrick Delfmann, Jörg Becker",
      "authorNames": [
        "Jannaber, Sven",
        "Karhof, Arne",
        "Riehle, Dennis M.",
        "Thomas, Oliver",
        "Delfmann, Patrick",
        "Becker, Jörg"
      ],
      "year": "2016",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Modellierung 2016: Workshopband 2.-4. März, 2016; Karlsruhe, Proceedings",
      "publisher": "Gesellschaft für Informatik",
      "pages": "13-22",
      "peerReviewed": "nein",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://dl.gi.de/20.500.12116/847",
          "kind": "full-text"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://dl.gi.de/20.500.12116/847",
      "detailPath": "/publications/5296-invigorating-event-driven-process-chains-towards-an-integrated-meta-model-for-epc-standardization",
      "apa7": "Jannaber, S., Karhof, A., Riehle, D. M., Thomas, O., Delfmann, P., & Becker, J. (2016). Invigorating Event-driven Process Chains - Towards an integrated meta model for EPC standardization. Modellierung 2016: Workshopband 2.-4. März, 2016; Karlsruhe, Proceedings, 13–22. https://dl.gi.de/20.500.12116/847",
      "bibtex": "@inproceedings{Jannaber2016Invigorating,\n\taddress = {Bonn},\n\tauthor = {Jannaber, Sven and Karhof, Arne and Riehle, Dennis M. and Thomas, Oliver and Delfmann, Patrick and Becker, J{\\\" o}rg},\n\tbooktitle = {Modellierung 2016: Workshopband 2.-4. {M}{\\\" a}rz, 2016; {Karlsruhe}, {Proceedings}},\n\tisbn = {978-3-88579-649-7; 3-88579-649-X},\n\tyear = {2016},\n\tpages = {13--22},\n\torganization = {Gesellschaft f{\\\" u}r Informatik},\n\ttitle = {Invigorating {Event}-driven {Process} {Chains} - {Towards} an integrated meta model for {EPC} standardization},\n\turl = {https://dl.gi.de/20.500.12116/847},\n}"
    },
    {
      "id": 5297,
      "title": "On the de-facto Standard of Event-driven Process Chains: How EPC is defined in Literature",
      "authors": "Dennis M. Riehle, Sven Jannaber, Arne Karhof, Oliver Thomas, Patrick Delfmann, Jörg Becker",
      "authorNames": [
        "Riehle, Dennis M.",
        "Jannaber, Sven",
        "Karhof, Arne",
        "Thomas, Oliver",
        "Delfmann, Patrick",
        "Becker, Jörg"
      ],
      "year": "2016",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Modellierung 2016: 2.-4. März, 2016; Karlsruhe; Proceedings",
      "publisher": "Gesellschaft für Informatik",
      "pages": "61-76",
      "peerReviewed": "nein",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://dl.gi.de/20.500.12116/830",
          "kind": "full-text"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://dl.gi.de/20.500.12116/830",
      "detailPath": "/publications/5297-on-the-de-facto-standard-of-event-driven-process-chains-how-epc-is-defined-in-literature",
      "apa7": "Riehle, D. M., Jannaber, S., Karhof, A., Thomas, O., Delfmann, P., & Becker, J. (2016). On the de-facto Standard of Event-driven Process Chains: How EPC is defined in Literature. Modellierung 2016: 2.-4. März, 2016; Karlsruhe; Proceedings, 61–76. https://dl.gi.de/20.500.12116/830",
      "bibtex": "@inproceedings{Riehle2016On,\n\taddress = {Bonn},\n\tauthor = {Riehle, Dennis M. and Jannaber, Sven and Karhof, Arne and Thomas, Oliver and Delfmann, Patrick and Becker, J{\\\" o}rg},\n\tbooktitle = {Modellierung 2016: 2.-4. {M}{\\\" a}rz, 2016; {Karlsruhe}; {Proceedings}},\n\tisbn = {978-3-88579-648-0},\n\tyear = {2016},\n\tpages = {61--76},\n\torganization = {Gesellschaft f{\\\" u}r Informatik},\n\ttitle = {On the de-facto {Standard} of {Event}-driven {Process} {Chains}: How {EPC} is defined in {Literature}},\n\turl = {https://dl.gi.de/20.500.12116/830},\n}"
    },
    {
      "id": 5298,
      "title": "On the de-facto Standard of Event-driven Process Chains: Reviewing EPC Implementations in Process Modelling Tools",
      "authors": "Arne Karhof, Sven Jannaber, Dennis M. Riehle, Oliver Thomas, Patrick Delfmann, Jörg Becker",
      "authorNames": [
        "Karhof, Arne",
        "Jannaber, Sven",
        "Riehle, Dennis M.",
        "Thomas, Oliver",
        "Delfmann, Patrick",
        "Becker, Jörg"
      ],
      "year": "2016",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Modellierung 2016: 2.-4. März, 2016; Karlsruhe; Proceedings",
      "publisher": "Gesellschaft für Informatik",
      "pages": "77-91",
      "peerReviewed": "nein",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://dl.gi.de/20.500.12116/831",
          "kind": "full-text"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://dl.gi.de/20.500.12116/831",
      "detailPath": "/publications/5298-on-the-de-facto-standard-of-event-driven-process-chains-reviewing-epc-implementations-in-process-modelling-tools",
      "apa7": "Karhof, A., Jannaber, S., Riehle, D. M., Thomas, O., Delfmann, P., & Becker, J. (2016). On the de-facto Standard of Event-driven Process Chains: Reviewing EPC Implementations in Process Modelling Tools. Modellierung 2016: 2.-4. März, 2016; Karlsruhe; Proceedings, 77–91. https://dl.gi.de/20.500.12116/831",
      "bibtex": "@inproceedings{Karhof2016On,\n\taddress = {Bonn},\n\tauthor = {Karhof, Arne and Jannaber, Sven and Riehle, Dennis M. and Thomas, Oliver and Delfmann, Patrick and Becker, J{\\\" o}rg},\n\tbooktitle = {Modellierung 2016: 2.-4. {M}{\\\" a}rz, 2016; {Karlsruhe}; {Proceedings}},\n\tisbn = {978-3-88579-648-0},\n\tyear = {2016},\n\tpages = {77--91},\n\torganization = {Gesellschaft f{\\\" u}r Informatik},\n\ttitle = {On the de-facto {Standard} of {Event}-driven {Process} {Chains}: Reviewing {EPC} {Implementations} in {Process} {Modelling} {Tools}},\n\turl = {https://dl.gi.de/20.500.12116/831},\n}"
    },
    {
      "id": 8716,
      "title": "Ansätze zur Unternehmensmodellierung - Eine Einordnung",
      "authors": "Jörg Becker, Dennis M. Riehle, Nico Clever",
      "authorNames": ["Becker, Jörg", "Riehle, Dennis M.", "Clever, Nico"],
      "year": "2016",
      "type": "Sammelbandbeitrag",
      "language": "de",
      "venue": "Geschäftsprozessorientierte Systementwicklung: Von der Unternehmensarchitektur zum IT-System",
      "publisher": "Springer Vieweg",
      "pages": "415-425",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "DOI",
          "url": "https://doi.org/10.1007/978-3-658-14826-3_25",
          "kind": "doi"
        }
      ],
      "doiUrl": "https://doi.org/10.1007/978-3-658-14826-3_25",
      "fullTextUrl": null,
      "detailPath": "/publications/8716-ans-tze-zur-unternehmensmodellierung-eine-einordnung",
      "apa7": "Becker, J., Riehle, D. M., & Clever, N. (2016). Ansätze zur Unternehmensmodellierung - Eine Einordnung. In Geschäftsprozessorientierte Systementwicklung: Von der Unternehmensarchitektur zum IT-System (pp. 415–425). Springer Vieweg. https://doi.org/10.1007/978-3-658-14826-3_25",
      "bibtex": "@inbook{Becker2016Ansatze,\n\taddress = {Wiesbaden},\n\tauthor = {Becker, J{\\\" o}rg and Riehle, Dennis M. and Clever, Nico},\n\tbooktitle = {Gesch{\\\" a}ftsprozessorientierte {Systementwicklung}: Von der {Unternehmensarchitektur} zum {IT}-{System}},\n\tdoi = {10.1007/978-3-658-14826-3_25},\n\tisbn = {978-3-658-14825-6},\n\tyear = {2016},\n\tpages = {415--425},\n\tpublisher = {Springer Vieweg},\n\ttitle = {Ans{\\\" a}tze zur {Unternehmensmodellierung} - {Eine} {Einordnung}},\n\turl = {https://doi.org/10.1007/978-3-658-14826-3_25},\n}"
    },
    {
      "id": 8802,
      "title": "Towards an EPC Standardization - A Literature Review on Exchange Formats for EPC Models",
      "authors": "Dennis M. Riehle, Sven Jannaber, Arne Karhof, Patrick Delfmann, Oliver Thomas, Jörg Becker",
      "authorNames": [
        "Riehle, Dennis M.",
        "Jannaber, Sven",
        "Karhof, Arne",
        "Delfmann, Patrick",
        "Thomas, Oliver",
        "Becker, Jörg"
      ],
      "year": "2016",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Multikonferenz Wirtschaftsinformatik MKWI 2016, Band 1: Technische Universität Ilmenau; 09. - 11. März 2016",
      "publisher": "Universitätsverlag Ilmenau",
      "pages": "1167-1178",
      "peerReviewed": "nein",
      "access": "Open Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://www.db-thueringen.de/servlets/DerivateServlet/Derivate-33064/ilm1-2016100021.pdf",
          "kind": "full-text"
        },
        {
          "label": "URN",
          "url": "https://nbn-resolving.org/urn:nbn:de:gbv:ilm1-2016100021",
          "kind": "external"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://www.db-thueringen.de/servlets/DerivateServlet/Derivate-33064/ilm1-2016100021.pdf",
      "detailPath": "/publications/8802-towards-an-epc-standardization-a-literature-review-on-exchange-formats-for-epc-models",
      "apa7": "Riehle, D. M., Jannaber, S., Karhof, A., Delfmann, P., Thomas, O., & Becker, J. (2016). Towards an EPC Standardization - A Literature Review on Exchange Formats for EPC Models. Multikonferenz Wirtschaftsinformatik MKWI 2016, Band 1: Technische Universität Ilmenau; 09. - 11. März 2016, 1167–1178. https://www.db-thueringen.de/servlets/DerivateServlet/Derivate-33064/ilm1-2016100021.pdf",
      "bibtex": "@inproceedings{Riehle2016Towards,\n\taddress = {Ilmenau},\n\tauthor = {Riehle, Dennis M. and Jannaber, Sven and Karhof, Arne and Delfmann, Patrick and Thomas, Oliver and Becker, J{\\\" o}rg},\n\tbooktitle = {Multikonferenz {Wirtschaftsinformatik} {MKWI} 2016, {Band} 1: Technische {Universit}{\\\" a}t {Ilmenau}; 09. - 11. {M}{\\\" a}rz 2016},\n\tisbn = {978-3-86360-132-4},\n\tyear = {2016},\n\tpages = {1167--1178},\n\torganization = {Universit{\\\" a}tsverlag Ilmenau},\n\ttitle = {Towards an {EPC} {Standardization} - {A} {Literature} {Review} on {Exchange} {Formats} for {EPC} {Models}},\n\turl = {https://www.db-thueringen.de/servlets/DerivateServlet/Derivate-33064/ilm1-2016100021.pdf},\n}"
    },
    {
      "id": 9566,
      "title": "From Legislation to potential Compliance Violations in Business Processes - Simplicity Matters: Research Paper 188",
      "authors": "Steffen Höhenberger, Dennis M. Riehle, Patrick Delfmann",
      "authorNames": [
        "Höhenberger, Steffen",
        "Riehle, Dennis M.",
        "Delfmann, Patrick"
      ],
      "year": "2016",
      "type": "Konferenzpaper",
      "language": "en",
      "venue": "Proceeding of the 24th European Conference on Information Systems, ECIS 2016: Istanbul, Turkey, June 12-15, 2016",
      "publisher": "Association for Information Systems/AIS eLibrary",
      "pages": "keine Angaben-keine Angaben",
      "peerReviewed": "nein",
      "access": "Restricted Access",
      "abstract": null,
      "links": [
        {
          "label": "Full text",
          "url": "https://aisel.aisnet.org/ecis2016_rp/188",
          "kind": "full-text"
        }
      ],
      "doiUrl": null,
      "fullTextUrl": "https://aisel.aisnet.org/ecis2016_rp/188",
      "detailPath": "/publications/9566-from-legislation-to-potential-compliance-violations-in-business-processes-simplicity-matters-research-paper-188",
      "apa7": "Höhenberger, S., Riehle, D. M., & Delfmann, P. (2016). From Legislation to potential Compliance Violations in Business Processes - Simplicity Matters: Research Paper 188. In B. Metin (Ed.), Proceeding of the 24th European Conference on Information Systems, ECIS 2016: Istanbul, Turkey, June 12-15, 2016 (p. keine Angaben-keine Angaben). Association for Information Systems/AIS eLibrary. https://aisel.aisnet.org/ecis2016_rp/188",
      "bibtex": "@inproceedings{Hohenberger2016From,\n\taddress = {Atlanta, GA},\n\tauthor = {H{\\\" o}henberger, Steffen and Riehle, Dennis M. and Delfmann, Patrick},\n\tbooktitle = {Proceeding of the 24th {European} {Conference} on {Information} {Systems}, {ECIS} 2016: Istanbul, {Turkey}, {June} 12-15, 2016},\n\teditor = {Metin, Bilgin},\n\tyear = {2016},\n\tpages = {keine Angaben--keine Angaben},\n\torganization = {Association for Information Systems/AIS eLibrary},\n\ttitle = {From {Legislation} to potential {Compliance} {Violations} in {Business} {Processes} - {Simplicity} {Matters}: Research {Paper} 188},\n\turl = {https://aisel.aisnet.org/ecis2016_rp/188},\n}"
    }
  ]
}
